webpackJsonp([1],{

/***/ "/qWP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2fgd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CRBY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GmRo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GuHI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hun4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/array/from.js
var from = __webpack_require__("c/Tr");
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/is-integer.js
var is_integer = __webpack_require__("RRo+");
var is_integer_default = /*#__PURE__*/__webpack_require__.n(is_integer);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/set.js
var core_js_set = __webpack_require__("lHA8");
var set_default = /*#__PURE__*/__webpack_require__.n(core_js_set);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/vue-resource/dist/vue-resource.esm.js
var vue_resource_esm = __webpack_require__("8+8L");

// CONCATENATED MODULE: ./src/config.js
var CONFIG = {
	LOCALE: "nl-NL",
	CURRENCY: "EUR",
	HOST: "/"
};
// CONCATENATED MODULE: ./src/helpers.js




var Helpers = {
	/**
     * Price formatting helper for any locale and currency combination
     *
     * @param {number} price The price to format
     * @param {number} [digits = 2] Digits after separator to format price with
     *
     * @returns {string} Formatted price taking currency and locale in to account
     */
	toCurrencyString: function toCurrencyString(price) {
		var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

		var formattedPrice = price.toLocaleString(CONFIG.LOCALE, {
			style: "currency",
			currency: CONFIG.CURRENCY,
			minimumFractionDigits: digits,
			maximumFractionDigits: digits
		});

		return formattedPrice;
	},
	isEmptyObject: function isEmptyObject(obj) {
		for (var prop in obj) {
			if (obj.hasOwnProperty(prop)) {
				return false;
			}
		}

		return stringify_default()(obj) === stringify_default()({});
	},
	sortObjectByProperty: function sortObjectByProperty(array, property) {
		return from_default()(array).slice().sort(function (a, b) {
			return a[property] - b[property];
		});
	},
	/**
  * Sort properties of object
  * @param {Object} obj required: Object to sort
  * @param {String} sortedBy [1]: Key to sort object by. First key by default
  * @param {Boolean} sortNumeric false: Whether it should sort numeric. Default = alphabetic
  * @param {Boolean} reverse false: Should output be reversed. Default is not reversed
  * @param {Boolean} returnObject true: should return object; if false array is returned
  *
  * @returns {*} based on returnObject
  */
	sortProperties: function sortProperties(obj) {
		var sortedBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
		var sortNumeric = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
		var reverse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
		var returnObject = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

		var reversed = reverse ? -1 : 1;
		var sortable = [];
		var newObject = {};

		for (var key in obj) {
			if (obj.hasOwnProperty(key)) {
				sortable.push([key, obj[key]]);
			}
		}
		if (sortNumeric) {
			sortable.sort(function (a, b) {
				return reversed * (a[1][sortedBy] - b[1][sortedBy]);
			});
		} else {
			sortable.sort(function (a, b) {
				var x = a[1][sortedBy].toLowerCase();
				var y = b[1][sortedBy].toLowerCase();
				return x < y ? reversed * -1 : x > y ? reversed : 0;
			});
		}

		for (var i = 0; i < sortable.length; i++) {
			var _key = sortable[i][0];
			var value = sortable[i][1];

			newObject[_key] = value;
		}

		return returnObject ? newObject : sortable;
	},
	optimizedResize: function optimizedResize(theCallback) {
		var callbacks = [];
		var running = false;

		// fired on resize event
		function resize() {
			if (!running) {
				running = true;
				setTimeout(runCallbacks, 166);
			}
		}

		// run the actual callbacks
		function runCallbacks() {
			callbacks.forEach(function (callback) {
				callback();
			});

			running = false;
		}

		// adds callback to loop
		function addCallback(callback) {
			if (callback) {
				callbacks.push(callback);
			}
		}

		(function () {
			if (!callbacks.length) {
				window.addEventListener("resize", resize);
			}
			addCallback(theCallback);
		})();
	}
};

Array.prototype.first = function (condition) {
	var first = this[0];

	if (typeof condition === "function") {
		return this.find(condition) || first;
	}

	return first;
};

Array.prototype.last = function (condition) {
	var last = this[this.length - 1];

	if (typeof condition === "function") {
		return this.find(condition) || last;
	}

	return last;
};

var Helper = Helpers;
// CONCATENATED MODULE: ./src/helpers/specification/findSpecificationById.js
/**
 * Resolve the specification a public `?s=` link refers to.
 *
 * Public links carry the *external* ChrisRussellNG specification id, while the
 * configurator API also exposes the internal OfferSpecification id as `id`.
 * Both are small integers, so matching on `id` can silently resolve to a
 * different variant than the link intended. Match on the external id first and
 * only fall back to `id` for specifications that have no external mapping.
 *
 * @param {Specification[]} specifications
 * @param {number} specificationId
 * @returns {Specification|undefined}
 */
var findSpecificationById = function findSpecificationById(specifications, specificationId) {
  var byExternalId = specifications.find(function (s) {
    return s.externalId === specificationId;
  });

  if (byExternalId) {
    return byExternalId;
  }

  return specifications.find(function (s) {
    return !s.externalId && s.id === specificationId;
  });
};
// CONCATENATED MODULE: ./src/helpers/specification/findProductFront.js


/**
 * @param {ProductFront[]} productData
 * @param {number} specificationId
 * @returns {ProductFront}
 */
var findProductFront_findProductFront = function findProductFront(productData, specificationId) {
  return productData.find(function (p) {
    return findSpecificationById(p.specifications, specificationId);
  });
};
// CONCATENATED MODULE: ./src/helpers/specification/buildSpecificationConfiguration.js

/**
 * @param {ProductFront} productFront
 * @param {Specification} specification
 * @returns {SpecificationConfiguration}
 */
var buildSpecificationConfiguration_buildSpecificationConfiguration = function buildSpecificationConfiguration(productFront, specification) {
	var configuration = defaultConfigurationFor(productFront.id, specification);
	var optionList = specification.productOptionGroups.flatMap(function (optionGroup) {
		return optionGroup.productOptions;
	});

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = get_iterator_default()(specification.productOptionGroups), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var optionGroup = _step.value;

			var optionToChoose = findBestChoiceOption(optionGroup.productOptions);

			if (!optionToChoose) {
				optionToChoose = findCheapestOption(optionGroup.productOptions);
			}

			if (optionToChoose.requiredProductOptionIds.length) {
				var requiredOption = findRequiredOption(optionList, optionToChoose);
				var requiredOptionGroup = findRequiredOptionGroup(specification.productOptionGroups, requiredOption);
				var indexOfOptionGroup = specification.productOptionGroups.indexOf(requiredOptionGroup);

				configuration.productOptionIds.splice(indexOfOptionGroup, 1, requiredOption.id);
			}

			configuration.productOptionIds.push(optionToChoose.id);
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return configuration;
};

/**
 * @param {ProductOption[]} options
 * @returns {ProductOption}
 */
var findBestChoiceOption = function findBestChoiceOption(options) {
	return options.find(function (o) {
		return o.isBestChoice;
	});
};

/**
 * @param {ProductOption[]} options
 * @returns {ProductOption}
 */
var findCheapestOption = function findCheapestOption(options) {
	return options.sort(function (a, b) {
		return a.amountPrices[0].price - b.amountPrices[0].price;
	}).first();
};

/**
 * @param {ProductOption[]} options
 * @param {ProductOption} optionToChoose
 * @returns {ProductOption}
 */
var findRequiredOption = function findRequiredOption(options, optionToChoose) {
	return options.find(function (o) {
		return o.id === optionToChoose.requiredProductOptionIds.first();
	});
};

/**
 * @param {ProductOptionGroup[]} optionGroups
 * @param {ProductOption} requiredOption
 * @returns {ProductOptionGroup}
 */
var findRequiredOptionGroup = function findRequiredOptionGroup(optionGroups, requiredOption) {
	return optionGroups.find(function (og) {
		return og.productOptions.find(function (o) {
			return o.id === requiredOption.id;
		});
	});
};

/**
 * @param {number} productFrontId
 * @param {Specification} specification
 * @returns {SpecificationConfiguration}
 */
var defaultConfigurationFor = function defaultConfigurationFor(productFrontId, specification) {
	return {
		id: 0,
		specificationId: specification.id,
		productFrontId: productFrontId,
		productOptionIds: [],
		productGroupIdsForcedByEditor: [],
		amount: specification.amount ? specification.amount : specification.minAmount,
		pages: specification.minPageCount,
		// The specification sizes include bleed, the configured size is without bleed
		widthInMm: specification.minWidthInMm - 2 * (specification.bleed || 0),
		heightInMm: specification.minHeightInMm - 2 * (specification.bleed || 0),
		previewUrl: "",
		hasOffsetPrintingAmount: false
	};
};
// CONCATENATED MODULE: ./src/helpers/updatePriceOnProductPage.js


/**
 * @param {Price} price
 * @param {boolean} isRushPrice
 */
var updatePriceOnProductPage = function updatePriceOnProductPage(price, isRushPrice) {
	var priceHolder = document.querySelector(".product-summary .price-holder");

	if (!priceHolder) {
		updatePriceOnProductPage_updateSdwProductPrice(isRushPrice ? price.rushPriceWithTax : price.PriceWithTax);
		return;
	}

	if (isRushPrice) {
		priceHolder.outerHTML = updatePriceOnProductPage_renderPriceHolder({
			withTax: price.rushPriceWithTax || null,
			withoutTax: price.rushPriceWithoutTax
		});
	} else {
		priceHolder.outerHTML = updatePriceOnProductPage_renderPriceHolder({
			withTax: price.PriceWithTax || null,
			withoutTax: price.PriceWithoutTax
		});
	}
};

/**
 * @param {number|null} withTax
 * @param {number} withoutTax
 * @returns {string}
 */
var updatePriceOnProductPage_renderPriceHolder = function renderPriceHolder(_ref) {
	var withTax = _ref.withTax,
	    withoutTax = _ref.withoutTax;

	if (!withTax) {
		return "<span class=\"price-holder mt-s show\">\n\t\t\t\t<meta content=\"" + Helper.toCurrencyString(withoutTax) + "\" itemProp=\"price\">\n\t\t\t\t<span class=\"price mr-s\">" + Helper.toCurrencyString(withoutTax) + "</span>\n\t\t\t\t<span class=\"text--small\">excl. btw</span>\n\t\t\t</span>";
	}

	return "<span class=\"price-holder mt-s show\">\n\t\t\t<meta content=\"" + Helper.toCurrencyString(withTax) + "\" itemProp=\"price\">\n\t\t\t<span class=\"price mr-s\">" + Helper.toCurrencyString(withTax) + "</span>\n\t\t\t<span class=\"text--small\">incl. btw</span>\n\t\t\t<span class=\"text--small text--bold show mt-xs\">" + Helper.toCurrencyString(withoutTax) + " excl. btw</span>\n\t\t</span>";
};

/**
 * SDW renders a "from" price in .product-price instead of the DWN .price-holder.
 * It is kept on the element so it can be restored when there is no price.
 * @param {number|null|undefined} withTax
 */
var updatePriceOnProductPage_updateSdwProductPrice = function updateSdwProductPrice(withTax) {
	var productPrice = document.querySelector(".product-price");

	if (!productPrice) {
		return;
	}

	if (productPrice.dataset.fromPriceHtml === undefined) {
		productPrice.dataset.fromPriceHtml = productPrice.innerHTML;
	}

	productPrice.innerHTML = withTax ? "<span class=\"product-price__value\">" + Helper.toCurrencyString(withTax) + "</span>" : productPrice.dataset.fromPriceHtml;
};

/**
 * Empties the server-rendered price range so it cannot be mistaken for the
 * specification price while that price is still being calculated.
 */
var clearPriceOnProductPage = function clearPriceOnProductPage() {
	var priceHolder = document.querySelector(".product-summary .price-holder");

	if (!priceHolder) {
		return;
	}

	priceHolder.innerHTML = "";
};
// CONCATENATED MODULE: ./src/helpers/specification/preselectConfiguratorItems.js



var preselectConfiguratorItems__this = this;







/**
 * @param {number[]} frontIds
 * @param {ProductFront[]} productData
 */
var preselectConfiguratorItems = function () {
	var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(frontIds, productData) {
		var productFront, specification, preselectedQuantity, configuration, unwatch;
		return regenerator_default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						if (store.state.selectedProduct) {
							_context.next = 5;
							break;
						}

						productFront = findProductFront_findProductFront(productData, store.state.baseProps.specificationId);

						if (productFront) {
							_context.next = 4;
							break;
						}

						return _context.abrupt("return");

					case 4:

						store.commit("SET_SELECTED_PRODUCT", productFront);

					case 5:
						specification = findSpecificationById(store.state.selectedProduct.specifications, store.state.baseProps.specificationId);

						if (specification) {
							_context.next = 8;
							break;
						}

						return _context.abrupt("return");

					case 8:
						preselectedQuantity = store.state.baseProps.preselectedQuantity;

						if (preselectedQuantity) {
							specification.amount = preselectedQuantity;
						}

						clearPriceOnProductPage();

						store.commit("SET_CONFIGURATOR_TYPE", "configuration");

						configuration = buildSpecificationConfiguration_buildSpecificationConfiguration(store.state.selectedProduct, specification);


						store.state.baseProps.isConfiguration = true;

						store.commit("SET_EXISTING_CONFIGURATION_DATA", configuration);
						store.commit("SET_EXISTING_CONFIGURATION_SELECTED");

						if (preselectConfiguratorItems_hasOnlyOffsetPrices(specification)) {
							setOffsetPrice();
						}

						unwatch = store.watch(function (state) {
							return state.configurator.steps.all;
						}, function (steps) {
							var firstOptionStep = steps.find(function (step) {
								return step.groupId;
							});
							if (firstOptionStep) {
								store.commit("SET_STEP_ACTIVE", firstOptionStep);
								unwatch();
							}
						}, { immediate: true });


						store.watch(function (_, getters) {
							return getters.getPrice;
						}, function (price) {
							var isRushPrice = store.getters.getOrderLine.isRush;
							updatePriceOnProductPage(price, isRushPrice);
						});

					case 19:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, preselectConfiguratorItems__this);
	}));

	return function preselectConfiguratorItems(_x, _x2) {
		return _ref.apply(this, arguments);
	};
}();

var preselectConfiguratorItems_hasOnlyOffsetPrices = function hasOnlyOffsetPrices(specification) {
	var amountList = store.state.selectedProduct.amountList;
	return (!amountList || !amountList.length || amountList === "0") && specification.offsetPricings && specification.offsetPricings.length > 0;
};

var setOffsetPrice = function () {
	var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
		var offsetPrices;
		return regenerator_default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.next = 2;
						return store.dispatch("_getOffsetPriceTable");

					case 2:
						offsetPrices = store.getters.getOffsetPriceTable.sort(function (a, b) {
							return a.Amount - b.Amount;
						});


						store.commit("SET_OFFSET_SELECTED", true);
						store.commit("SET_ORDERLINE_AMOUNT", offsetPrices[0].Amount);
						store.commit("SET_CONFIGURATION_OFFSET_PRICE", offsetPrices[0].Amount);

					case 6:
					case "end":
						return _context2.stop();
				}
			}
		}, _callee2, preselectConfiguratorItems__this);
	}));

	return function setOffsetPrice() {
		return _ref2.apply(this, arguments);
	};
}();
// CONCATENATED MODULE: ./src/helpers/addPercentage.js
/**
 * @param {number} base
 * @param {number} percentage
 * @returns {number}
 */
var addPercentage = function addPercentage(base, percentage) {
  return base * (1 + percentage);
};
// CONCATENATED MODULE: ./src/helpers/findDeliveryTimeForAmount.js
/**
 * @param {DeliveryTime[]} deliveryTimes
 * @param {number} amount
 * @param {boolean} isRush
 * @param {boolean} isOffset
 * */
var findDeliveryTimeForAmount = function findDeliveryTimeForAmount(deliveryTimes, amount, isRush, isOffset) {
  return deliveryTimes.filter(function (dt) {
    return dt.productionSpeed === (isRush ? "rush" : "standard") && dt.productionType === (isOffset ? "offset" : "standard") && dt.fromQuantity <= (!amount ? 1 : amount);
  }).sort(function (a, b) {
    return b.fromQuantity - a.fromQuantity;
  })[0];
};
// CONCATENATED MODULE: ./src/store/index.js










/* eslint-disable */










vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);
vue_esm["a" /* default */].use(vue_resource_esm["a" /* default */]);

var EventBus = new vue_esm["a" /* default */]();

// Option groups/options tagged Hidden are never choosable by the customer (unlike Disabled,
// which is already filtered out server-side before reaching the configurator). They can still
// be selected behind the scenes (e.g. a default forced elsewhere), so they stay in the catalog
// data and are filtered out purely on the frontend, the same way as "locked from editor" groups.
var getHiddenOptionGroupIdsFromState = function getHiddenOptionGroupIdsFromState(state) {
	return (state.selectedFormat && state.selectedFormat.productOptionGroups || []).filter(function (g) {
		return g.isHidden;
	}).map(function (g) {
		return g.id;
	});
};

var getHiddenOptionIdsFromState = function getHiddenOptionIdsFromState(state) {
	return (state.selectedFormat && state.selectedFormat.productOptionGroups || []).flatMap(function (g) {
		return g.productOptions || [];
	}).filter(function (o) {
		return o.isHidden;
	}).map(function (o) {
		return o.id;
	});
};

// Options/groups scoped (via OnlyForCreationSources) to creation sources that don't include this
// upload's actual origin aren't valid for it - e.g. something scoped to only the configurator doesn't
// apply to an upload that came from the online editor. The backend lists those ids here so they get
// hidden the same way as Hidden-tagged options.
var getNonConfiguratorOptionIdsFromState = function getNonConfiguratorOptionIdsFromState(state) {
	return state.config.configurationSettings.nonConfiguratorProductOptionIds || [];
};

var store = new vuex_esm["a" /* default */].Store({
	state: {
		baseProps: {},
		productData: [],
		viewPort: {
			width: 0,
			s: false,
			ms: false,
			m: false,
			l: false,
			xl: false
		},
		config: {
			price: {
				PriceWithTax: null,
				PriceWithoutTax: null
			},
			extra: {},
			priceTable: [],
			offsetPriceTable: [],
			configurationSettings: {
				productGroupIdsForcedByEditor: [],
				fileIsUploaded: false,
				nonConfiguratorProductOptionIds: []
			},
			currentConfigSupportsOffset: false,
			printSidesCount: null
		},
		configurator: {
			steps: {
				current: {
					data: {},
					index: 0
				},
				all: [],
				available: {
					next: false,
					prev: false
				},
				first: function first() {
					return this.all.first();
				},
				last: function last() {
					return this.all.last();
				},

				general: {
					configuratorDataValid: false,
					optionsRenderable: false,
					existingConfigurationAdded: false,
					existingConfigurationValidatedSteps: false,
					existingConfigurationIsFinalized: false
				}
			},
			changed: false,
			configurationChanged: false,
			boundaries: null
		},
		configuratorData: {
			hasMultipleProducts: false,
			hasFormatMatches: false,
			hasFormatSuggestions: false,
			canSetConfigurationPrice: true
		},
		customPageCount: null,
		alteredPageCount: null,
		orderLine: {
			amount: 0,
			isRush: false,
			isOffset: false,
			offsetSkuId: null
		},
		order: {
			status: false,
			message: "",
			thumbnailUrl: null
		},
		file: {
			pageCount: null,
			content: null,
			cover: null,
			contentIsUploaded: false,
			coverIsUploaded: false,
			uploadsComplete: false,
			uploadSessionGuid: null,
			uploadSizes: {
				content: null,
				cover: null
			},
			customErrorMessages: {
				content: null,
				cover: null
			},
			isCustomSize: false,
			matchedCustomSizeFormat: null
		},
		customSize: {
			width: null,
			height: null
		},
		customSizeValid: false,
		isLoaded: false,
		selectedProduct: null,
		selectedFormat: { id: null },
		formatSuggestions: [],
		formatMatches: [],
		selectedOptions: [],
		selectedGroups: [],
		printSidesAvailability: {
			single: false,
			double: false,
			set: false
		},
		coverPrintSidesAvailability: {
			single: false,
			double: false,
			set: false
		},
		requiredOptionIds: {},
		requiredOptionsWithinGroups: {},
		availableOptions: [],
		unavailableOptions: [],
		excludedByFilters: [],
		type: "initial",
		throttle: {
			amount: null
		},
		loading: {
			price: false
		},
		quotationResponse: null,
		name: "",
		dictionary: {
			optionCategory: {
				0: "default",
				1: "paper",
				2: "print",
				3: "finish",
				4: "material"
			},
			chunkType: {
				0: "cover",
				1: "content"
			},
			orientation: {
				0: "both",
				1: "portrait",
				2: "landscape"
			}
		},
		svg: {
			editable: "<svg class=\"orientation__svg\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" viewBox=\"0 0 25 25\" enable-background=\"new 0 0 1000 1000\"><path d=\"M23.25 2.893L21.128.771c-.943-.944-2.592-.944-3.536 0L2.248 16.118l-.004.003-.003.004-.248.248a.499.499 0 0 0-.133.239L.343 23.077a.5.5 0 0 0 .601.601l6.466-1.517a.499.499 0 0 0 .239-.133l.248-.247.004-.003.003-.004L23.25 6.428a2.505 2.505 0 0 0 0-3.535zm-2.487 4.608L16.53 3.247l.708-.709 4.244 4.243-.719.72zM7.546 20.717l-4.242-4.242L15.823 3.954l4.233 4.254-12.51 12.509zm-4.824-3.409l3.991 3.99L1.5 22.521l1.222-5.213zm19.82-11.587l-.354.354-4.244-4.244.354-.354c.566-.566 1.555-.567 2.122 0L22.542 3.6a1.503 1.503 0 0 1 0 2.121z\"/></svg>",
			locked: "<svg class=\"orientation__svg\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" viewBox=\"0 0 1000 1000\" enable-background=\"new 0 0 1000 1000\"><path d=\"M321.8,455.5h356.4V321.8c0-49.2-17.4-91.2-52.2-126c-34.8-34.8-76.8-52.2-126-52.2c-49.2,0-91.2,17.4-126,52.2c-34.8,34.8-52.2,76.8-52.2,126L321.8,455.5L321.8,455.5z M900.9,522.3v400.9c0,18.6-6.5,34.3-19.5,47.3c-13,13-28.8,19.5-47.3,19.5H165.9c-18.6,0-34.3-6.5-47.3-19.5c-13-13-19.5-28.8-19.5-47.3V522.3c0-18.6,6.5-34.3,19.5-47.3c13-13,28.8-19.5,47.3-19.5h22.3V321.8c0-85.4,30.6-158.7,91.9-219.9C341.3,40.7,414.7,10,500,10c85.3,0,158.7,30.6,219.9,91.9c61.3,61.3,91.9,134.6,91.9,219.9v133.6h22.3c18.6,0,34.3,6.5,47.3,19.5C894.4,488,900.9,503.7,900.9,522.3L900.9,522.3z\"/></svg>",
			orientation: {
				landscape: "<svg class=\"orientation__svg\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\"><defs><style>.cls-1{fill:#7DC8FF;}</style></defs><rect class=\"cls-1\" x=\"13.95\" y=\"83.75\" width=\"472.1\" height=\"333.8\"/></svg>",
				portrait: "<svg class=\"orientation__svg\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\"><defs><style>.cls-1{fill:#7DC8FF;}.cls-2{fill:#7DC8FF;}</style></defs><rect class=\"cls-1\" x=\"167.1\" y=\"299.75\" width=\"165.8\" height=\"117.2\"/><rect class=\"cls-2\" x=\"83.1\" y=\"14.6\" width=\"333.8\" height=\"472.1\"/></svg>",
				both: "<svg class=\"orientation__svg\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\"><defs><style>.cls-3{fill:#E73467;stroke:#E73467;stroke-width:60;stroke-linejoin:round;stroke-miterlimit:10;}.cls-4{fill:none;stroke:#E73467;stroke-width:70;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}</style></defs><polygon class=\"cls-3\" points=\"229.6,84.3 229.6,134.5 186.1,109.4 142.6,84.3 186.1,59.2 229.6,34.1\"/><polygon class=\"cls-3\" points=\"270.4,415.7 270.4,365.5 313.9,390.6 357.4,415.7 313.9,440.8 270.4,465.9\"/><path class=\"cls-4\" d=\"M85.5,229.6c-0.8,6.7-1.2,13.5-1.2,20.4c0,91.5,74.2,165.7,165.7,165.7c6.9,0,13.7-0.4,20.4-1.2\"/><path class=\"cls-4\" d=\"M414.5,270.4c0.8-6.7,1.2-13.5,1.2-20.4c0-91.5-74.2-165.7-165.7-165.7c-6.9,0-13.7,0.4-20.4,1.2\"/></svg>"
			},
			icon: {
				inkDrops: "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"svg svg--ink-drops\" viewBox=\"0 0 632.137 632.137\" xml:space=\"preserve\"><g><g><path d=\"M225.408,20.392c-6.525,0-12.653,3.13-16.486,8.401C200.795,39.967,10.063,303.782,10.063,416.792    c0,118.74,96.605,215.345,215.344,215.345c118.75,0,215.365-96.604,215.365-215.345c0-113.01-190.742-376.825-198.857-387.999    C238.071,23.521,231.943,20.392,225.408,20.392z\"/><path d=\"M526.284,8.401C522.44,3.13,516.303,0,509.777,0s-12.652,3.13-16.486,8.401c-15.997,22.013-95.789,134.584-95.789,189.203c0,61.909,50.356,112.275,112.275,112.275c61.909,0,112.296-50.367,112.296-112.275C622.063,142.985,542.271,30.414,526.284,8.401\"/></g></g></svg>",
				leaf: "<svg class=\"svg svg--leaf\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" stroke-width=\"2\"  fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5 21c.5 -4.5 2.5 -8 7 -10\" /> <path d=\"M9 18c6.218 0 10.5 -3.288 11 -12v-2h-4.014c-9 0 -11.986 4 -12 9c0 1 0 3 2 5h3z\" /></svg>"
			}
		}
	},
	getters: {
		checkData: function checkData(state) {
			return {
				hasSelectedProduct: state.selectedProduct != null && state.selectedProduct.hasOwnProperty("specifications") && state.selectedProduct.id != null,
				hasSelectedFormat: state.selectedFormat.id != null,
				hasSelectedOptions: state.selectedOptions.length > 0
			};
		},
		getOrder: function getOrder(state) {
			return state.order;
		},
		getFile: function getFile(state) {
			return state.file;
		},
		isConfiguratorDataValid: function isConfiguratorDataValid(state) {
			return state.configurator.steps.general.configuratorDataValid;
		},
		isOptionsRenderable: function isOptionsRenderable(state) {
			return state.configurator.steps.general.optionsRenderable;
		},
		isExistingConfigurationAdded: function isExistingConfigurationAdded(state) {
			return state.configurator.steps.general.existingConfigurationAdded;
		},
		getLoader: function getLoader(state) {
			return state.loading;
		},
		getConfiguratorData: function getConfiguratorData(state) {
			return state.configuratorData;
		},
		getConfiguratorChanged: function getConfiguratorChanged(state) {
			return state.configurator.configurationChanged;
		},
		getProductData: function getProductData(state) {
			return state.productData;
		},
		getAvailableFormats: function getAvailableFormats(state) {
			if (store.getters.checkData.hasSelectedProduct) {
				var getDimensions = function getDimensions(specification) {
					return specification.productSize.widthInMm * specification.productSize.heightInMm;
				};

				return state.selectedProduct.specifications.sort(function (a, b) {
					var isCustom = [a, b].some(function (s) {
						return s.isCustomSize;
					});

					if (isCustom) {
						return a.isCustomSize ? 1 : -1;
					}

					var _map = [a, b].map(function (s) {
						return s.productSize.name || "";
					}),
					    _map2 = slicedToArray_default()(_map, 2),
					    aName = _map2[0],
					    bName = _map2[1];

					var _map3 = [a, b].map(function (s) {
						return getDimensions(s);
					}),
					    _map4 = slicedToArray_default()(_map3, 2),
					    aSize = _map4[0],
					    bSize = _map4[1];

					if ([aName, bName].some(function (name) {
						return (/^[A-z] ?[0-9]/i.test(name)
						);
					})) {
						if (aName[0] > bName[0]) {
							return -1;
						}

						if (aName[0] < bName[0]) {
							return 1;
						}
					}

					if (aSize > bSize) {
						return 1;
					}

					if (aSize < bSize) {
						return -1;
					}

					return 0;
				});
			}
		},
		getAvailableOptions: function getAvailableOptions(state) {
			return state.availableOptions;
		},
		getUnavailableOptions: function getUnavailableOptions(state) {
			return state.unavailableOptions || [];
		},
		getExcludedByFilters: function getExcludedByFilters(state) {
			return state.excludedByFilters || [];
		},
		getAllUnavailableOptions: function getAllUnavailableOptions(state) {
			// Combine unavailable options (from requirements) with excluded options (from filters)
			return [].concat(toConsumableArray_default()(new set_default.a([].concat(toConsumableArray_default()(state.unavailableOptions || []), toConsumableArray_default()(state.excludedByFilters || []), toConsumableArray_default()(getHiddenOptionIdsFromState(state)), toConsumableArray_default()(getNonConfiguratorOptionIdsFromState(state))))));
		},
		getSelectedProduct: function getSelectedProduct(state) {
			return state.selectedProduct;
		},
		getSelectedFormat: function getSelectedFormat(state) {
			return state.selectedFormat;
		},

		bleedSize: function bleedSize(state) {
			return function (size) {
				/**
     * @returns Functions return trimmed and untrimmed bleedSize from size input
     * @param {object} size to calculate bleed with
     */
				var axisBleed = state.selectedFormat.bleed * 2;

				return {
					untrimmed: function untrimmed() {
						return {
							height: size.height + axisBleed,
							width: size.width + axisBleed
						};
					},
					trimmed: function trimmed() {
						return {
							height: size.height - axisBleed,
							width: size.width - axisBleed
						};
					}
				};
			};
		},
		getSelectedFormatDescription: function getSelectedFormatDescription(state, getters) {
			/**
    * @returns boolean if properties exist
    * @param {object} size to check properties of
    */
			var size = getters.getProductSize;

			if (size.width === 0 && size.height === 0) {
				if (state.selectedFormat.productSize.description) {
					return state.selectedFormat.productSize.description;
				} else if (state.selectedFormat.productSize.fullName) {
					return state.selectedFormat.productSize.fullName;
				} else {
					return null;
				}
			}

			var bleedSize = getters.bleedSize(size);
			var description = "";

			var trimmedSizeDescription = function trimmedSizeDescription(_ref) {
				var width = _ref.width,
				    height = _ref.height;

				return "<strong>Eindformaat (excl. afloop): </strong>\n\t\t\t\t\t" + width + "mm breed x " + height + "mm hoog.";
			};

			var pdfSizeDescription = function pdfSizeDescription(_ref2) {
				var width = _ref2.width,
				    height = _ref2.height;

				return "<strong>PDF-formaat (incl. afloop): </strong>\n\t\t\t\t\t" + width + "mm breed x " + height + "mm hoog.";
			};

			if (state.file.uploadsComplete) {
				if (state.selectedFormat.bleed) {
					description += trimmedSizeDescription(bleedSize.trimmed());
					description += "<br/>";
				}

				description += pdfSizeDescription(size);
			} else {
				description += trimmedSizeDescription(size);

				if (state.selectedFormat.bleed) {
					description += "<br/>";
					description += pdfSizeDescription(bleedSize.untrimmed());
				}
			}

			return description;
		},
		getSelectedOptions: function getSelectedOptions(state) {
			return Helper.sortProperties(state.selectedOptions, "index", true, false, true);
		},
		getUnsortedSelectedOptions: function getUnsortedSelectedOptions(state) {
			return state.selectedOptions;
		},
		showOrientation: function showOrientation(state) {
			return store.getters.getUniqueOrientations.includes(0) || store.getters.getUniqueOrientations.length > 1;
		},
		getUniqueOrientations: function getUniqueOrientations(state) {
			var result = [];
			if (store.getters.getConfiguratorLoaded) {
				store.getters.getAvailableFormats.map(function (f) {
					if (!result.includes(f.productSize.orientation)) {
						result.push(f.productSize.orientation);
					}
				});
			}
			return result;
		},
		getGroupIndexedSelectedOptions: function getGroupIndexedSelectedOptions() {
			var selectedOptions = store.getters.getSelectedOptions;
			var groupIndexedSelectedOptions = {};

			for (var option in selectedOptions) {
				groupIndexedSelectedOptions[selectedOptions[option].parentGroupId] = selectedOptions[option];
			}

			return groupIndexedSelectedOptions;
		},
		getSelectedGroups: function getSelectedGroups(state) {
			return Helper.sortProperties(state.selectedGroups, "index", true, false, true);
		},
		getUnsortedSelectedGroups: function getUnsortedSelectedGroups(state) {
			return state.selectedGroups;
		},
		getSelectedOptionIds: function getSelectedOptionIds() {
			var ids = [];

			for (var option in store.getters.getSelectedOptions) {
				ids.push(store.getters.getSelectedOptions[option].id);
			}

			return ids;
		},
		getFormatSuggestions: function getFormatSuggestions(state) {
			var formatSuggestions = state.formatSuggestions.reduce(function (suggestions, suggestion) {
				var formatSuggestionData = state.selectedProduct.specifications.find(function (f) {
					return f.id === suggestion.specificationId;
				});

				for (var attr in suggestion) {
					formatSuggestionData[attr] = suggestion[attr];
				}

				if (!formatSuggestionData.isMatch) {
					// check if it is a true suggestion instead of a match
					suggestions.push(formatSuggestionData);
				}

				return suggestions;
			}, []);

			return formatSuggestions;
		},
		getFormatMatches: function getFormatMatches(state) {
			return state.formatMatches.sort(function (a, b) {
				return a.id - b.id;
			});
		},
		getCustomSize: function getCustomSize(state) {
			return state.customSize;
		},
		isCustomSize: function isCustomSize(state) {
			return state.file.isCustomSize;
		},
		getCustomSizeValid: function getCustomSizeValid(state) {
			return state.customSizeValid;
		},
		getPageCount: function getPageCount(state) {
			return state.alteredPageCount || state.file.pageCount || state.customPageCount;
		},
		getPrintSidesCount: function getPrintSidesCount(state) {
			return state.config.printSidesCount;
		},
		getAllPageCounts: function getAllPageCounts(state) {
			return {
				custom: state.customPageCount,
				file: state.file.pageCount,
				altered: state.alteredPageCount
			};
		},
		getPrintSidesAvailability: function getPrintSidesAvailability(state) {
			return state.printSidesAvailability;
		},
		getCoverPrintSidesAvailability: function getCoverPrintSidesAvailability(state) {
			return state.coverPrintSidesAvailability;
		},
		getDictionary: function getDictionary(state) {
			return state.dictionary;
		},
		getSvg: function getSvg(state) {
			return state.svg;
		},
		isPrintSidesCountChoice: function isPrintSidesCountChoice(state) {
			if (store.getters.checkData.hasSelectedFormat) {
				return !state.baseProps.hasSeparateCover && state.selectedFormat.minPageCount === 1 && state.selectedFormat.maxPageCount === 2 && (state.selectedFormat.pageIncrement === 1 || state.selectedFormat.pageIncrement === 0);
			}
		},
		currentConfigSupportsOffset: function currentConfigSupportsOffset(state) {
			return state.config.currentConfigSupportsOffset;
		},
		hasConfiguratorPageCountOptions: function hasConfiguratorPageCountOptions(state) {
			// If the offer has any option configured with a fixed page count (CONFIGURATOR_PAGE_COUNT),
			// the page count is driven by the selected option instead of the page count slider.
			if (!state.selectedFormat || !state.selectedFormat.productOptionGroups) {
				return false;
			}

			return state.selectedFormat.productOptionGroups.some(function (group) {
				return group.productOptions.some(function (option) {
					return option.configuratorPageCount !== null && option.configuratorPageCount !== undefined;
				});
			});
		},
		validatePageCount: function validatePageCount(state) {
			if (store.getters.checkData.hasSelectedFormat) {
				var pages = state.customPageCount;
				var min = state.selectedFormat.minPageCount;
				var max = state.selectedFormat.maxPageCount;
				var step = state.selectedFormat.pageIncrement;

				return !(pages < min || pages > max || pages % step !== 0);
			}
		},
		getCurrentStep: function getCurrentStep(state) {
			return state.configurator.steps.current;
		},
		getAllSteps: function getAllSteps(state) {
			return state.configurator.steps.all;
		},
		getStepsAvailability: function getStepsAvailability(state) {
			return state.configurator.steps.available;
		},
		getConfiguratorType: function getConfiguratorType(state) {
			return {
				isInitial: state.type === "initial",
				isUploader: state.type === "upload",
				isCalculate: state.type === "calculate",
				isConfiguration: state.type === "configuration" || state.baseProps.configId !== "null"
			};
		},
		getConfiguratorLoaded: function getConfiguratorLoaded(state) {
			return state.isLoaded;
		},
		getUploaderPosition: function getUploaderPosition(state) {
			var type = store.getters.getConfiguratorType;

			return {
				before: !type.isConfiguration && type.isUploader,
				after: !type.isConfiguration && (type.isCalculate || type.isInitial) && store.getters.isConfiguratorDataValid
			};
		},
		getUploadHasError: function getUploadHasError(state) {
			return state.file.customErrorMessages.content || state.file.customErrorMessages.cover;
		},
		getConfiguratorTypeString: function getConfiguratorTypeString(state) {
			return state.type;
		},
		getPrice: function getPrice(state) {
			return state.config.price;
		},
		getPriceExtra: function getPriceExtra(state) {
			return state.config.extra;
		},
		getPriceTable: function getPriceTable(state) {
			return state.config.priceTable.filter(function (a) {
				return a.amount >= state.selectedFormat.minAmount;
			}).sort(function (a, b) {
				return a.amount - b.amount;
			});
		},
		getOffsetPriceTable: function getOffsetPriceTable(state) {
			return state.config.offsetPriceTable.filter(function (a) {
				return a.Amount > 0;
			}).sort(function (a, b) {
				return a.Amount - b.Amount;
			});
		},
		isOffset: function isOffset(state) {
			return state.orderLine.isOffset;
		},
		isOffTheShelf: function isOffTheShelf(state) {
			if (!state.selectedProduct) {
				return false;
			}

			if (state.selectedProduct.selectedFormat) {
				return state.selectedProduct.selectedFormat.isOffTheShelf;
			}

			return state.selectedProduct.specifications.some(function (s) {
				return s.isOffTheShelf;
			});
		},
		isEditorProject: function isEditorProject(state) {
			return state.baseProps.isEditorProject;
		},
		isBookProduct: function isBookProduct(state) {
			// overwrite for booklike (losbladig) product. All booklike products need this check. This one explicitly because product has no cover
			var isLooseLeaf = store.getters.checkData.hasSelectedProduct ? state.selectedProduct.name.includes("Losbladig") : false;

			return state.baseProps.hasSeparateCover || isLooseLeaf;
		},
		hasSeparateCover: function hasSeparateCover(state) {
			return state.baseProps.hasSeparateCover;
		},

		// Hybrid off-the-shelf product: the content is delivered off-the-shelf, so the single uploaded
		// file is the cover. It's posted as the content upload; the PDF API validates and stores it as cover.
		onlyCoverRequired: function onlyCoverRequired(state) {
			return !!state.selectedFormat.onlyCoverRequired;
		},
		hasDigitalAvailable: function hasDigitalAvailable() {
			if (store.getters.checkData.hasSelectedFormat) {
				return store.getters.getAmountData.amountList.length !== 1 && store.getters.getAmountData.amountList[0] !== 0;
			}
		},
		hasOffsetAvailable: function hasOffsetAvailable(state) {
			if (store.getters.checkData.hasSelectedFormat) {
				return state.baseProps.hasOffsetAvailable;
			}
		},
		getAmountData: function getAmountData(state) {
			var amountData = {
				customAmountAllowed: false,
				amountList: []
			};
			if (store.getters.checkData.hasSelectedFormat) {
				amountData.customAmountAllowed = state.selectedProduct.isCustomAmountAllowed;

				state.selectedProduct.amountList.split(",").forEach(function (a) {
					amountData.amountList.push(parseInt(a));
				});
				amountData.minAmount = state.selectedFormat.minAmount;
				amountData.maxAmount = state.selectedFormat.maxAmount;
			}
			return amountData;
		},
		getConfigurationName: function getConfigurationName(state) {
			return state.name;
		},
		getOrderLine: function getOrderLine(state) {
			return state.orderLine;
		},
		isRushOrderAvailable: function isRushOrderAvailable(state) {
			// Rush is only a meaningful choice if it's actually faster than standard for the
			// currently selected amount - a rush production time being configured for the product
			// isn't enough on its own (near a cutoff, rush can compute to the same date as
			// standard). Mirrors the comparison Cart/StepTwo.cs makes server-side.
			var standard = store.getters.getStandardDelivery;
			var rush = store.getters.getRushDelivery;

			return !!(rush && standard && rush.rawDate < standard.rawDate);
		},
		getDeliveryTimes: function getDeliveryTimes(state) {
			if (!state.selectedFormat.deliveryTimes) {
				return state.selectedProduct.specifications[0].deliveryTimes;
			} else {
				return state.selectedFormat.deliveryTimes;
			}
		},
		getStandardDelivery: function getStandardDelivery(state) {
			return findDeliveryTimeForAmount(store.getters.getDeliveryTimes, state.orderLine.amount, false, false);
		},
		getRushDelivery: function getRushDelivery(state) {
			return findDeliveryTimeForAmount(store.getters.getDeliveryTimes, state.orderLine.amount, true, false);
		},
		getOffsetDelivery: function getOffsetDelivery(state) {
			return findDeliveryTimeForAmount(store.getters.getDeliveryTimes, state.orderLine.amount, false, true);
		},
		getOffsetRushDelivery: function getOffsetRushDelivery(state) {
			return findDeliveryTimeForAmount(store.getters.getDeliveryTimes, state.orderLine.amount, true, true);
		},
		getProductSize: function getProductSize(state) {
			if (store.state.selectedFormat.isCustomSize) {
				if (state.file.uploadsComplete) {
					return {
						width: state.file.content.uploadSize.width,
						height: state.file.content.uploadSize.height
					};
				}

				if (state.customSize.width && state.customSize.height) {
					return {
						width: state.customSize.width,
						height: state.customSize.height
					};
				}
			}

			return {
				width: 0,
				height: 0
			};
		},
		getTrimmedProductSize: function getTrimmedProductSize(state, getters) {
			/**
    * @returns the product size without bleed. After an upload the product size is the PDF size, which includes bleed
    */
			var size = getters.getProductSize;

			if (state.selectedFormat.isCustomSize && state.file.uploadsComplete) {
				return getters.bleedSize(size).trimmed();
			}

			return size;
		},
		getCalculationPayload: function getCalculationPayload(state) {
			if (store.getters.checkData.hasSelectedFormat && store.getters.checkData.hasSelectedProduct) {
				return {
					id: store.state.baseProps.configId !== "null" ? parseInt(store.state.baseProps.configId) : null,
					productFrontId: store.state.selectedProduct.id,
					specificationId: store.state.selectedFormat.id,
					productOptionIds: store.getters.getSelectedOptionIds.length ? store.getters.getSelectedOptionIds : [],
					pages: store.getters.getPageCount,
					widthInMm: Math.round(store.getters.getTrimmedProductSize.width),
					heightInMm: Math.round(store.getters.getTrimmedProductSize.height),
					uploadPublicId: state.file.uploadSessionGuid
				};
			}
		},
		getPostConfig: function getPostConfig(state) {
			var data = void 0;
			var postConfig = {};

			if (store.getters.checkData.hasSelectedFormat && store.getters.checkData.hasSelectedProduct && store.getters.checkData.hasSelectedOptions) {
				if (state.baseProps.isConfiguration && !state.baseProps.specificationId) {
					data = store.getters.getConfigurationSettings;
				} else {
					data = store.getters.getCalculationPayload;
				}

				postConfig.id = data.id;
				postConfig.pageCount = store.getters.getPageCount || store.getters.getSelectedFormat.minPageCount;

				postConfig.customAmount = store.state.orderLine.amount !== 0 ? store.state.orderLine.amount : data.amount;

				if (data.widthInMm !== 0) {
					postConfig.customWidthInMm = data.widthInMm;
				}
				if (data.heightInMm !== 0) {
					postConfig.customHeightInMm = data.heightInMm;
				}

				postConfig.specificationId = data.specificationId;
				postConfig.productFrontId = data.productFrontId;
				postConfig.name = data.name ? data.name : store.getters.getConfigurationName;

				postConfig.productOptionIds = store.getters.getSelectedOptionIds;

				postConfig.hasOffsetPrintingAmount = store.state.orderLine.isOffset || false;

				if (store.state.orderLine.isOffset && store.state.orderLine.offsetSkuId) {
					postConfig.offsetSkuId = store.state.orderLine.offsetSkuId;
				}

				postConfig.uploadPublicId = state.file.uploadSessionGuid !== null ? state.file.uploadSessionGuid : null;

				if (state.baseProps.isConfiguration && !state.baseProps.specificationId && data.uploadPublicId !== null && typeof data.uploadPublicId !== "undefined" && data.uploadPublicId !== "") {
					postConfig.uploadPublicId = data.uploadPublicId;
				}

				if (state.baseProps.isConfiguration && !state.baseProps.specificationId && data.editorProjectId !== null && typeof data.editorProjectId !== "undefined" && data.editorProjectId !== "") {
					postConfig.editorProjectId = data.editorProjectId;
				}
			}
			return postConfig;
		},
		getConfigurationSettings: function getConfigurationSettings(state) {
			return state.config.configurationSettings;
		},
		getNonEditableOptionOfferIds: function getNonEditableOptionOfferIds(state) {
			return state.config.configurationSettings.nonEditableOptionOfferIds || [];
		},
		getLockedOptionGroupIds: function getLockedOptionGroupIds(state) {
			var lockedOfferIds = state.config.configurationSettings.nonEditableOptionOfferIds || [];
			if (!lockedOfferIds.length || !state.selectedFormat || !state.selectedFormat.productOptionGroups) {
				return [];
			}
			return state.selectedFormat.productOptionGroups.filter(function (g) {
				return g.productOptions.some(function (po) {
					return lockedOfferIds.includes(po.id);
				});
			}).map(function (g) {
				return g.id;
			});
		},
		getHiddenOptionGroupIds: function getHiddenOptionGroupIds(state) {
			return getHiddenOptionGroupIdsFromState(state);
		},
		getNonSelectableOptionGroupIds: function getNonSelectableOptionGroupIds(state) {
			var forcedByEditor = state.config.configurationSettings.productGroupIdsForcedByEditor || [];
			return [].concat(toConsumableArray_default()(new set_default.a([].concat(toConsumableArray_default()(forcedByEditor), toConsumableArray_default()(getHiddenOptionGroupIdsFromState(state))))));
		},
		getUploadSessionGuid: function getUploadSessionGuid(state) {
			return state.file.uploadSessionGuid;
		},
		uploadsAreComplete: function uploadsAreComplete(state) {
			return state.file.uploadsComplete;
		},
		getCustomErrorMessages: function getCustomErrorMessages(state) {
			return state.file.customErrorMessages;
		},
		getMatchedCustomSizeFormat: function getMatchedCustomSizeFormat(state) {
			return state.file.matchedCustomSizeFormat;
		},
		getMatchedCustomSizeFormatData: function getMatchedCustomSizeFormatData(state) {
			if (store.getters.checkData.hasSelectedProduct) {
				return state.selectedProduct.specifications.find(function (f) {
					return f.id === store.getters.getMatchedCustomSizeFormat;
				});
			}
		},
		isCustomUpload: function isCustomUpload(state) {
			return state.file.isCustomSize;
		},
		getPreviewUrl: function getPreviewUrl(state) {
			if (!state.file.uploadsComplete && !state.baseProps.isConfiguration) {
				return null;
			}
			if (state.order.thumbnailUrl) {
				return state.order.thumbnailUrl;
			}
			if (!state.file.cover && state.file.content) {
				return state.file.content.mainPreviewUrl;
			}
			if (state.file.cover) {
				return state.file.cover.mainPreviewUrl;
			}
			return null;
		},
		existingConfigIsFinalized: function existingConfigIsFinalized(state) {
			return state.configurator.steps.general.existingConfigurationIsFinalized;
		},
		getQuotationResponse: function getQuotationResponse(state) {
			return state.quotationResponse;
		},
		getBoundingRect: function getBoundingRect(state) {
			return state.configurator.boundaries;
		},
		getViewPort: function getViewPort(state) {
			return state.viewPort;
		},

		getGroupIdFromOptionId: function getGroupIdFromOptionId(state) {
			return function (id) {
				if (state.selectedFormat) {
					var groupId = null;

					state.selectedFormat.productOptionGroups.forEach(function (group) {
						var groupContainsId = group.productOptions.some(function (po) {
							return po.id === id;
						});
						if (groupContainsId) {
							groupId = group.id;
						}
					});

					return groupId;
				}
			};
		},
		getRequiredOptionsWithinGroups: function getRequiredOptionsWithinGroups(state) {
			return state.requiredOptionsWithinGroups;
		},

		getStepExists: function getStepExists(state) {
			return function (stepToCheck) {
				var steps = store.getters.getAllSteps;
				var stepExists = function stepExists(step) {
					return {
						"string": steps.some(function (a) {
							return a.name === step;
						}),
						"number": steps.some(function (a) {
							return a.groupId === step;
						})
					}[typeof step === "undefined" ? "undefined" : typeof_default()(step)];
				};

				var result = stepExists(stepToCheck);

				return {
					bool: result,
					class: result ? "cursor-pointer" : ""
				};
			};
		},
		isSpecificationConfiguration: function isSpecificationConfiguration(state) {
			return !!state.baseProps.specificationId;
		}
	},
	mutations: {
		CONFIGURATOR_ADD_STEP: function CONFIGURATOR_ADD_STEP(state, payload) {
			if (!state.configurator.steps.all.find(function (x) {
				return x.name === payload.option.name;
			})) {
				if (payload.position !== undefined) {
					state.configurator.steps.all.splice(payload.position, 0, payload.option);
				} else {
					state.configurator.steps.all.push(payload.option);
				}
			}
		},
		CONFIGURATOR_REMOVE_STEP: function CONFIGURATOR_REMOVE_STEP(state, payload) {
			var step = state.configurator.steps.all.find(function (x) {
				return x.name === payload;
			});
			if (step) {
				state.configurator.steps.all.splice(state.configurator.steps.all.indexOf(step), 1);
			}
		},
		CONFIGURATOR_UPDATE_STEP: function CONFIGURATOR_UPDATE_STEP(state, payload) {
			state.configurator.steps.all[payload.index][payload.property] = payload.value;
		},
		CONFIGURATOR_SET_ACTIVE_STEP: function CONFIGURATOR_SET_ACTIVE_STEP(state, payload) {
			if (payload !== undefined) {
				state.configurator.steps.current.data = payload;
				state.configurator.steps.current.index = state.configurator.steps.all.indexOf(payload);

				if (["configurator-overview", "price-table"].includes(payload.name)) {
					store.dispatch("_getPriceTable");

					if (store.getters.hasOffsetAvailable) {
						store.dispatch("_getOffsetPriceTable");
					}
					state.configurator.changed = false;
				}

				if (store.getters.checkData.hasSelectedOptions) {
					store.commit("CHECK_OPTION_AVAILABILITY");
					store.commit("CHECK_FILTER_EXCLUSIONS");
				}

				if (store.getters.checkData.hasSelectedFormat && payload.groupId) {
					// gets item within group
					var options = store.getters.getSelectedFormat.productOptionGroups.find(function (g) {
						return g.id === payload.groupId;
					}).productOptions;

					// Get all unavailable options (both from requirements and from exclusion filters)
					var allUnavailable = store.getters.getAllUnavailableOptions;

					// checks if item within groups are within unavailable options. If so alter options to the available options
					if (allUnavailable.length > 0) {
						options = options.filter(function (o) {
							return !allUnavailable.includes(o.id);
						});
					}

					var hasSingleItem = options.length === 1;

					if (hasSingleItem) {
						var option = options[0];
						option.parentGroupId = payload.groupId;
						store.commit("SET_SELECTED_OPTION", option);
					}
				}

				store.commit("CONFIGURATOR_STEP_AVAILABLE");
			}
		},
		CONFIGURATOR_STEP_AVAILABLE: function CONFIGURATOR_STEP_AVAILABLE(state) {
			var maxSteps = state.configurator.steps.all.length - 1;
			var currentStep = state.configurator.steps.current.index;
			if (state.configurator.steps.all[currentStep]) {
				var currentStepValid = state.configurator.steps.all[currentStep].valid;

				store.commit("CHECK_CONFIGURATOR_DATA_VALID");
				state.configurator.steps.available.next = currentStep < maxSteps && currentStepValid;
				state.configurator.steps.available.prev = currentStep > 0;
			}
		},
		CONFIGURATOR_STEP_NEXT: function CONFIGURATOR_STEP_NEXT(state) {
			var maxSteps = state.configurator.steps.all.length - 1;
			var currentStep = state.configurator.steps.current.index;

			if (currentStep < maxSteps) {
				store.commit("CONFIGURATOR_SET_ACTIVE_STEP", state.configurator.steps.all[currentStep + 1]);
			}
		},
		CONFIGURATOR_STEP_PREV: function CONFIGURATOR_STEP_PREV(state) {
			var currentStep = state.configurator.steps.current.index;

			if (currentStep > 0) {
				store.commit("CONFIGURATOR_SET_ACTIVE_STEP", state.configurator.steps.all[currentStep - 1]);
			}
		},
		SET_STEP_VALID: function SET_STEP_VALID(state, payload) {
			var index = payload != null ? payload : state.configurator.steps.current.index;
			if (state.configurator.steps.all[index]) {
				state.configurator.steps.all[index].valid = true;
			}
		},
		SET_STEP_INVALID: function SET_STEP_INVALID(state, payload) {
			var index = payload != null ? payload : state.configurator.steps.current.index;

			state.configurator.steps.all[index].valid = false;
		},
		SET_PRODUCT_DATA: function SET_PRODUCT_DATA(state, payload) {
			state.productData = payload;
		},
		SET_BASE_PROPS: function SET_BASE_PROPS(state, payload) {
			state.baseProps = payload;
			state.baseProps.isEditorProject = typeof payload.editorProject !== "undefined" ? payload.editorProject.toLowerCase() === "true" : false;
			state.baseProps.isFront = payload.productFrontId[0] !== "null";
			state.baseProps.isConfiguration = payload.configId !== "null";
			state.baseProps.productFrontId = payload.productFrontId.map(function (id) {
				return id !== "null" ? parseInt(id) : "null";
			});
			state.baseProps.hasSeparateCover = payload.hasCover.toLowerCase() === "true";
		},
		SET_CONFIGURATOR_PRODUCT_DATA: function SET_CONFIGURATOR_PRODUCT_DATA(state) {
			state.configuratorData.hasMultipleProducts = state.productData.length > 1;
			if (!state.configuratorData.hasMultipleProducts) {
				store.commit("SET_SELECTED_PRODUCT", state.productData[0]);
			}

			state.isLoaded = true;
		},
		SET_CONFIGURATOR_FORMAT_DATA: function SET_CONFIGURATOR_FORMAT_DATA(state) {
			state.configuratorData.hasMultiplePages = state.selectedFormat.maxPageCount !== state.selectedFormat.minPageCount;
			state.configurator.steps.general.optionsRenderable = false;
			state.orderLine.amount = !state.selectedProduct.isCustomAmountAllowed ? store.getters.getAmountData.amountList[0] : state.selectedFormat.minAmount;
		},
		SET_SELECTED_PRODUCT: function SET_SELECTED_PRODUCT(state, payload) {
			state.selectedProduct = payload;
			state.configurator.steps.general.optionsRenderable = false;

			store.commit("CLEAR_SELECTED_FORMAT");
			store.commit("CLEAR_SELECTED_OPTIONS");
			store.commit("CLEAR_CONFIGURATION_PRICE");
			store.commit("INVALIDATE_ALL_STEPS_AFTER", "select-product");
			store.commit("CONFIGURATOR_STEP_AVAILABLE");
		},
		CLEAR_SELECTED_FORMAT: function CLEAR_SELECTED_FORMAT(state) {
			state.selectedFormat = { id: null };
			state.configurator.steps.general.optionsRenderable = false;

			store.commit("CLEAR_SELECTED_OPTIONS");
			store.commit("CLEAR_CONFIGURATION_PRICE");
		},
		RESET_ALL_FILE_UPLOADS: function RESET_ALL_FILE_UPLOADS(state) {
			state.file.pageCount = null;
			store.commit("SET_MAIN_PREVIEW_URL", null);

			store.commit("RESET_FILE_UPLOAD", "content");
			store.commit("RESET_FILE_UPLOAD", "cover");

			store.commit("RESET_FORMAT_MATCHES");
			store.commit("RESET_FORMAT_SUGGESTIONS");

			store.commit("RESET_MATCHED_CUSTOMSIZE_FORMAT_SUGGESTION");
			store.commit("RESET_CUSTOM_ERROR_MESSAGE", "content");
			store.commit("RESET_CUSTOM_ERROR_MESSAGE", "cover");

			EventBus.$emit("resetUploadInput");
		},
		SET_SELECTED_FORMAT: function SET_SELECTED_FORMAT(state, payload) {
			if (payload !== store.getters.getSelectedFormat.id) {
				if (store.getters.checkData.hasSelectedFormat && payload !== null && store.getters.getUploaderPosition.after) {
					store.commit("CHECK_CONFIGURATOR_DATA_VALID");
					store.commit("SET_STEP_VALID");
					EventBus.$emit("selectedFormatDoesNotMatch");
					store.commit("SET_STEP_ACTIVE", "select-format");
				}

				state.selectedFormat = payload !== null ? state.selectedProduct.specifications.find(function (f) {
					return f.id === payload;
				}) : { id: null };

				store.commit("CLEAR_SELECTED_OPTIONS");

				state.customPageCount = null;

				store.commit("CLEAR_CONFIGURATION_PRICE");
				store.commit("INVALIDATE_ALL_STEPS_AFTER", "select-format");

				if (payload !== null) {
					store.commit("BOOK_SINGLE_DOUBLE_SIDED_PAGECOUNT_PRINTSIDE_CHECK");

					if (store.getters.checkData.hasSelectedFormat) {
						store.commit("SET_CONFIGURATOR_FORMAT_DATA");

						if (state.baseProps.isConfiguration) {
							state.configurator.steps.general.optionsRenderable = true;
						}

						state.baseProps.hasOffsetAvailable = store.state.selectedFormat.offsetPricings.length > 0;

						if (!state.baseProps.isConfiguration) {
							store.dispatch("_getConfigurationPrice");
						}

						if (store.getters.uploadsAreComplete) {
							if (state.selectedFormat.isCustomSize) {
								// The upload size includes bleed, the custom size is without bleed
								store.commit("SET_CUSTOM_SIZE", store.getters.bleedSize(store.getters.getFile.content.uploadSize).trimmed());
							} else {
								store.commit("SET_CUSTOM_SIZE", { width: null, height: null });
							}
						}

						if (state.baseProps.isConfiguration) {
							store.commit("SET_ALL_CONFIGURATION_OPTIONS");
						}

						if (state.baseProps.isConfiguration && state.config.configurationSettings.previewUrl) {
							store.commit("SET_MAIN_PREVIEW_URL", state.config.configurationSettings.previewUrl);
						}

						store.commit("GET_REQUIRED_OPTION_IDS");
						store.commit("OPTION_AVAILABILITY_INIT");
					}
				}
			} else {
				store.commit("BOOK_SINGLE_DOUBLE_SIDED_PAGECOUNT_PRINTSIDE_CHECK");
			}

			store.commit("CONFIGURATOR_STEP_AVAILABLE");
		},
		BOOK_SINGLE_DOUBLE_SIDED_PAGECOUNT_PRINTSIDE_CHECK: function BOOK_SINGLE_DOUBLE_SIDED_PAGECOUNT_PRINTSIDE_CHECK(state) {
			// The uploaded file of a hybrid off-the-shelf product is the cover, so its page count says nothing about the content
			if (store.getters.uploadsAreComplete && store.getters.isBookProduct && !store.getters.onlyCoverRequired) {
				store.commit("SET_PRINTSIDE_AVAILABILITY", store.getters.getFile.content.pageCount);
			}

			// Mirrors the content check above: the cover may finish uploading before a format is
			// selected (SET_COVER_UPLOAD's own SET_COVER_PRINTSIDE_AVAILABILITY call would bail with
			// no selected format yet), so re-derive it here too once a format is actually selected.
			if (store.getters.uploadsAreComplete && store.getters.hasSeparateCover && !store.getters.onlyCoverRequired) {
				store.commit("SET_COVER_PRINTSIDE_AVAILABILITY", store.getters.getFile.cover.isSingleSidedCover);
			}
		},
		SET_FORMAT_MATCHES: function SET_FORMAT_MATCHES(state, payload) {
			state.formatMatches = payload;
			state.configuratorData.hasFormatMatches = true;
		},
		SET_FORMAT_SUGGESTIONS: function SET_FORMAT_SUGGESTIONS(state, payload) {
			if (typeof payload !== "undefined") {
				state.formatSuggestions = payload;
				state.configuratorData.hasFormatSuggestions = true;

				if (payload.length === 1 && payload[0].isMatch) {
					state.configuratorData.hasFormatSuggestions = false;
				}
			}
		},
		RESET_FORMAT_MATCHES: function RESET_FORMAT_MATCHES(state) {
			state.formatMatches = [];
			state.configuratorData.hasFormatMatches = false;
		},
		RESET_FORMAT_SUGGESTIONS: function RESET_FORMAT_SUGGESTIONS(state) {
			state.formatSuggestions = [];
			state.configuratorData.hasFormatSuggestions = false;
		},
		GET_REQUIRED_OPTION_IDS: function GET_REQUIRED_OPTION_IDS(state) {
			var requiredOptionsWithinGroups = {};
			if (state.selectedFormat.productOptionGroups) {
				state.selectedFormat.productOptionGroups.forEach(function (group) {
					var optionsWithRequirements = group.productOptions.filter(function (i) {
						return i.requiredProductOptionIds.length;
					});

					optionsWithRequirements.forEach(function (option) {
						requiredOptionsWithinGroups[option.id] = {};
						var groupsWithIds = {};

						option.requiredProductOptionIds.forEach(function (o) {
							var group = store.getters.getGroupIdFromOptionId(o);

							groupsWithIds[group] = groupsWithIds[group] || [];
							groupsWithIds[group].push(o);

							state.requiredOptionIds[o] = group;
						});
						requiredOptionsWithinGroups[option.id] = groupsWithIds;
					});
				});
			}
			state.requiredOptionsWithinGroups = requiredOptionsWithinGroups;
		},
		INVALIDATE_ALL_STEPS_AFTER: function INVALIDATE_ALL_STEPS_AFTER(state, payload) {
			var lastValidStepIndex = state.configurator.steps.all.indexOf(state.configurator.steps.all.find(function (step) {
				return step.name === payload;
			}));
			for (var i = lastValidStepIndex + 1; i < state.configurator.steps.all.length; i++) {
				state.configurator.steps.all[i].valid = false;
			}
			// edge case: Separating the page count selection from the format step creates a situation
			// where the default value for the page count is already set and valid, but the next button stays disabled.
			// We force this step to essentially always be valid, because it is.
			var pageCountStep = state.configurator.steps.all.find(function (step) {
				return step.name === "page-count";
			});
			if (pageCountStep) {
				pageCountStep.valid = true;
			}
		},
		REMOVE_ALL_STEPS_AFTER: function REMOVE_ALL_STEPS_AFTER(state, payload) {
			var lastValidStepIndex = state.configurator.steps.all.indexOf(state.configurator.steps.all.find(function (step) {
				return step.name === payload;
			}));
			for (var i = lastValidStepIndex + 1; i < state.configurator.steps.all.length; i++) {
				store.commit("CONFIGURATOR_REMOVE_STEP", state.configurator.steps.all[i].name);
			}
		},
		CLEAR_SELECTED_OPTION: function CLEAR_SELECTED_OPTION(state, payload) {
			var group = state.selectedGroups.find(function (a) {
				return a.id === payload;
			});
			var option = state.selectedOptions.find(function (a) {
				return a.parentGroupId === payload;
			});

			var optionItemIndex = state.selectedOptions.indexOf(option);

			if (group.length && option.length) {
				state.selectedOptions.splice(optionItemIndex, 1);
			}

			var step = state.configurator.steps.all.find(function (a) {
				return a.groupId === payload;
			});

			var stepIndex = state.configurator.steps.all.indexOf(step);
			store.commit("SET_STEP_INVALID", stepIndex);

			store.commit("CONFIGURATOR_STEP_AVAILABLE");
		},
		SET_SELECTED_OPTION_EXTRAS: function SET_SELECTED_OPTION_EXTRAS(state, payload) {
			// DWN Product 'Tabbladen' has an option for the amount of tabs. This should correspond to the pagecount for singlesided as well as doublesided.
			// The DWN API sends webshop ids (groups 3386/3392, options 815-817); the SDW custom configurator maps back to the legacy ids (group 135, options 149-151).
			var tabGroupIds = [135, 3386, 3392];
			var tabCountByOptionId = {
				149: 10,
				150: 15,
				151: 5,
				815: 10,
				816: 15,
				817: 5
			};
			var selectedTabOption = state.selectedOptions.find(function (o) {
				return tabGroupIds.includes(o.parentGroupId);
			});

			if (selectedTabOption) {
				var tabCount = tabCountByOptionId[selectedTabOption.baseOptionId];
				var printSidesCount = store.getters.getPrintSidesCount || 1;

				if (tabCount) {
					store.commit("SET_PAGE_COUNT", tabCount * printSidesCount);
				}
			}
		},
		SET_SELECTED_OPTION: function SET_SELECTED_OPTION(state, payload) {
			var checkExistingOption = state.selectedOptions.find(function (a) {
				return a.parentGroupId === payload.parentGroupId;
			});
			var groupData = state.selectedFormat.productOptionGroups.find(function (a) {
				return a.id === payload.parentGroupId;
			});
			var hasExistingOption = checkExistingOption !== undefined;

			var itemIndex = state.selectedOptions.indexOf(checkExistingOption);

			state.selectedOptions.splice(hasExistingOption ? itemIndex : groupData.index >= 0 ? groupData.index : state.selectedOptions.length, hasExistingOption ? 1 : 0, payload);

			store.commit("SET_STEP_VALID");

			if (groupData && state.dictionary.optionCategory[groupData.optionCategory] === "print" && store.getters.isPrintSidesCountChoice) {
				store.commit("SET_PAGE_COUNT", payload.printSideCount);
			}

			if (groupData && state.dictionary.optionCategory[groupData.optionCategory] === "print" && state.dictionary.chunkType[groupData.chunkType] === "content") {
				store.commit("SET_PRINT_SIDES_COUNT", payload.printSideCount);
			}

			if (payload.configuratorPageCount !== null && payload.configuratorPageCount !== undefined) {
				store.commit("SET_PAGE_COUNT", payload.configuratorPageCount);
			}

			store.commit("SET_SELECTED_OPTION_EXTRAS", payload);
			store.commit("CONFIGURATOR_STEP_AVAILABLE");
			store.commit("ADD_TO_SELECTED_GROUPS", payload.parentGroupId);
			store.commit("CHECK_OPTION_AVAILABILITY");
			store.commit("CHECK_FILTER_EXCLUSIONS");

			if (state.requiredOptionIds.hasOwnProperty(payload.id)) {
				store.commit("CHECK_CONFIGURATOR_DATA_VALID");
			}

			if (!state.baseProps.isConfiguration || state.configurator.steps.general.existingConfigurationAdded) {
				store.dispatch("_getConfigurationPrice");
			}

			if (state.configurator.steps.general.existingConfigurationIsFinalized) {
				state.configurator.configurationChanged = true;
			}

			state.configurator.changed = true;
			store.commit("CONFIGURATOR_STEP_AVAILABLE");
		},
		SET_ALL_CONFIGURATION_OPTIONS: function SET_ALL_CONFIGURATION_OPTIONS(state) {
			if (state.baseProps.isConfiguration) {
				var _ret = function () {
					var configurationOptionIds = state.config.configurationSettings.productOptionIds;

					var optionGroups = store.getters.getSelectedFormat.productOptionGroups.sort(function (a, b) {
						return a.index - b.index;
					});
					for (var optionGroup in optionGroups) {
						var optionToSelect = null;

						var _loop = function _loop(option) {
							if (typeof_default()(optionGroups[optionGroup]) !== "object") {
								return {
									v: {
										v: void 0
									}
								};
							}
							var initialOptionToSelect = optionGroups[optionGroup].productOptions.find(function (o) {
								return o.id === parseInt(configurationOptionIds[option]);
							});

							if (initialOptionToSelect) {
								optionToSelect = initialOptionToSelect.baseOptionId !== 123 || !state.baseProps.isEditorProject ? initialOptionToSelect : optionGroups[optionGroup].productOptions.find(function (o) {
									return o.baseOptionId === 122;
								});
							}

							if (optionToSelect !== null) {
								return "break";
							}
						};

						_loop2: for (var option in configurationOptionIds) {
							var _ret2 = _loop(option);

							switch (_ret2) {
								case "break":
									break _loop2;

								default:
									if ((typeof _ret2 === "undefined" ? "undefined" : typeof_default()(_ret2)) === "object") return _ret2.v;
							}
						}

						if (optionToSelect !== null) {
							optionToSelect.parentGroupId = optionGroups[optionGroup].id;
							store.commit("SET_SELECTED_OPTION", optionToSelect);
						}
					}
				}();

				if ((typeof _ret === "undefined" ? "undefined" : typeof_default()(_ret)) === "object") return _ret.v;
			}
		},
		SET_ORDER: function SET_ORDER(state, payload) {
			state.order = payload;
		},
		OPTION_AVAILABILITY_INIT: function OPTION_AVAILABILITY_INIT(state) {
			if (state.selectedFormat.productOptionGroups) {
				state.selectedFormat.productOptionGroups.forEach(function (group) {
					group.productOptions.forEach(function (option) {
						state.availableOptions.push(option.id);
					});
				});

				// Bug #7649: option numbering was messed up whilst switching formats and optionsRenderable was set true too early. (Please dont remove setTimeout() because this made sure execution was timed properly)
				if (!state.baseProps.isConfiguration) {
					setTimeout(function () {
						state.configurator.steps.general.optionsRenderable = true;
					}, 0);
				}
			}
		},
		OPTION_AVAILABILITY_MET: function OPTION_AVAILABILITY_MET(state, payload) {
			var addIndex = state.availableOptions.includes(payload);
			if (!addIndex) {
				state.availableOptions.push(payload);
			}

			var removeIndex = state.unavailableOptions.indexOf(payload);
			if (removeIndex > -1) {
				state.unavailableOptions.splice(removeIndex, 1);
			}
		},
		OPTION_AVAILABILITY_UNMET: function OPTION_AVAILABILITY_UNMET(state, payload) {
			var removeIndex = state.availableOptions.indexOf(payload);
			if (removeIndex > -1) {
				state.availableOptions.splice(removeIndex, 1);
			}

			var addIndex = state.unavailableOptions.includes(payload);
			if (!addIndex) {
				state.unavailableOptions.push(payload);
			}
		},
		CHECK_OPTION_AVAILABILITY: function CHECK_OPTION_AVAILABILITY(state) {
			keys_default()(state.requiredOptionsWithinGroups).forEach(function (optionKey) {
				var option = state.requiredOptionsWithinGroups[optionKey];
				optionKey = parseInt(optionKey);

				var optionGroupIdToReset = store.getters.getGroupIdFromOptionId(optionKey);

				var hasOptionWithRequirementSelected = state.selectedOptions.find(function (o) {
					return o.id === optionKey;
				});

				var availabilityArray = [];

				keys_default()(option).forEach(function (groupKey) {
					var group = option[groupKey];
					groupKey = parseInt(groupKey);

					var selectedOptionBasedOnGroup = state.selectedOptions.find(function (o) {
						return o.parentGroupId === groupKey;
					});

					if (selectedOptionBasedOnGroup) {
						if (group.includes(selectedOptionBasedOnGroup.id)) {
							availabilityArray.push(true);
						} else {
							// HAS UNMET REQUIREMENTS
							availabilityArray.push(false);
						}
					}
				});

				if (availabilityArray.every(function (i) {
					return i === true;
				})) {
					store.commit("OPTION_AVAILABILITY_MET", optionKey);
				} else {
					store.commit("OPTION_AVAILABILITY_UNMET", optionKey);
					if (hasOptionWithRequirementSelected) {
						store.commit("RESET_OPTION_GROUP", optionGroupIdToReset);
					}
				}

				store.commit("CHECK_CONFIGURATOR_DATA_VALID");
			});
		},
		CHECK_FILTER_EXCLUSIONS: function CHECK_FILTER_EXCLUSIONS(state) {
			var _state$excludedByFilt;

			if (!state.selectedFormat || !state.selectedFormat.productOptionGroups) {
				state.excludedByFilters.splice(0, state.excludedByFilters.length);
				return;
			}

			var groups = state.selectedFormat.productOptionGroups;
			var allProductOptions = groups.reduce(function (acc, g) {
				return acc.concat(g.productOptions);
			}, []);
			var selectedIds = state.selectedOptions.map(function (s) {
				return s.id;
			});

			var excludedOptionOfferIds = new set_default.a();

			// Requirement filters are intentionally NOT applied here as a hard allow-list: two
			// options that each require something in the other's group can otherwise deadlock the
			// picker (selecting one locks the other group down to its requirement, which locks the
			// first group back down, with no option left to click to escape it). The server-side
			// picker (OptionSelectionFilterHelper.GetCompatibleOptionOffers) leaves requirements out
			// for the same reason; CHECK_OPTION_AVAILABILITY / RESET_OPTION_GROUP below enforces them
			// reactively instead, by resetting the dependent group rather than blocking the picker.

			// Reverse direction — a selected option directly excludes other options.
			state.selectedOptions.forEach(function (selected) {
				var option = allProductOptions.find(function (po) {
					return po.id === selected.id;
				});
				if (option && option.excludedProductOptionIds) {
					option.excludedProductOptionIds.forEach(function (id) {
						return excludedOptionOfferIds.add(id);
					});
				}
			});

			// Forward direction — a candidate whose own exclusions would invalidate an existing
			// selection is hidden so the user can't pick it.
			allProductOptions.forEach(function (candidate) {
				if (selectedIds.includes(candidate.id)) {
					return;
				}

				if (candidate.excludedProductOptionIds && candidate.excludedProductOptionIds.some(function (id) {
					return selectedIds.includes(id);
				})) {
					excludedOptionOfferIds.add(candidate.id);
				}
			});

			(_state$excludedByFilt = state.excludedByFilters).splice.apply(_state$excludedByFilt, [0, state.excludedByFilters.length].concat(toConsumableArray_default()(excludedOptionOfferIds)));
		},
		RESET_OPTION_GROUP: function RESET_OPTION_GROUP(state, payload) {
			state.selectedOptions.forEach(function (option, index) {
				if (option.parentGroupId === payload) {
					state.selectedOptions.splice(index, 1);
				}
			});

			state.selectedGroups.forEach(function (group, index) {
				if (group.id === payload) {
					state.selectedOptions.splice(index, 1);
				}
			});

			var step = state.configurator.steps.all.find(function (a) {
				return a.groupId === payload;
			});
			var stepIndex = state.configurator.steps.all.indexOf(step);

			store.commit("SET_STEP_INVALID", stepIndex);
		},
		SET_CUSTOM_SIZE: function SET_CUSTOM_SIZE(state, payload) {
			state.customSize = payload;

			if (!state.baseProps.isConfiguration) {
				store.commit("CONFIGURATOR_STEP_AVAILABLE");
				if (payload.width && payload.height) {
					store.dispatch("_getConfigurationPrice");
				}
			}
		},
		SET_CUSTOM_SIZE_VALID: function SET_CUSTOM_SIZE_VALID(state, payload) {
			state.customSizeValid = payload;
		},
		SET_PAGE_COUNT: function SET_PAGE_COUNT(state, payload) {
			if (is_integer_default()(payload)) {
				state.customPageCount = parseInt(payload);
				store.dispatch("_getConfigurationPrice");
				store.commit("SET_ALTERED_PAGE_COUNT");
			}
		},
		SET_PRINT_SIDES_COUNT: function SET_PRINT_SIDES_COUNT(state, payload) {
			var newPrintSidesCount = parseInt(payload);
			var oldPrintSidesCount = state.config.printSidesCount;

			// When editing an existing configuration without a new file upload, the page count
			// stored in customPageCount must be adjusted manually because SET_ALTERED_PAGE_COUNT
			// only recalculates alteredPageCount when a file is present. Products where the page
			// count is the sides count itself are excluded: SET_SELECTED_OPTION already set
			// customPageCount to the selected option's printSideCount, so compensating here
			// would immediately undo that change.
			if (!store.getters.isPrintSidesCountChoice && !state.file.pageCount && state.customPageCount && oldPrintSidesCount && newPrintSidesCount !== oldPrintSidesCount) {
				if (oldPrintSidesCount === 2 && newPrintSidesCount === 1) {
					// dubbelzijdig → enkelzijdig: double the page count
					state.customPageCount = state.customPageCount * 2;
				} else if (oldPrintSidesCount === 1 && newPrintSidesCount === 2) {
					// enkelzijdig → dubbelzijdig: halve the page count
					state.customPageCount = Math.floor(state.customPageCount / 2);
				}
			}

			state.config.printSidesCount = newPrintSidesCount;
			store.commit("SET_ALTERED_PAGE_COUNT");
		},
		SET_ALTERED_PAGE_COUNT: function SET_ALTERED_PAGE_COUNT(state, payload) {
			var singleSidePrintFileUploaded = state.printSidesAvailability.set && state.printSidesAvailability.single && state.file.pageCount > 0 && state.config.printSidesCount === 1;

			// vlakliggend
			if (state.selectedFormat.productType >= 4 && state.selectedFormat.productType <= 6) {
				state.alteredPageCount = null;
			} else if (singleSidePrintFileUploaded) {
				state.alteredPageCount = state.file.pageCount * 2;
			} else {
				state.alteredPageCount = null;
			}
		},
		SET_CONFIGURATION_NAME: function SET_CONFIGURATION_NAME(state, payload) {
			state.name = payload;
		},
		SET_CONFIGURATOR_TYPE: function SET_CONFIGURATOR_TYPE(state, payload) {
			state.type = payload || "initial";

			var calculateStep = store.getters.getConfiguratorData.hasMultipleProducts ? "select-product" : "select-format";

			if (!store.getters.isConfiguratorDataValid) {
				store.commit("CONFIGURATOR_REMOVE_STEP", "uploader");
			}

			var setType = {
				"upload": function upload() {
					store.commit("SET_STEP_ACTIVE", "uploader");
				},
				"calculate": function calculate() {
					store.commit("RESET_FILE_UPLOAD", "content");
					store.commit("RESET_FILE_UPLOAD", "cover");
					EventBus.$emit("resetUploadInput");
					store.commit("RESET_FORMAT_MATCHES");
					store.commit("RESET_FORMAT_SUGGESTIONS");
					store.commit("SET_STEP_ACTIVE", calculateStep);
				}
			}[payload];

			if (typeof setType === "function") {
				setType();
			} else {
				store.commit("SET_STEP_ACTIVE", store.state.configurator.steps.first());
			}
		},
		SET_STEP_ACTIVE: function SET_STEP_ACTIVE(state, payload) {
			if (state.configurator.steps.all.length > 0) {
				var activeStep = {
					"string": state.configurator.steps.all.find(function (a) {
						return a.name === payload;
					}),
					"number": state.configurator.steps.all.find(function (a) {
						return a.groupId === payload;
					}),
					"object": payload
				}[typeof payload === "undefined" ? "undefined" : typeof_default()(payload)];
				store.commit("CONFIGURATOR_SET_ACTIVE_STEP", activeStep);
			}
		},
		SET_ORDERLINE_AMOUNT: function SET_ORDERLINE_AMOUNT(state, payload) {
			state.orderLine.amount = parseInt(payload);

			if (state.orderLine.isOffset) {
				store.commit("SET_CONFIGURATION_OFFSET_PRICE", parseInt(payload));
			} else {
				store.dispatch("_getConfigurationPrice");
			}
		},
		SET_RUSH_SELECTED: function SET_RUSH_SELECTED(state, payload) {
			state.orderLine.isRush = payload;
		},
		SET_OFFSET_SELECTED: function SET_OFFSET_SELECTED(state, payload) {
			state.orderLine.isOffset = payload;
			if (!payload) {
				state.orderLine.offsetSkuId = null;
				store.dispatch("_getConfigurationPrice");
			} else {
				if (state.orderLine.amount) {
					store.commit("SET_CONFIGURATION_OFFSET_PRICE", state.orderLine.amount);
				}
			}
		},
		SET_OFFSET_SKU_ID: function SET_OFFSET_SKU_ID(state, payload) {
			state.orderLine.offsetSkuId = payload;
		},
		SET_FIRST_OFFSET_AMOUNT_SELECTED: function SET_FIRST_OFFSET_AMOUNT_SELECTED(state) {
			if (!store.getters.getOffsetPriceTable.length) {
				return;
			}

			if (!store.getters.hasDigitalAvailable && store.getters.hasOffsetAvailable) {
				var amount = state.orderLine.amount || store.getters.getOffsetPriceTable[0].Amount;
				store.commit("SET_RUSH_SELECTED", false);
				store.commit("SET_OFFSET_SELECTED", true);
				store.commit("SET_ORDERLINE_AMOUNT", amount);
				store.commit("SET_CONFIGURATION_OFFSET_PRICE", amount);
			}
		},
		ADD_TO_SELECTED_GROUPS: function ADD_TO_SELECTED_GROUPS(state, payload) {
			var groupExists = state.selectedGroups.some(function (a) {
				return a.id === payload;
			});

			if (!groupExists) {
				var parentGroupData = state.selectedFormat.productOptionGroups.find(function (a) {
					return a.id === payload;
				});
				var parentGroup = {
					chunkType: parentGroupData.chunkType,
					id: parentGroupData.id,
					index: parentGroupData.index,
					name: parentGroupData.name,
					optionCategory: parentGroupData.optionCategory,
					supportsCombinedPrint: parentGroupData.supportsCombinedPrint,
					title: parentGroupData.title
				};

				state.selectedGroups.push(parentGroup);
			}
		},
		CLEAR_SELECTED_OPTIONS: function CLEAR_SELECTED_OPTIONS(state) {
			if (state.selectedGroups.length > 0) {
				state.selectedGroups.splice(0, state.selectedGroups.length);
				state.selectedOptions.splice(0, state.selectedOptions.length);
			}
			state.excludedByFilters.splice(0, state.excludedByFilters.length);
			store.commit("AUTOMATICALLY_SET_OPTIONS");
		},
		AUTOMATICALLY_SET_OPTIONS: function AUTOMATICALLY_SET_OPTIONS(state) {
			if (!state.selectedFormat || !state.selectedFormat.productOptionGroups) {
				return;
			}
			var shouldPreSelectedTheseOptionGroups = state.selectedFormat.productOptionGroups.filter(function (productOptionGroup) {
				return productOptionGroup.productOptions.length === 1;
			});
			if (shouldPreSelectedTheseOptionGroups.length > 0) {
				shouldPreSelectedTheseOptionGroups.forEach(function (optionGroup) {
					var option = optionGroup.productOptions[0];
					option.parentGroupId = optionGroup.id;
					store.commit("SET_SELECTED_OPTION", option);
				});
			}
		},
		CHECK_CONFIGURATOR_DATA_VALID: function CHECK_CONFIGURATOR_DATA_VALID(state) {
			// Ensure excludedByFilters reflects the current selection set, then drop any
			// selection that lives in that set. Cascading resets converge within a few
			// iterations; the bound protects against pathological cycles.
			store.commit("CHECK_FILTER_EXCLUSIONS");

			var _loop3 = function _loop3(i) {
				var excluded = new set_default.a(state.excludedByFilters || []);
				var conflicts = state.selectedOptions.filter(function (o) {
					return excluded.has(o.id);
				});

				if (conflicts.length === 0) {
					return "break";
				}

				var groupsToReset = [].concat(toConsumableArray_default()(new set_default.a(conflicts.map(function (o) {
					return o.parentGroupId;
				}))));
				groupsToReset.forEach(function (id) {
					return store.commit("RESET_OPTION_GROUP", id);
				});
				store.commit("CHECK_FILTER_EXCLUSIONS");
			};

			for (var i = 0; i < 5; i++) {
				var _ret3 = _loop3(i);

				if (_ret3 === "break") break;
			}

			var hasInvalidSteps = state.configurator.steps.all.some(function (step) {
				return !step.valid;
			});
			var preparatorySteps = ["select-product", "select-format"];
			var insufficientProgression = preparatorySteps.includes(state.configurator.steps.current.data.name);
			var finalizedExistingConfiguration = state.baseProps.isConfiguration && state.configurator.steps.general.existingConfigurationAdded;

			if (state.baseProps.isConfiguration && !state.configurator.steps.general.existingConfigurationIsFinalized && !state.configurator.steps.general.existingConfigurationValidatedSteps) {
				store.commit("SET_EACH_STEP_VALID");
			}

			var validate = function validate(current) {
				if (store.getters.checkData.hasSelectedFormat) {
					// Groups forced by the editor or tagged Hidden are never presented to the customer, so
					// neither the group nor any selection already made for it (behind the scenes) should
					// count towards "did the customer complete every step they could actually see".
					var nonSelectableGroupIds = store.getters.getNonSelectableOptionGroupIds;
					var countableOptionGroups = state.selectedFormat.productOptionGroups.filter(function (g) {
						return !nonSelectableGroupIds.includes(g.id);
					});
					var countableSelectedOptions = state.selectedOptions.filter(function (o) {
						return !nonSelectableGroupIds.includes(o.parentGroupId);
					});
					var allOptionsSelected = countableOptionGroups.length === countableSelectedOptions.length;

					if (allOptionsSelected) {
						if (!finalizedExistingConfiguration) {
							store.commit("FINALIZE_EXISTING_CONFIG");

							return true;
						}
					} else {
						return false;
					}
				}

				if (state.configurator.steps.current.index > 0 && !insufficientProgression) {
					return !hasInvalidSteps;
				}

				if (!insufficientProgression) {
					return true;
				}

				return current;
			};

			state.configurator.steps.general.configuratorDataValid = validate(state.configurator.steps.general.configuratorDataValid);
		},
		SET_CONFIGURATION_PRICE: function SET_CONFIGURATION_PRICE(state, payload) {
			state.config.price = payload;

			if (store.getters.isRushOrderAvailable) {
				var rushPriceWithoutTax = addPercentage(payload.PriceWithoutTax, state.selectedProduct.rushOrderCostPercentage);
				state.config.extra.rushPrice = rushPriceWithoutTax;
				state.config.price.rushPriceWithoutTax = rushPriceWithoutTax;

				state.config.price.rushPriceWithTax = addPercentage(payload.PriceWithTax, state.selectedProduct.rushOrderCostPercentage);
			}

			var singleData = {
				PriceWithoutTax: payload.PriceWithoutTax / state.orderLine.amount,
				PriceWithTax: payload.PriceWithTax / state.orderLine.amount
			};

			store.commit("SET_CONFIGURATION_PRICE_SINGLE", singleData);
		},
		CLEAR_CONFIGURATION_PRICE: function CLEAR_CONFIGURATION_PRICE(state) {
			state.config.price = {
				PriceWithTax: null,
				PriceWithoutTax: null
			};
			store.commit("CLEAR_ORDERLINE");
		},
		CLEAR_ORDERLINE: function CLEAR_ORDERLINE(state) {
			state.orderLine = {
				amount: 0,
				isRush: false,
				isOffset: false,
				offsetSkuId: null
			};
		},
		SET_CONFIGURATION_PRICE_SINGLE: function SET_CONFIGURATION_PRICE_SINGLE(state, payload) {
			state.config.extra.singlePrice = payload.PriceWithoutTax;
			state.config.extra.singlePriceWithTax = payload.PriceWithTax;

			if (store.getters.isRushOrderAvailable) {
				state.config.extra.singleRushPrice = payload.PriceWithoutTax * state.selectedProduct.rushOrderCostPercentage + payload.PriceWithoutTax;
				state.config.extra.singleRushPriceWithTax = payload.PriceWithTax * state.selectedProduct.rushOrderCostPercentage + payload.PriceWithTax;
			}
		},
		SET_CONFIGURATION_OFFSET_PRICE: function SET_CONFIGURATION_OFFSET_PRICE(state, payload) {
			var offsetPriceTable = store.state.config.offsetPriceTable;
			var offset = offsetPriceTable.find(function (line) {
				return line.Amount === payload;
			});

			if (!offset && offsetPriceTable.length) {
				offset = offsetPriceTable.reduce(function (closest, line) {
					return Math.abs(line.Amount - payload) < Math.abs(closest.Amount - payload) ? line : closest;
				});
			}

			if (offset) {
				var offsetPrice = offset.Price;

				state.config.price.PriceWithoutTax = offsetPrice;
				var pricePayload = {
					PriceWithoutTax: offsetPrice
				};

				store.commit("SET_CONFIGURATION_PRICE", pricePayload);
			}
		},
		SET_EXISTING_CONFIGURATION_DATA: function SET_EXISTING_CONFIGURATION_DATA(state, payload) {
			if (state.baseProps.isConfiguration) {
				state.config.configurationSettings = payload;
				state.configuratorData.canSetConfigurationPrice = !payload.hasOffsetPrintingAmount;
				store.state.baseProps.productFrontId = payload.productFrontId;
			}
		},
		SET_EXISTING_CONFIGURATION_SELECTED: function SET_EXISTING_CONFIGURATION_SELECTED(state) {
			if (state.baseProps.isConfiguration) {
				store.commit("SET_SELECTED_FORMAT", state.config.configurationSettings.specificationId);
			}
		},
		SET_PRICE_TABLE: function SET_PRICE_TABLE(state, payload) {
			state.config.priceTable = payload;
		},
		SET_OFFSET_PRICE_TABLE: function SET_OFFSET_PRICE_TABLE(state, payload) {
			state.config.offsetPriceTable = payload;
		},
		SET_EACH_STEP_VALID: function SET_EACH_STEP_VALID(state) {
			var configurationOptionIds = store.getters.getConfigurationSettings.productOptionIds;
			var configuratorSteps = state.configurator.steps.all;

			configuratorSteps.forEach(function (step) {
				if (!step.groupId) {
					step.valid = true;
				} else {
					var configurationIncludesGroup = configurationOptionIds.some(function (id) {
						return store.getters.getGroupIdFromOptionId(id) === step.groupId;
					});
					step.valid = configurationIncludesGroup;
				}
			});

			var validOptionSteps = configuratorSteps.filter(function (step) {
				return step.groupId && step.valid;
			});

			var allConfigurableStepsValid = validOptionSteps.length === configurationOptionIds.length;
			var invalidStep = configuratorSteps.find(function (step) {
				return !step.valid;
			});

			if (allConfigurableStepsValid && invalidStep) {
				state.configurator.steps.general.existingConfigurationValidatedSteps = true;
				store.commit("SET_STEP_ACTIVE", invalidStep);
			}
		},
		SET_OFFSET_SUPPORT: function SET_OFFSET_SUPPORT(state, payload) {
			state.config.currentConfigSupportsOffset = payload;
		},
		SET_OFFSET_PRICETABLE: function SET_OFFSET_PRICETABLE(state, payload) {
			state.config.offsetPriceTable = payload;
			EventBus.$emit("finishedOffsetPriceTableFill");
		},
		FINALIZE_EXISTING_CONFIG: function FINALIZE_EXISTING_CONFIG(state) {
			if (state.baseProps.isConfiguration) {
				store.commit("SET_CUSTOM_SIZE", {
					width: state.config.configurationSettings.widthInMm,
					height: state.config.configurationSettings.heightInMm
				});

				if (state.config.configurationSettings.hasOffsetPrintingAmount) {
					store.commit("SET_OFFSET_SELECTED", true);
				}

				store.commit("SET_ORDERLINE_AMOUNT", state.config.configurationSettings.amount);

				EventBus.$once("finishedOffsetPriceTableFill", function () {
					if (state.config.configurationSettings.hasOffsetPrintingAmount) {
						store.commit("SET_CONFIGURATION_OFFSET_PRICE", state.config.configurationSettings.amount);
					}
				});

				store.commit("SET_PAGE_COUNT", state.config.configurationSettings.pages);

				// Reopening an existing configuration never re-runs the upload flow, so
				// state.file.pageCount (only ever set by SET_CONTENT_UPLOAD) would otherwise
				// stay null here. option-item.vue's isPrintSidesCountChoice lock compares the
				// uploaded file's page count against each option's printSideCount, so without
				// this the single/double sided lock silently no-ops for reopened configurations.
				// Only do this once a PDF has actually been uploaded - configurationSettings.pages
				// defaults to the format's minimum page count before that, and setting file.pageCount
				// from that default would lock the sides choice before the customer uploaded anything.
				if (state.config.configurationSettings.hasUpload) {
					state.file.pageCount = state.config.configurationSettings.pages;
				}

				// Same reasoning as above: this derives single/double-sided availability from
				// the page count, so it must not run against the pre-upload default page count.
				if (store.getters.isBookProduct && state.config.configurationSettings.hasUpload) {
					store.commit("SET_PRINTSIDE_AVAILABILITY", state.config.configurationSettings.pages);
				}

				state.configurator.steps.general.configuratorDataValid = true;
				state.configurator.steps.general.existingConfigurationAdded = true;
			}
		},
		SET_FILE_UPLOAD: function SET_FILE_UPLOAD(state, payload) {
			state.file[payload.type] = payload;
			store.commit("RESET_FORMAT_SUGGESTIONS");
			store.commit("RESET_FORMAT_MATCHES");
			store.commit("RESET_CUSTOM_ERROR_MESSAGE", payload.type.toLowerCase());

			if (payload.displayError) {
				store.commit("SET_CUSTOM_ERROR_MESSAGE", payload);
			} else {
				store.commit("SET_" + payload.type.toUpperCase() + "_UPLOAD");
				state.file.uploadSizes[payload.type.toLowerCase()] = payload.uploadSize;
			}
		},
		RESET_FILE_UPLOAD: function RESET_FILE_UPLOAD(state, payload) {
			state.file[payload] = null;
			state.file[payload + "IsUploaded"] = false;

			if (state.file.content === null || state.baseProps.hasSeparateCover && !store.getters.onlyCoverRequired && state.file.cover === null) {
				store.commit("SET_UPLOADS_COMPLETE", false);
				state.file.isCustomSize = false;
			}
		},
		SET_COVER_UPLOAD: function SET_COVER_UPLOAD(state) {
			state.file.coverIsUploaded = true;

			if (store.getters.hasSeparateCover) {
				store.commit("SET_COVER_PRINTSIDE_AVAILABILITY", state.file.cover.isSingleSidedCover);
			}

			if (state.file.contentIsUploaded) {
				store.commit("SET_UPLOAD_SUCCESS");
			}
		},
		SET_CONTENT_UPLOAD: function SET_CONTENT_UPLOAD(state) {
			state.file.contentIsUploaded = true;

			// For hybrid off-the-shelf products the uploaded file is the cover, the content page count stays as configured
			if (!store.getters.onlyCoverRequired) {
				state.file.pageCount = state.file.content.pageCount;
			}

			if (!state.baseProps.hasSeparateCover || store.getters.onlyCoverRequired || state.file.coverIsUploaded) {
				store.commit("SET_UPLOAD_SUCCESS");
			}
		},
		SET_PRINTSIDE_AVAILABILITY: function SET_PRINTSIDE_AVAILABILITY(state, payload) {
			if (store.getters.checkData.hasSelectedFormat) {
				var result = {
					single: false,
					double: false,
					set: true
				};
				var min = state.selectedFormat.minPageCount;
				var minSingle = min / 2;
				var max = state.selectedFormat.maxPageCount;
				var maxSingle = max / 2;

				// 10 niet mogelijk
				if (payload >= minSingle && payload < min) {
					// 12 alleen enkelzijdig mogelijk
					result.single = true;
				} else if (payload >= min && payload <= maxSingle) {
					// 24 enkelzijdig en dubbelzijdig mogelijk
					// 200 enkelzijdig en dubbelzijdig mogelijk
					result.single = true;
					result.double = true;
				} else if (payload > maxSingle && payload <= max) {
					// 400 alleen dubbelzijdig mogelijk. enkelzijdig niet mogelijk
					result.double = true;
				}
				// 402 niet mogelijk

				if (!result.single && !result.double && result.set) {
					state.configuratorData.canSetConfigurationPrice = false;
					store.commit("RESET_ALL_FILE_UPLOADS");

					if (store.getters.getUploaderPosition.before) {
						store.commit("CLEAR_SELECTED_FORMAT");
						store.commit("CHECK_CONFIGURATOR_DATA_VALID");
						store.commit("CONFIGURATOR_STEP_AVAILABLE");
					}

					store.commit("CLEAR_CONFIGURATION_PRICE");
					store.commit("SET_STEP_ACTIVE", "uploader");

					EventBus.$emit("configuratorModal", {
						title: "Ongeldig pagina-aantal geüpload",
						content: "<p>Er zijn " + payload + " pagina's geupload. Dat is een ongeldig aantal pagina's voor dit product. <br>Voor enkelzijdige bedrukking is het minimum " + minSingle + " pagina's en het maximum " + maxSingle + " pagina's. <br>Dubbelzijdige bedrukking heeft een minimum van " + min + " pagina's en maximaal " + max + " pagina's. De uploadvelden zijn gereset zodat u opnieuw kunt uploaden.</p>"
					});

					state.configuratorData.canSetConfigurationPrice = true;
				}

				state.printSidesAvailability = result;
			}
		},
		SET_COVER_PRINTSIDE_AVAILABILITY: function SET_COVER_PRINTSIDE_AVAILABILITY(state, payload) {
			// payload is the IsSingleSidedCover flag the backend already determined at upload time
			// (from the offer's actually available cover print-side options) - unlike the content
			// version above, this is never re-derived from a min/max page-count range client-side,
			// since a cover spec's page count isn't reliably "the doubled value, halve it for single"
			// (e.g. a single-sided-only cover can have its page count stored as the real value already).
			if (payload == null) {
				return;
			}

			state.coverPrintSidesAvailability = {
				single: payload === true,
				double: payload === false,
				set: true
			};
		},
		SET_UPLOADS_COMPLETE: function SET_UPLOADS_COMPLETE(state, payload) {
			if (payload) {
				// Sorry, this exists because there is a race condition that is triggered when uploading a file and pressing next (cover and content)
				if (state.configurator.steps.last().name === "uploader") {
					setTimeout(function () {
						state.configurator.steps.current.data.name = "configurator-overview";
						state.configurator.steps.current.index = state.configurator.steps.all.findIndex(function (s) {
							return s.name === "configurator-overview";
						});
					}, 250);
				}
			}
			state.file.uploadsComplete = payload;
		},
		SET_UPLOAD_SUCCESS: function SET_UPLOAD_SUCCESS(state) {
			var hasError = state.file.customErrorMessages.content !== null || state.file.customErrorMessages.cover !== null;
			var hasFormatSuggestions = state.file.content.suggestions !== null && state.file.content.suggestions.length > 0;
			var specificationIds = state.file.content && state.file.content.specificationIds || [];

			if (!hasError) {
				store.commit("SET_UPLOADS_COMPLETE", true);
				store.commit("SET_STEP_VALID");
			}
			store.commit("CONFIGURATOR_STEP_AVAILABLE");

			if (specificationIds.length === 1) {
				if (state.file.content) {
					state.file.isCustomSize = state.selectedProduct.specifications.find(function (f) {
						return f.id === specificationIds[0];
					}).isCustomSize;
				}

				if (!state.file.isCustomSize) {
					store.commit("SET_SELECTED_FORMAT", specificationIds[0]);
				} else {
					if (store.getters.getUploaderPosition.before) {
						if (hasFormatSuggestions) {
							store.commit("SET_FORMAT_SUGGESTIONS", state.file.content.suggestions);
						}
						store.commit("SET_MATCHED_CUSTOMSIZE_FORMAT_SUGGESTION", specificationIds[0]);
					} else {
						store.commit("SET_SELECTED_FORMAT", specificationIds[0]);
					}
				}
			} else if (specificationIds.length > 1) {
				store.commit("SET_SELECTED_FORMAT", null);

				var payload = [];
				specificationIds.forEach(function (x) {
					state.selectedProduct.specifications.forEach(function (s) {
						if (s.id === x) {
							payload.push(s);
						}
					});
				});
				store.commit("SET_FORMAT_MATCHES", payload);

				if (hasFormatSuggestions) {
					store.commit("SET_FORMAT_SUGGESTIONS", state.file.content.suggestions);
				}
			}

			store.commit("SET_ALTERED_PAGE_COUNT");

			if (store.getters.checkData.hasSelectedFormat) {
				store.dispatch("_getConfigurationPrice");
			}
		},
		SET_MATCHED_CUSTOMSIZE_FORMAT_SUGGESTION: function SET_MATCHED_CUSTOMSIZE_FORMAT_SUGGESTION(state, payload) {
			state.file.matchedCustomSizeFormat = payload;
		},
		RESET_MATCHED_CUSTOMSIZE_FORMAT_SUGGESTION: function RESET_MATCHED_CUSTOMSIZE_FORMAT_SUGGESTION(state) {
			state.file.matchedCustomSizeFormat = null;
		},
		SET_UPLOAD_SESSION_GUID: function SET_UPLOAD_SESSION_GUID(state, payload) {
			state.file.uploadSessionGuid = payload;
		},
		SET_CUSTOM_ERROR_MESSAGE: function SET_CUSTOM_ERROR_MESSAGE(state, payload) {
			state.file.customErrorMessages[payload.type] = payload.message;
			state.file.uploadSizes[payload.type.toLowerCase()] = payload.uploadSize;

			var specificationIds = state.file.content && state.file.content.specificationIds || [];
			if (specificationIds.length === 1) {
				store.commit("SET_UPLOAD_SUCCESS");
			}

			if (payload.suggestions !== null && payload.suggestions.length > 0) {
				store.commit("SET_FORMAT_SUGGESTIONS", payload.suggestions);
			}
		},
		SET_QUOTATION_RESPONSE: function SET_QUOTATION_RESPONSE(state, payload) {
			store.state.quotationResponse = payload;
		},
		RESET_CUSTOM_ERROR_MESSAGE: function RESET_CUSTOM_ERROR_MESSAGE(state, payload) {
			state.file.customErrorMessages[payload] = null;
		},
		SET_MAIN_PREVIEW_URL: function SET_MAIN_PREVIEW_URL(state, payload) {
			state.order.thumbnailUrl = payload;
		},
		FINAL_STEP_EXISTING_CONFIG: function FINAL_STEP_EXISTING_CONFIG(state) {
			state.configurator.steps.general.existingConfigurationIsFinalized = true;

			if (!state.configuratorData.canSetConfigurationPrice) {
				EventBus.$once("finishedOffsetPriceTableFill", function () {
					state.configuratorData.canSetConfigurationPrice = true;
				});
			}
		},
		SET_BOUNDING_RECT: function SET_BOUNDING_RECT(state, payload) {
			state.configurator.boundaries = payload;
		},
		SET_VIEWPORT_INFO: function SET_VIEWPORT_INFO(state, payload) {
			var breakPoint = {
				s: 480,
				ms: 720,
				m: 1000,
				l: 1200
			};

			state.viewPort = {
				width: payload,
				s: payload <= breakPoint.s,
				ms: payload <= breakPoint.ms,
				m: payload <= breakPoint.m,
				l: payload <= breakPoint.l,
				xl: payload > breakPoint.l
			};
		},
		SET_SPECIFICATION_ID: function SET_SPECIFICATION_ID(state, payload) {
			state.baseProps = extends_default()({}, state.baseProps, { specificationId: payload });
		},
		SET_IS_SPECIFICATION_CONFIGURATION: function SET_IS_SPECIFICATION_CONFIGURATION(state, payload) {
			state.baseProps = extends_default()({}, state.baseProps, { isSpecificationConfiguration: payload });
		},
		SET_PRESELECTED_QUANTITY: function SET_PRESELECTED_QUANTITY(state, payload) {
			state.baseProps = extends_default()({}, state.baseProps, { preselectedQuantity: payload });
		}
	},
	actions: {
		_SetProductData: function _SetProductData() {
			var _this = this;

			var getFrontIdData = function () {
				var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(frontId) {
					var result;
					return regenerator_default.a.wrap(function _callee3$(_context3) {
						while (1) {
							switch (_context3.prev = _context3.next) {
								case 0:
									_context3.next = 2;
									return vue_esm["a" /* default */].http.get(CONFIG.HOST + apiUrl + frontId + "/");

								case 2:
									result = _context3.sent;


									productData.push(result.body);

									if (productData.length === frontIds.length) {
										store.commit("SET_PRODUCT_DATA", productData);
										store.commit("SET_CONFIGURATOR_PRODUCT_DATA");

										if (store.state.baseProps.isConfiguration) {
											store.commit("SET_EXISTING_CONFIGURATION_SELECTED");
										}
									}

								case 5:
								case "end":
									return _context3.stop();
							}
						}
					}, _callee3, this);
				}));

				return function getFrontIdData(_x2) {
					return _ref5.apply(this, arguments);
				};
			}();

			var apiUrl = "configurator/get-product-front/";
			var frontIds = store.state.baseProps.productFrontId;
			var productData = [];

			if (store.state.baseProps.isConfiguration) {
				if (!store.state.configurator.steps.general.existingConfigurationAdded) {
					vue_esm["a" /* default */].http.get(CONFIG.HOST + "configurator/api/get/" + store.state.baseProps.configId + "/").then(function () {
						var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(response) {
							var result;
							return regenerator_default.a.wrap(function _callee$(_context) {
								while (1) {
									switch (_context.prev = _context.next) {
										case 0:
											result = JSON.parse(response.bodyText);

											store.commit("SET_EXISTING_CONFIGURATION_DATA", result);

											_context.next = 4;
											return getFrontIdData(result.productFrontId);

										case 4:
										case "end":
											return _context.stop();
									}
								}
							}, _callee, _this);
						}));

						return function (_x) {
							return _ref3.apply(this, arguments);
						};
					}());
				}
			} else if (store.state.baseProps.isFront) {
				if (store.state.baseProps.specificationId) {
					promise_default.a.all(frontIds.map(function (id) {
						return getFrontIdData(id);
					})).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
						return regenerator_default.a.wrap(function _callee2$(_context2) {
							while (1) {
								switch (_context2.prev = _context2.next) {
									case 0:
										return _context2.abrupt("return", preselectConfiguratorItems(frontIds, productData));

									case 1:
									case "end":
										return _context2.stop();
								}
							}
						}, _callee2, _this);
					})));
				} else {
					frontIds.forEach(getFrontIdData);
				}
			}
		},
		_getConfigurationPrice: function _getConfigurationPrice() {
			var isValidIfCustomSize = !store.state.selectedFormat.isCustomSize || store.state.customSizeValid;

			var hasValidConfiguration = store.getters.checkData.hasSelectedFormat && store.getters.checkData.hasSelectedProduct && store.getters.getConfiguratorData.canSetConfigurationPrice && isValidIfCustomSize;

			if (hasValidConfiguration) {
				if (!store.state.orderLine.isOffset && store.getters.hasDigitalAvailable) {
					var payload = store.getters.getCalculationPayload;
					store.state.loading.price = true;

					clearTimeout(store.state.throttle.amount);

					store.state.throttle.amount = setTimeout(function () {
						payload.amount = store.state.orderLine.amount;

						vue_esm["a" /* default */].http.post(CONFIG.HOST + "configurator/calculate-price-sdwn/", payload).then(function (result) {
							store.commit("SET_CONFIGURATION_PRICE", JSON.parse(result.bodyText));
							store.state.loading.price = false;
						});
					}, 300);
				}
			}
		},
		_getPriceTable: function _getPriceTable() {
			var hasValidConfiguration = store.getters.checkData.hasSelectedFormat && store.getters.checkData.hasSelectedProduct && store.getters.isConfiguratorDataValid;

			if (hasValidConfiguration) {
				var payload = store.getters.getCalculationPayload;
				var priceTable = [];
				var amountData = store.getters.getAmountData;

				amountData.amountList.forEach(function (amount) {
					payload.amount = amount;
					var tableRow = {
						amount: amount,
						default: {},
						rush: {}
					};

					vue_esm["a" /* default */].http.post(CONFIG.HOST + "configurator/calculate-price-sdwn/", payload).then(function (result) {
						var data = JSON.parse(result.bodyText);

						tableRow.default = data;
						tableRow.default.singlePrice = data.PriceWithoutTax / amount;
						tableRow.default.singlePriceWithTax = data.PriceWithTax / amount;

						if (store.getters.isRushOrderAvailable) {
							var rushPrice = data.PriceWithoutTax * store.state.selectedProduct.rushOrderCostPercentage + data.PriceWithoutTax;
							var rushPriceWithTax = data.PriceWithTax * store.state.selectedProduct.rushOrderCostPercentage + data.PriceWithTax;

							tableRow.rush.PriceWithoutTax = rushPrice;
							tableRow.rush.PriceWithTax = rushPriceWithTax;
							tableRow.rush.singlePrice = rushPrice / amount;
							tableRow.rush.singlePriceWithTax = rushPriceWithTax / amount;
						}
					});
					priceTable.push(tableRow);
				});

				store.commit("SET_PRICE_TABLE", priceTable);
			}
		},
		_getOffsetPriceTable: function _getOffsetPriceTable() {
			return new promise_default.a(function (resolve, reject) {
				if (store.state.selectedFormat.offsetPricings.length > 0) {
					var relevantOptionIds = store.state.selectedOptions.map(function (option) {
						return option.baseOptionId;
					}).filter(function (id) {
						return id != null;
					});

					var availableOffsetPricings = store.state.selectedFormat.offsetPricings.find(function (pricings) {
						if (pricings.optionIds.every(function (id) {
							return relevantOptionIds.includes(id);
						})) {
							return pricings;
						}
					});

					if (availableOffsetPricings) {
						store.commit("SET_OFFSET_SUPPORT", true);
						store.commit("SET_OFFSET_SKU_ID", availableOffsetPricings.id);
						var url = CONFIG.HOST + "configurator/get-offset-price-list/" + availableOffsetPricings.id + "/";
						vue_esm["a" /* default */].http.get(url).then(function (result) {
							var offsetPriceTableWithSinglePrice = result.body.offSetPrices.map(function (pricing) {
								pricing.Single = pricing.Price / pricing.Amount;
								return pricing;
							});

							store.commit("SET_OFFSET_PRICETABLE", offsetPriceTableWithSinglePrice);

							resolve();
						});
					} else {
						store.commit("SET_OFFSET_SUPPORT", false);
						resolve();
					}
				}
			});
		},
		_sendQuotationMail: function _sendQuotationMail(context, data) {
			var hasValidConfiguration = store.getters.checkData.hasSelectedFormat && store.getters.checkData.hasSelectedProduct && store.getters.isConfiguratorDataValid;

			if (hasValidConfiguration) {
				var payload = store.getters.getPostConfig;

				vue_esm["a" /* default */].http.post(CONFIG.HOST + "configurator/save-configuration/", payload).then(function (result) {
					var quotationMailPayload = {
						configurationPublicId: result.data.configurationId,
						email: data.email,
						phoneNumber: data.phoneNumber,
						amount: data.amount,
						recaptchaToken: data.recaptchaToken
					};
					vue_esm["a" /* default */].http.post(CONFIG.HOST + "quotation/quote-confirmation-submit/", null, {
						params: quotationMailPayload
					});
					store.commit("SET_QUOTATION_RESPONSE", result);
				}, function (err) {
					store.commit("SET_QUOTATION_RESPONSE", err);
				});
			}
		},
		_createConfiguration: function _createConfiguration() {
			var existingPublicId = store.getters.getUploadSessionGuid;
			var selectedFormat = store.getters.getSelectedFormat;
			var specificationId = selectedFormat && selectedFormat.id ? selectedFormat.id : null;
			var selectedProduct = store.getters.getSelectedProduct;
			var productFrontId = selectedProduct ? selectedProduct.id : store.state.baseProps.productFrontId[0];
			var customSize = store.getters.getCustomSize;
			var pageCount = store.getters.getPageCount;

			var params = [];
			if (existingPublicId) {
				params.push("publicId=" + existingPublicId);
			}
			if (specificationId) {
				params.push("specificationId=" + specificationId);
			}
			if (productFrontId) {
				params.push("productFrontId=" + productFrontId);
			}
			if (customSize && customSize.width) {
				params.push("customWidth=" + customSize.width);
			}
			if (customSize && customSize.height) {
				params.push("customHeight=" + customSize.height);
			}
			if (pageCount) {
				params.push("pageCount=" + pageCount);
			}

			var url = CONFIG.HOST + "configurator/create-configuration/" + (params.length > 0 ? "?" + params.join("&") : "");

			return vue_esm["a" /* default */].http.get(url).then(function (result) {
				store.commit("SET_UPLOAD_SESSION_GUID", result.body);
				return result;
			});
		},
		_saveConfiguration: function _saveConfiguration() {
			var hasValidConfiguration = store.getters.checkData.hasSelectedFormat && store.getters.checkData.hasSelectedProduct && store.getters.isConfiguratorDataValid;

			if (!hasValidConfiguration) {
				return promise_default.a.resolve(null);
			}

			var payload = store.getters.getPostConfig;
			return vue_esm["a" /* default */].http.post(CONFIG.HOST + "configurator/save-configuration", payload);
		},
		_postConfiguration: function _postConfiguration() {
			var hasValidConfiguration = store.getters.checkData.hasSelectedFormat && store.getters.checkData.hasSelectedProduct && store.getters.isConfiguratorDataValid;

			if (hasValidConfiguration) {
				store.dispatch("_saveConfiguration").then(function (result) {
					if (result.data.statusCode !== 400) {
						vue_esm["a" /* default */].http.get(CONFIG.HOST + "configurations/add-to-cart/", {
							params: {
								publicId: result.data.configurationId,
								isConfigurator: true
							}
						}).then(function () {
							store.commit("SET_ORDER", {
								success: true,
								message: "Het product is toegevoegd aan uw winkelwagen"
							});

							if (store.getters.getOrderLine.isRush) {
								vue_esm["a" /* default */].http.post(CONFIG.HOST + "configurator/set-rush-order/", { isRushOrder: true });
							}

							try {
								ga("send", "event", "configurator", "toegevoegd aan winkelwagen"); // eslint-disable-line no-undef
							} finally {
								setTimeout(function () {
									window.location.href = CONFIG.HOST + "carts/step-one/";
								}, 500);
							}
						}, function (error) {
							console.error(error);
							store.commit("SET_ORDER", {
								success: false,
								message: "Er is een fout opgetreden; het product toevoegen aan de winkelwagen is niet gelukt. [error:3]"
							});
						});
					} else {
						console.error("Status 400");
						store.commit("SET_ORDER", {
							success: false,
							message: "De configuratie kan niet worden opgeslagen. [error:2]"
						});
					}
				}, function (error) {
					console.error(error);
					store.commit("SET_ORDER", {
						success: false,
						message: "Kan geen verbinding tot stand brengen met de server. [error:1]"
					});
				});
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/element/modal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var modal = ({
	name: "Modal",
	props: {
		title: {
			type: String,
			default: ""
		},
		buttonStyle: {
			type: String,
			default: "button"
		},
		buttonText: {
			type: String,
			default: "Informatie"
		},
		open: {
			type: Boolean,
			default: false
		},
		modalStyle: {
			type: String,
			default: ""
		},
		buttonClass: {
			type: String,
			default: ""
		},
		holderClass: {
			type: String,
			default: ""
		}
	},
	data: function data() {
		return {
			active: false
		};
	},

	computed: {
		showFooter: function showFooter() {
			return !["styled", "plain"].includes(this.modalStyle) || !!this.$slots.footer;
		}
	},
	methods: {
		openModal: function openModal() {
			this.active = true;
			this._savedOverflow = document.documentElement.style.overflow;
			document.documentElement.style.overflow = "hidden";
		},
		closeModal: function closeModal() {
			this.active = false;
			document.documentElement.style.overflow = this._savedOverflow || "";
			this._savedOverflow = null;
		},
		dismiss: function dismiss() {
			this.$emit("close");
			this.closeModal();
		}
	},
	watch: {
		open: function open(a, b) {
			if (a) {
				this.openModal();
			} else {
				this.closeModal();
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7af06b0c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.holderClass},[(_vm.buttonStyle != 'none')?[(_vm.buttonStyle == 'tooltip')?_c('button',{staticClass:"tool-tip__label tool-tip__label--absolute",class:_vm.buttonClass,attrs:{"title":_vm.title},on:{"click":_vm.openModal}},[_vm._v("i")]):_vm._e(),_vm._v(" "),(_vm.buttonStyle == 'button')?_c('button',{staticClass:"button",class:_vm.buttonClass,attrs:{"title":_vm.title},on:{"click":_vm.openModal}},[_vm._v(_vm._s(_vm.buttonText))]):_vm._e(),_vm._v(" "),(_vm.buttonStyle == 'descriptionButton')?_c('button',{staticClass:"description__button",class:_vm.buttonClass,attrs:{"title":_vm.title},on:{"click":_vm.openModal}},[_vm._v(_vm._s(_vm.buttonText))]):_vm._e(),_vm._v(" "),(_vm.buttonStyle == 'custom')?_c('p',{staticClass:"cursor-pointer",class:_vm.buttonClass,attrs:{"title":_vm.title},on:{"click":_vm.openModal}},[_vm._v(_vm._s(_vm.buttonText))]):_vm._e(),_vm._v(" "),(_vm.buttonStyle == 'inline')?_c('span',{staticClass:"text-link--underline cursor-pointer",class:_vm.buttonClass,attrs:{"title":_vm.title},on:{"click":function($event){$event.stopPropagation();return _vm.openModal.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.buttonText))]):_vm._e()]:_vm._e(),_vm._v(" "),_vm._t("button"),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.active)?_c('div',{staticClass:"configurator-modal",class:{ 'configurator-modal--styled' : _vm.modalStyle == 'styled'}},[_c('div',{staticClass:"modal-backdrop",on:{"click":_vm.dismiss}}),_vm._v(" "),_c('div',{staticClass:"modal-holder"},[_c('div',{staticClass:"modal-inner"},[_c('div',{staticClass:"modal-header",class:{ 'modal-header--plain' : ['styled','plain'].includes(_vm.modalStyle)}},[_c('div',[(_vm.title != '')?_c('div',{staticClass:"h2 modal-title",class:{ 'title--dot' : _vm.modalStyle == 'styled'}},[_vm._v(_vm._s(_vm.title))]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"modal-close",on:{"click":_vm.dismiss}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"modal-content",class:{'modal-content--styled' : _vm.modalStyle == 'styled'}},[_vm._t("default")],2),_vm._v(" "),(_vm.showFooter)?_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"button button--grey-light",on:{"click":_vm.closeModal}},[_vm._v("Sluiten")])]})],2):_vm._e()])])]):_vm._e()])],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/element/modal.vue
function injectStyle (context) {
  __webpack_require__("rtms")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var element_modal = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/element/price.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var element_price = ({
	name: "Price",
	props: {
		overview: {
			type: Boolean,
			default: false
		},
		smaller: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		hasPrice: function hasPrice() {
			return this.$store.getters.getPrice.PriceWithoutTax != null;
		},
		inclTaxOnly: function inclTaxOnly() {
			// data-prices-incl-tax-only="true" on the mount div hides the
			// (excl. BTW) row and promotes the (incl. BTW) value to large
			// styling. SDW opts in; DWN omits the attribute.
			return this.$store.state.baseProps.pricesInclTaxOnly === "true";
		},
		priceInfo: function priceInfo() {
			return this.$store.getters.getPrice;
		},
		priceExtra: function priceExtra() {
			return this.$store.getters.getPriceExtra;
		},
		currentStep: function currentStep() {
			return this.$store.getters.getCurrentStep.data.name;
		},
		getOrderLine: function getOrderLine() {
			return this.$store.getters.getOrderLine;
		}
	},
	methods: {
		formatPrice: function formatPrice(price) {
			if (price) {
				return Helper.toCurrencyString(price);
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d4e8d62","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/price.vue
var price_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPrice && _vm.priceInfo.PriceWithoutTax !== null)?_c('div',{staticClass:"price-holder"},[(!_vm.inclTaxOnly)?_c('div',{staticClass:"grid grid--1-2"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cell price-holder__cell"},[_c('p',{staticClass:"price-holder__price-large"},[(!_vm.getOrderLine.isRush)?[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.formatPrice(_vm.priceInfo.PriceWithoutTax))+"\n\t\t\t\t")]:_vm._e(),_vm._v(" "),(_vm.getOrderLine.isRush)?[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.formatPrice(_vm.priceExtra.rushPrice))+"\n\t\t\t\t")]:_vm._e()],2)])]):_vm._e(),_vm._v(" "),(_vm.inclTaxOnly || (!_vm.getOrderLine.isRush && !_vm.getOrderLine.isOffset))?_c('div',{staticClass:"grid grid--1-2"},[_c('div',{staticClass:"cell price-holder__cell"},[(!_vm.inclTaxOnly)?_c('p',{staticClass:"price-holder__price--btw"},[_vm._v("(incl. BTW)")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cell price-holder__cell"},[_c('p',{class:_vm.inclTaxOnly ? 'price-holder__price-large' : 'price-holder__price'},[(_vm.inclTaxOnly && _vm.getOrderLine.isRush && _vm.priceExtra.rushPriceWithTax)?[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.formatPrice(_vm.priceExtra.rushPriceWithTax))+"\n\t\t\t\t")]:[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.formatPrice(_vm.priceInfo.PriceWithTax))+"\n\t\t\t\t")]],2)])]):_vm._e(),_vm._v(" "),(_vm.getOrderLine.isOffset)?_c('p',{staticClass:"price-holder__price price-holder__price--red"},[_vm._v("offset\n\t")]):_vm._e(),_vm._v(" "),(_vm.getOrderLine.isRush)?_c('p',{staticClass:"price-holder__price price-holder__price--red"},[_vm._v("spoedlevering\n\t")]):_vm._e()]):_vm._e()}
var price_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell price-holder__cell"},[_c('p',{staticClass:"price-holder__price--btw"},[_vm._v("(excl. BTW)")])])}]

// CONCATENATED MODULE: ./src/components/element/price.vue
function price_injectStyle (context) {
  __webpack_require__("kAG1")
}
/* script */


/* template */

/* template functional */
var price___vue_template_functional__ = false
/* styles */
var price___vue_styles__ = price_injectStyle
/* scopeId */
var price___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var price___vue_module_identifier__ = null

var price_Component = Object(component_normalizer["a" /* default */])(
  element_price,
  price_render,
  price_staticRenderFns,
  price___vue_template_functional__,
  price___vue_styles__,
  price___vue_scopeId__,
  price___vue_module_identifier__
)

/* harmony default export */ var components_element_price = (price_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/element/price-amount.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var price_amount = ({
	name: "PriceAmount",
	computed: {
		hasPrice: function hasPrice() {
			return this.$store.getters.getPrice.PriceWithoutTax != null;
		},
		priceInfo: function priceInfo() {
			return this.$store.getters.getPrice;
		},
		getOrderLine: function getOrderLine() {
			return this.$store.getters.getOrderLine;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e66fdc24","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/price-amount.vue
var price_amount_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPrice && _vm.priceInfo.PriceWithoutTax !== null)?_c('div',{staticClass:"h3 configurator-additional-info"},[_vm._v("\n\tOplage: "),_c('strong',[_vm._v(_vm._s(_vm.getOrderLine.amount))])]):_vm._e()}
var price_amount_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/element/price-amount.vue
/* script */


/* template */

/* template functional */
var price_amount___vue_template_functional__ = false
/* styles */
var price_amount___vue_styles__ = null
/* scopeId */
var price_amount___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var price_amount___vue_module_identifier__ = null

var price_amount_Component = Object(component_normalizer["a" /* default */])(
  price_amount,
  price_amount_render,
  price_amount_staticRenderFns,
  price_amount___vue_template_functional__,
  price_amount___vue_styles__,
  price_amount___vue_scopeId__,
  price_amount___vue_module_identifier__
)

/* harmony default export */ var element_price_amount = (price_amount_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/element/price-pages.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var price_pages = ({
	name: "PriceAmount",
	computed: {
		pageCount: function pageCount() {
			return this.$store.getters.getPageCount;
		},
		isPrintSidesCountChoice: function isPrintSidesCountChoice() {
			return this.$store.getters.isPrintSidesCountChoice;
		},
		showPageCount: function showPageCount() {
			return !this.isPrintSidesCountChoice && this.pageCount != null && this.pageCount > 1;
		},
		allPageCounts: function allPageCounts() {
			return this.$store.getters.getAllPageCounts;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16e988a7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/price-pages.vue
var price_pages_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPageCount)?_c('h3',{staticClass:"configurator-additional-info"},[_c('strong',[_vm._v(_vm._s(_vm.pageCount))]),_vm._v(" pagina's "),(_vm.allPageCounts.altered)?_c('span',[_vm._v("("+_vm._s(_vm.allPageCounts.file)+" pdf-pagina's)")]):_vm._e()]):_vm._e()}
var price_pages_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/element/price-pages.vue
/* script */


/* template */

/* template functional */
var price_pages___vue_template_functional__ = false
/* styles */
var price_pages___vue_styles__ = null
/* scopeId */
var price_pages___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var price_pages___vue_module_identifier__ = null

var price_pages_Component = Object(component_normalizer["a" /* default */])(
  price_pages,
  price_pages_render,
  price_pages_staticRenderFns,
  price_pages___vue_template_functional__,
  price_pages___vue_styles__,
  price_pages___vue_scopeId__,
  price_pages___vue_module_identifier__
)

/* harmony default export */ var element_price_pages = (price_pages_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/element/spine.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var element_spine = ({
	name: "Spine",
	components: {
		pricePages: element_price_pages
	},
	props: {
		table: {
			type: Boolean,
			default: false
		},
		navigation: {
			type: Boolean,
			default: false
		},
		inline: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		selectedOptions: function selectedOptions() {
			return this.$store.getters.getSelectedOptions;
		},
		selectedFormat: function selectedFormat() {
			return this.$store.getters.getSelectedFormat;
		},
		pageCount: function pageCount() {
			return this.$store.getters.getPageCount;
		},
		printSidesCount: function printSidesCount() {
			return this.$store.getters.getPrintSidesCount;
		},
		allPageCounts: function allPageCounts() {
			return this.$store.getters.getAllPageCounts;
		},
		spine: function spine() {
			var spine = 0;
			var hasHardOrSoftCover = true;

			var productType = {
				default: 0,
				hardCover: 1,
				softCover: 2,
				flatLying: 4,
				cartBoardbudget: 5,
				cartBoardPermium: 6
			};
			// Let op: wanneer vlakliggend hier bij komt moet er een extra berekening komen met basethickness 13

			var chunkType = {
				cover: 0,
				content: 1
			};

			var optionCategory = {
				default: 0,
				paper: 1,
				print: 2,
				finish: 3,
				material: 4
			};
			var paperSelected = false;

			for (var i in this.selectedOptions) {
				var selectedOption = this.selectedOptions[i];
				var productOptionGroup = this.selectedFormat.productOptionGroups[i];
				var hasSelectedPaperThickness = productOptionGroup && productOptionGroup.optionCategory === optionCategory.paper && productOptionGroup.chunkType === chunkType.content;
				var isThicknessForTwoPages = this.selectedFormat.productType === productType.hardCover || this.selectedFormat.productType === productType.softCover;

				if (selectedOption && hasSelectedPaperThickness) {
					var pageCount = Math.max(0, this.pageCount - 24);

					if (isThicknessForTwoPages) {
						pageCount /= 2;
					}

					spine += pageCount * selectedOption.sheetThickness;
				}

				if (productOptionGroup.optionCategory === optionCategory.paper) {
					paperSelected = true;
				}
			}

			if (this.selectedFormat.productType === productType.hardCover) {
				spine += 6;
			} else if (this.selectedFormat.productType === productType.softCover) {
				spine += 3;
			} else if (this.selectedFormat.productType === productType.flatLying) {
				spine += 9.5;
			} else if (this.selectedFormat.productType === productType.cartBoardbudget) {
				spine = this.pageCount / 2 * 1.03 + 2;
			} else if (this.selectedFormat.productType === productType.cartBoardPermium) {
				spine = (this.pageCount / 2 + 1) * 1.97 + 2;
			} else {
				return null;
			}

			if (this.selectedFormat.productType === productType.hardCover || this.selectedFormat.productType === productType.flatLying) {
				var possibleBacks = {
					7: 8.7,
					10: 10.7,
					12: 13.7,
					14: 15.7,
					17: 18.7,
					20: 21.7,
					22: 23.7,
					24: 25.7,
					27: 28.7,
					30: 31.7,
					33: 34.7,
					36: 37.7,
					39: 40.7,
					42: 43.7,
					45: 46.7
				};

				var roundedSpine = keys_default()(possibleBacks).find(function (key) {
					return spine < possibleBacks[key];
				});

				if (roundedSpine) {
					spine = parseInt(roundedSpine);
				}
			}

			if (hasHardOrSoftCover && paperSelected) {
				return Math.ceil(spine);
			}

			return null;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39a4a47c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/spine.vue
var spine_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.navigation && _vm.spine != null)?_c('h3',{staticClass:"configurator-additional-info"},[_vm._v("\n\tRugdikte:\n\t"),_c('strong',[_vm._v(_vm._s(_vm.spine)+" mm")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.pageCount)+" pag. "),(_vm.allPageCounts.altered)?_c('span',[_vm._v(" / "+_vm._s(_vm.allPageCounts.file)+" pdf-pag.")]):_vm._e()])]):(_vm.table && _vm.spine != null)?_c('div',{staticClass:"cell"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"configurator-overview__option-name"},[_vm._v("\n\t\t"+_vm._s(_vm.spine)+" mm\n\t\t"),_c('strong',[_vm._v(_vm._s(_vm.pageCount)+" pag. "),(_vm.allPageCounts.altered)?_c('span',[_vm._v(" / "+_vm._s(_vm.allPageCounts.file)+" pdf-pag.")]):_vm._e()])])]):(_vm.inline && _vm.spine != null)?_c('span',[_vm._v("\n\tRugdikte: "+_vm._s(_vm.spine)+"mm,\n")]):(_vm.spine != null)?_c('h3',[_vm._v("\n\tRugdikte:\n\t"),_c('span',[_vm._v("\n\t\t"+_vm._s(_vm.spine)+" mm\n\t\t"),_c('strong',[_vm._v(_vm._s(_vm.pageCount)+" pag. "),(_vm.allPageCounts.altered)?_c('span',[_vm._v(" / "+_vm._s(_vm.allPageCounts.file)+" pdf-pag.")]):_vm._e()])])]):(_vm.navigation)?_c('price-pages'):_vm._e()}
var spine_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"configurator-overview__option"},[_c('strong',[_vm._v("Rugdikte:")])])}]

// CONCATENATED MODULE: ./src/components/element/spine.vue
/* script */


/* template */

/* template functional */
var spine___vue_template_functional__ = false
/* styles */
var spine___vue_styles__ = null
/* scopeId */
var spine___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var spine___vue_module_identifier__ = null

var spine_Component = Object(component_normalizer["a" /* default */])(
  element_spine,
  spine_render,
  spine_staticRenderFns,
  spine___vue_template_functional__,
  spine___vue_styles__,
  spine___vue_scopeId__,
  spine___vue_module_identifier__
)

/* harmony default export */ var components_element_spine = (spine_Component.exports);

// CONCATENATED MODULE: ./src/helpers/tracking.js




var EVENT_PREFIX = "configurator_";

var Events = {
	INIT: "init",
	SELECT_OPTION: "select_option",
	SELECT_PRODUCT: "select_product",
	SELECT_SIZE: "select_size",
	CHANGE_QUANTITY: "change_quantity",
	ADD_TO_CART: "add_to_cart"
};

var tracking_pushEvent = function pushEvent(event, data) {
	if (typeof window === "undefined" || !window) {
		return;
	}

	if (!window.dataLayer) window.dataLayer = [];

	window.dataLayer.push({
		event: "" + EVENT_PREFIX + event,
		custom_event: "" + EVENT_PREFIX + event,
		customDimensions: stringify_default()({
			"UserSegment": "configurator"
		}),
		details: data ? tracking_formatDetails(data) : "{}"
	});

	window.dataLayer.push({ event: null, details: null, customDimensions: null });
};

var tracking_formatDetails = function formatDetails(details) {
	var formattedDetails = {};

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = get_iterator_default()(entries_default()(details)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _ref = _step.value;

			var _ref2 = slicedToArray_default()(_ref, 2);

			var key = _ref2[0];
			var value = _ref2[1];

			formattedDetails[key] = String(value);
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return stringify_default()(formattedDetails);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator-navigation-buttons.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var configurator_navigation_buttons = ({
	name: "ConfiguratorNavigationButtons",
	components: {
		modal: element_modal,
		price: components_element_price,
		spine: components_element_spine,
		priceAmount: element_price_amount,
		pricePages: element_price_pages
	},
	props: {
		name: {
			type: String,
			default: ""
		}
	},
	data: function data() {
		return {
			openModal: false,
			disableOrderButton: false,
			autoScrollDebounce: 0,
			referenceDivContainer: null,
			hasSelectedOrderLineAmount: false
		};
	},

	computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])(["baseProps"]), {
		getOrder: function getOrder() {
			return this.$store.getters.getOrder;
		},
		stepClass: function stepClass() {
			return this.getAvailableSteps.next ? "button--cta" : "button--grey";
		},
		getAllSteps: function getAllSteps() {
			return this.$store.getters.getAllSteps;
		},
		getCurrentStep: function getCurrentStep() {
			return this.$store.getters.getCurrentStep;
		},
		getNextStep: function getNextStep() {
			return this.getAllSteps[this.getCurrentStep.index + 1] || null;
		},
		stepActive: function stepActive() {
			if (this.getCurrentStep.index >= keys_default()(this.getAllSteps).length) {
				return false;
			}
			return this.getAllSteps[this.getCurrentStep.index].name === this.name;
		},
		getAvailableSteps: function getAvailableSteps() {
			return this.$store.getters.getStepsAvailability;
		},
		isOffTheShelf: function isOffTheShelf() {
			return this.$store.getters.isOffTheShelf;
		},
		isOverviewStep: function isOverviewStep() {
			return this.$store.getters.getCurrentStep.data.name === "configurator-overview";
		},
		isUploadStep: function isUploadStep() {
			return this.$store.getters.getCurrentStep.data.name === "uploader";
		},
		isPriceTableStep: function isPriceTableStep() {
			return this.$store.getters.getCurrentStep.data.name === "price-table";
		},
		uploadsComplete: function uploadsComplete() {
			return this.$store.getters.uploadsAreComplete;
		},
		getPayload: function getPayload() {
			return this.$store.getters.getCalculationPayload;
		},
		configuratorType: function configuratorType() {
			return this.$store.getters.getConfiguratorType;
		},
		isConfiguratorDataValid: function isConfiguratorDataValid() {
			return this.$store.getters.isConfiguratorDataValid;
		},
		checkData: function checkData() {
			return this.$store.getters.checkData;
		},
		isLastUploadStep: function isLastUploadStep() {
			return this.isConfiguratorDataValid && this.isUploadStep && this.checkData.hasSelectedFormat && this.checkData.hasSelectedOptions;
		},
		configuratorData: function configuratorData() {
			return this.$store.getters.getConfiguratorData;
		},
		loadingPrice: function loadingPrice() {
			return this.$store.getters.getLoader.price;
		},
		hasPrice: function hasPrice() {
			return this.$store.getters.getPrice.PriceWithoutTax != null;
		},
		optionGroups: function optionGroups() {
			var optionGroups = this.$store.getters.getSelectedFormat.productOptionGroups;
			return optionGroups.sort(function (a, b) {
				return a.index - b.index;
			});
		},
		unavailableOptions: function unavailableOptions() {
			return this.$store.getters.getUnavailableOptions;
		},
		canShowPriceDueToCustomSize: function canShowPriceDueToCustomSize() {
			var isCustomSize = this.$store.getters.getSelectedFormat.isCustomSize;
			var validCustomSize = this.$store.getters.getCustomSizeValid;

			return isCustomSize ? isCustomSize && validCustomSize : true;
		},
		getOrderLine: function getOrderLine() {
			return this.$store.getters.getOrderLine;
		},
		editorUrl: function editorUrl() {
			var format = this.$store.getters.getSelectedFormat;

			if (!format || !this.baseProps.specifications) {
				return null;
			}

			var specification = this.baseProps.specifications.find(function (s) {
				return s.id === format.id;
			});

			if (!specification) {
				return null;
			}

			return specification.editorUrl;
		}
	}),
	methods: {
		stepExists: function stepExists(stepToCheck) {
			return this.$store.getters.getStepExists(stepToCheck);
		},

		setStepActive: function setStepActive(step) {
			if (this.stepExists(step).bool) {
				this.$store.commit("SET_STEP_ACTIVE", step);
			}
		},
		checkNextStep: function checkNextStep() {
			if (this.getNextStep.name === "select-format" && this.getCurrentStep.data.name === "uploader") {
				var stepPosition = this.getAllSteps.findIndex(function (step) {
					return step.name === "select-format";
				});
				var secondStep = this.getAllSteps[stepPosition + 1];
				if (secondStep) {
					return secondStep.name;
				}
			}

			return "";
		},
		checkPreviousStep: function checkPreviousStep() {
			var _this = this;

			var allSteps = this.getAllSteps;
			var options = this.optionGroups;
			var stepPosition = allSteps.findIndex(function (step) {
				return step.name === _this.getCurrentStep.data.name;
			});
			var unavailableOptions = this.unavailableOptions;

			function checkStepsArray(step) {
				var previousStep = allSteps[step - 1] || null;
				var option = options.filter(function (option) {
					return option.title === previousStep.title;
				})[0] || null;

				if (option && option.directlyVisibleOptions) {
					var visibleOptions = option.directlyVisibleOptions.filter(function (optionId) {
						return !unavailableOptions.includes(optionId);
					});

					if (visibleOptions.length > 1) {
						return option.id;
					}

					return checkStepsArray(step - 1);
				}

				return "";
			}

			return checkStepsArray(stepPosition);
		},
		nextStep: function nextStep() {
			if (window.matchMedia("(max-width: 480px)").matches) {
				document.body.classList.add("fade-in-slower");
			}

			setTimeout(function () {
				document.body.classList.remove("fade-in-slower");
			}, 400);

			if (this.checkNextStep() !== "") {
				this.$store.commit("SET_STEP_ACTIVE", this.checkNextStep());
				return;
			}

			this.$store.commit("CONFIGURATOR_STEP_NEXT");
		},
		prevStep: function prevStep() {
			if (window.matchMedia("(max-width: 480px)").matches) {
				document.body.classList.add("fade-in-slower");
			}

			setTimeout(function () {
				document.body.classList.remove("fade-in-slower");
			}, 400);

			if (this.checkPreviousStep() !== "") {
				this.$store.commit("SET_STEP_ACTIVE", this.checkPreviousStep());
				return;
			}

			this.$store.commit("CONFIGURATOR_STEP_PREV");
		},
		uploadFiles: function uploadFiles() {
			var _this2 = this;

			return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
				return regenerator_default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;
								_context.next = 3;
								return _this2.$store.dispatch("_createConfiguration");

							case 3:
								_context.next = 5;
								return _this2.$store.dispatch("_saveConfiguration");

							case 5:
								_context.next = 10;
								break;

							case 7:
								_context.prev = 7;
								_context.t0 = _context["catch"](0);

								console.error("Failed to prepare configuration before upload step", _context.t0);

							case 10:
								_this2.setStepActive("uploader");

							case 11:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this2, [[0, 7]]);
			}))();
		},
		configuratorOverview: function configuratorOverview() {
			var _this3 = this;

			return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
				return regenerator_default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_this3.setStepActive("configurator-overview");
								_this3.$forceUpdate();
								_context2.next = 4;
								return _this3.$nextTick();

							case 4:
								_this3.$forceUpdate();

							case 5:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this3);
			}))();
		},
		addToCart: function addToCart() {
			var selectedProduct = this.$store.getters.getSelectedProduct;
			var selectedFormat = this.$store.getters.getSelectedFormat;
			var price = this.$store.getters.getPrice;
			var orderLine = this.getOrderLine;

			tracking_pushEvent(Events.ADD_TO_CART, {
				productName: selectedProduct ? selectedProduct.name : null,
				formatName: selectedFormat ? selectedFormat.name : null,
				amount: orderLine ? orderLine.amount : null,
				price: price ? price.PriceWithoutTax : null
			});

			this.$store.dispatch("_postConfiguration");
			this.disableOrderButton = true;
		},
		scrollToStep: function scrollToStep() {
			var _this4 = this;

			var stepName = this.$store.getters.getCurrentStep.data.name;
			if (stepName && document.querySelector("#" + stepName)) {
				setTimeout(function () {
					var stepElement = document.querySelector("#" + stepName);
					var ctaHolder = stepElement.querySelector(".configurator-navigation");
					var header = document.querySelector(".header");
					var newScrollPos = _this4.calculateScrollPos(header, stepElement, ctaHolder);
					window.scrollTo({
						top: Math.abs(newScrollPos),
						behavior: "instant"
					});
				}, 0);
			}
		},
		calculateScrollPos: function calculateScrollPos(navHeader, stepperHeader) {
			var viewportHeight = window.innerHeight;

			var headerRect = stepperHeader.getBoundingClientRect();
			var navHeaderRect = navHeader.getBoundingClientRect();

			var effectiveViewportTop = navHeaderRect.height;
			var effectiveViewportHeight = viewportHeight - effectiveViewportTop;

			var headerVisible = headerRect.top >= effectiveViewportTop && headerRect.bottom <= viewportHeight;

			if (headerVisible) {
				return window.pageYOffset;
			}

			var combinedCurrentHeaderAndContent = headerRect.top;
			var canFitCurrentHeaderAndContent = combinedCurrentHeaderAndContent <= effectiveViewportHeight;

			if (canFitCurrentHeaderAndContent) {
				var currentScroll = window.pageYOffset;
				var targetScroll = currentScroll + viewportHeight;

				var headerTopAfterScroll = headerRect.top - (targetScroll - currentScroll);
				if (headerTopAfterScroll < effectiveViewportTop) {
					return currentScroll + (headerRect.top - effectiveViewportTop);
				}
				return targetScroll;
			}

			return window.pageYOffset + (headerRect.top - effectiveViewportTop);
		},
		orderButtonText: function orderButtonText() {
			if (this.configuratorType.isConfiguration && !this.baseProps.isSpecificationConfiguration && !this.baseProps.specificationId) {
				return "Opslaan & bestellen";
			}

			return "Bestellen";
		},
		stickyCheck: function stickyCheck() {
			if (!this.stepActive || !this.getAvailableSteps.next || !this.referenceDivContainer) {
				return;
			}

			if (this.getCurrentStep.data.name === "price-table" && !this.hasSelectedOrderLineAmount) {
				return;
			}

			var targetRect = this.$refs.stickyButtonAnchor.getBoundingClientRect();
			var shouldUnstick = window.innerHeight >= targetRect.bottom;

			if (shouldUnstick) {
				this.$refs.wrapperHandle.classList.remove("configurator-navigation__wrapper--sticky");
			} else {
				this.$refs.wrapperHandle.classList.add("configurator-navigation__wrapper--sticky");
			}

			var containerRect = this.referenceDivContainer.getBoundingClientRect();
			this.$el.style.setProperty("--configurator-sticky-left", containerRect.left + "px");
			this.$el.style.setProperty("--configurator-sticky-width", containerRect.width + "px");
		}
	},
	watch: {
		getOrder: function getOrder(a, b) {
			EventBus.$emit("openModal");
		},
		"getOrder.success": function getOrderSuccess(isUnsuccessful) {
			if (isUnsuccessful) {
				this.disableOrderButton = false;
			}
		},
		"getCurrentStep.data.name": function getCurrentStepDataName() {
			var _this5 = this;

			clearTimeout(this.autoScrollDebounce);
			this.autoScrollDebounce = setTimeout(function () {
				return _this5.scrollToStep();
			}, 100);
		},
		"getAvailableSteps.next": function getAvailableStepsNext() {
			this.stickyCheck();
		},
		"getOrderLine.amount": function getOrderLineAmount(cur, prev) {
			if (prev === 0) {
				return;
			}
			this.hasSelectedOrderLineAmount = true;
			this.stickyCheck();
		}
	},
	mounted: function mounted() {
		var _this6 = this;

		EventBus.$on("openModal", function () {
			_this6.openModal = false;
			setTimeout(function () {
				this.openModal = true;
			}.bind(_this6), 100);
		});
		this.referenceDivContainer = this.$el.closest(".configurator-step");
		addEventListener("scroll", this.stickyCheck, { passive: true });
		addEventListener("resize", this.stickyCheck, { passive: true });
		document.addEventListener("orderConfiguration", this.addToCart);
	},
	beforeDestroy: function beforeDestroy() {
		removeEventListener("scroll", this.stickyCheck);
		removeEventListener("resize", this.stickyCheck);
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55c01c4e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator-navigation-buttons.vue
var configurator_navigation_buttons_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"stickyButtonAnchor",staticClass:"configurator-navigation"},[_c('div',{ref:"wrapperHandle",staticClass:"configurator-navigation__wrapper"},[_c('div',{staticClass:"configurator-navigation-sticky-flex-container"},[(!_vm.isOverviewStep && !_vm.isLastUploadStep)?_c('div',{staticClass:"configurator-navigation__button-container configurator-navigation__button-container--price",class:{'text--center' : _vm.loadingPrice}},[(!_vm.loadingPrice)?_c('div',{staticClass:"configurator-price-holder-wrapper"},[_c('div',{staticClass:"configurator-price-holder"},[(_vm.hasPrice && _vm.canShowPriceDueToCustomSize)?[_c('div',{staticClass:"configurator-price-holder__side configurator-price-holder__side--left"},[_c('price',{staticClass:"text--right",attrs:{"smaller":""}})],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"configurator-price-holder__side configurator-price-holder__side--right"},[(_vm.configuratorData.hasMultiplePages)?_c('spine',{attrs:{"navigation":""}}):_vm._e(),_vm._v(" "),(!_vm.configuratorData.hasMultiplePages)?_c('price-pages'):_vm._e(),_vm._v(" "),_c('price-amount')],1)]:_vm._e()],2)]):[_vm._m(1)]],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"configurator-navigation__button-container"},[(_vm.getAvailableSteps.prev && !_vm.isLastUploadStep)?_c('button',{staticClass:"configurator-navigation__button configurator-navigation__button--previous button button--white",attrs:{"title":"Vorige"},on:{"click":_vm.prevStep}},[_vm._v("\n\t\t\t\t\tVorige")]):_vm._e(),_vm._v(" "),(!_vm.getAvailableSteps.prev && !_vm.isLastUploadStep)?_c('button',{staticClass:"configurator-navigation__button button",attrs:{"title":"Vorige","disabled":""}},[_vm._v("\n\t\t\t\t\tVorige")]):_vm._e(),_vm._v(" "),(_vm.editorUrl)?_c('a',{staticClass:"configurator-navigation__button button button-cta",attrs:{"title":"Direct ontwerpen","href":_vm.editorUrl}},[_vm._v("\n\t\t\t\t\tOntwerpen\n\t\t\t\t")]):_vm._e(),_vm._v(" "),(!_vm.isOverviewStep && !_vm.isLastUploadStep)?_c('button',{staticClass:"configurator-navigation__button button button-cta",class:_vm.stepClass,attrs:{"title":"Volgende","disabled":!_vm.getAvailableSteps.next},on:{"click":_vm.nextStep}},[_vm._v("\n\t\t\t\t\tVolgende\n\t\t\t\t")]):_vm._e(),_vm._v(" "),(!_vm.isOffTheShelf && _vm.isOverviewStep && !_vm.uploadsComplete && !_vm.configuratorType.isConfiguration)?_c('button',{staticClass:"configurator-navigation__button button button--indigo",attrs:{"title":"Uploaden"},on:{"click":_vm.uploadFiles}},[_vm._v("Bestanden uploaden")]):_vm._e(),_vm._v(" "),(_vm.isLastUploadStep && _vm.uploadsComplete)?_c('button',{staticClass:"configurator-navigation__button button button--cta button--no-change button--icon-ms-small",attrs:{"title":"Overzicht"},on:{"click":_vm.configuratorOverview}},[_vm._v("\n\t\t\t\t\tNaar overzicht\n\t\t\t\t\t"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.disableOrderButton),expression:"disableOrderButton"}],staticClass:"button-loader loading"})]):_vm._e(),_vm._v(" "),(_vm.isOverviewStep)?_c('button',{staticClass:"configurator-navigation__button button button--cta button--no-change button--icon-ms-small",attrs:{"title":this.orderButtonText(),"data-loading":"","disabled":_vm.disableOrderButton},on:{"click":_vm.addToCart}},[_vm._v("\n\t\t\t\t\t"+_vm._s(this.orderButtonText())+"\n\t\t\t\t\t"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.disableOrderButton),expression:"disableOrderButton"}],staticClass:"button-loader loading"})]):_vm._e()])])]),_vm._v(" "),(_vm.isConfiguratorDataValid)?_c('modal',{attrs:{"button-style":"none","modal-style":"styled","open":_vm.openModal}},[(_vm.getOrder.success)?_c('span',{staticClass:"success-message"},[_c('svg',{staticClass:"checkmark",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 52 52"}},[_c('circle',{staticClass:"checkmark__circle",attrs:{"cx":"26","cy":"26","r":"25","fill":"none"}}),_vm._v(" "),_c('path',{staticClass:"checkmark__check",attrs:{"fill":"none","d":"M14.1 27.2l7.1 7.2 16.7-16.8"}})]),_vm._v(" "),_c('span',{staticClass:"success-message__text"},[_vm._v("Toegevoegd aan winkelwagen")]),_vm._v(" "),_c('div',{staticClass:"error-message__holder"},[_c('p',[_vm._v("U wordt doorverwezen...")])])]):_vm._e(),_vm._v(" "),(!_vm.getOrder.success)?_c('span',{staticClass:"error-message"},[_c('svg',{staticClass:"error",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 52 52"}},[_c('circle',{staticClass:"error__circle",attrs:{"cx":"26","cy":"26","r":"25","fill":"none"}}),_vm._v(" "),_c('path',{staticClass:"error__cross",attrs:{"fill":"none","d":"M15 15l22 22 M37 15l-22 22"}})]),_vm._v(" "),_c('span',{staticClass:"success-message__text"},[_vm._v("Er ging iets fout...")]),_vm._v(" "),_c('div',{staticClass:"error-message__holder"},[_c('p',{domProps:{"textContent":_vm._s(_vm.getOrder.message)}})])]):_vm._e(),_vm._v(" "),(_vm.getOrder.status)?_c('a',{staticClass:"button button--cta",attrs:{"href":_vm.CONFIG.HOST + 'winkelwagen/'}},[_vm._v("Ga naar winkelwagen")]):_vm._e()]):_vm._e()],1)}
var configurator_navigation_buttons_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configurator-price-holder__side configurator-price-holder__side--divider"},[_c('div',{staticClass:"configurator-navigation-divider"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading loading--smaller"},[_c('div'),_c('div'),_c('div')])}]

// CONCATENATED MODULE: ./src/components/configurator-navigation-buttons.vue
function configurator_navigation_buttons_injectStyle (context) {
  __webpack_require__("s7rG")
}
/* script */


/* template */

/* template functional */
var configurator_navigation_buttons___vue_template_functional__ = false
/* styles */
var configurator_navigation_buttons___vue_styles__ = configurator_navigation_buttons_injectStyle
/* scopeId */
var configurator_navigation_buttons___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var configurator_navigation_buttons___vue_module_identifier__ = null

var configurator_navigation_buttons_Component = Object(component_normalizer["a" /* default */])(
  configurator_navigation_buttons,
  configurator_navigation_buttons_render,
  configurator_navigation_buttons_staticRenderFns,
  configurator_navigation_buttons___vue_template_functional__,
  configurator_navigation_buttons___vue_styles__,
  configurator_navigation_buttons___vue_scopeId__,
  configurator_navigation_buttons___vue_module_identifier__
)

/* harmony default export */ var components_configurator_navigation_buttons = (configurator_navigation_buttons_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/step/step.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var step_step = ({
	name: "Step",
	components: {
		configuratorNavigationButtons: components_configurator_navigation_buttons
	},
	data: function data() {
		return {
			firstStepActive: false
		};
	},

	props: {
		name: {
			type: String,
			default: ""
		},
		title: {
			type: String,
			default: ""
		},
		id: {
			type: Number,
			default: null
		},
		"error-message": {
			type: String,
			default: ""
		},
		valid: {
			type: Boolean,
			default: false
		},
		position: {
			type: Number,
			default: null
		}
	},
	computed: {
		stepName: function stepName() {
			return this.name.toLowerCase().replace(/([~!@#$%^&*()_+=`{}[\]|\\:;'<>,./? ])+/g, "-").replace(/^(-)+|(-)+$/g, "");
		},
		getAllSteps: function getAllSteps() {
			return this.$store.getters.getAllSteps;
		},
		getCurrentStep: function getCurrentStep() {
			return this.$store.getters.getCurrentStep;
		},
		stepActive: function stepActive() {
			return this.getAllSteps[this.getCurrentStep.index].name === this.stepName;
		},
		configuratorType: function configuratorType() {
			return this.$store.getters.getConfiguratorType;
		},
		getConfiguratorTypeString: function getConfiguratorTypeString() {
			return this.$store.getters.getConfiguratorTypeString;
		},
		configuratorData: function configuratorData() {
			return this.$store.state.configuratorData;
		},
		isConfiguratorDataValid: function isConfiguratorDataValid() {
			return this.$store.getters.isConfiguratorDataValid;
		},
		isExistingConfigurationAdded: function isExistingConfigurationAdded() {
			return this.$store.getters.isExistingConfigurationAdded;
		},
		existingConfigIsFinalized: function existingConfigIsFinalized() {
			return this.$store.getters.existingConfigIsFinalized;
		},
		getUploaderPosition: function getUploaderPosition() {
			return this.$store.getters.getUploaderPosition;
		},
		getThisStepData: function getThisStepData() {
			var _this = this;

			return this.getAllSteps.find(function (s) {
				return s.name === _this.stepName;
			});
		},
		checkData: function checkData() {
			return this.$store.getters.checkData;
		},
		isStepValid: function isStepValid() {
			var _this2 = this;

			var currentStep = this.stepName;
			var isStepAvailable = function isStepAvailable(step) {
				return {
					"select-product": _this2.checkData.hasSelectedProduct,
					"select-format": _this2.checkData.hasSelectedFormat
				}[step];
			};

			var stepIsValid = isStepAvailable(currentStep);

			if (stepIsValid != null) {
				return stepIsValid;
			}

			return this.getThisStepData.valid;
		},
		getStepInt: function getStepInt() {
			var _this3 = this;

			var step = this.getAllSteps.find(function (s) {
				return s.name === _this3.stepName;
			});
			return this.getAllSteps.indexOf(step) + 1;
		}
	},
	methods: {
		addStep: function addStep() {
			var payload = {
				option: {
					name: this.stepName,
					title: this.title,
					errorMessage: this.errorMessage,
					groupId: this.id,
					valid: this.valid ? this.valid : false
				}
			};

			if (this.position !== undefined && this.position !== null) {
				payload.position = this.position;
			}

			this.$store.commit("CONFIGURATOR_ADD_STEP", payload);
		},
		removeStep: function removeStep() {
			var _this4 = this;

			var stepToRemove = this.getAllSteps.find(function (a) {
				return a.name === _this4.stepName;
			}).name;

			this.$store.commit("CONFIGURATOR_REMOVE_STEP", stepToRemove);
		},
		isFocusStep: function isFocusStep(stepName) {
			return ["configurator-overview", "price-table", "uploader"].includes(stepName);
		}
	},
	watch: {
		getConfiguratorTypeString: function getConfiguratorTypeString(a, b) {
			var _this5 = this;

			var typeStringToStep = function typeStringToStep(type) {
				return {
					"upload": "uploader",
					"calculate": _this5.configuratorData.hasMultipleProducts ? "select-product" : "select-format"
				}[type] || null;
			};

			if (typeStringToStep(a)) {
				var payload = this.$store.getters.getAllSteps.find(function (s) {
					return s.name === typeStringToStep(a);
				});
				this.$store.commit("CONFIGURATOR_SET_ACTIVE_STEP", payload);
			}
		},
		name: function name(a, b) {
			function formatStep(input) {
				return input.toLowerCase().replace(/([~!@#$%^&*()_+=`{}[\]|\\:;'<>,./? ])+/g, "-").replace(/^(-)+|(-)+$/g, "");
			}
			var prevStepName = formatStep(b);

			var step = this.$store.getters.getAllSteps.find(function (x) {
				return x.name === prevStepName;
			});
			var stepIndex = this.$store.getters.getAllSteps.indexOf(step);

			this.$store.commit("CONFIGURATOR_UPDATE_STEP", {
				index: stepIndex,
				property: "name",
				value: formatStep(a)
			});
		},
		title: function title(a, b) {
			var step = this.$store.getters.getAllSteps.find(function (x) {
				return x.title === b;
			});
			var stepIndex = this.$store.getters.getAllSteps.indexOf(step);

			this.$store.commit("CONFIGURATOR_UPDATE_STEP", {
				index: stepIndex,
				property: "title",
				value: a
			});
		},
		id: function id(a, b) {
			var step = this.$store.getters.getAllSteps.find(function (x) {
				return x.groupId === b;
			});
			var stepIndex = this.$store.getters.getAllSteps.indexOf(step);

			this.$store.commit("CONFIGURATOR_UPDATE_STEP", {
				index: stepIndex,
				property: "groupId",
				value: a
			});
		},
		errorMessage: function errorMessage(a, b) {
			var step = this.$store.getters.getAllSteps.find(function (x) {
				return x.title === b;
			});
			var stepIndex = this.$store.getters.getAllSteps.indexOf(step);

			this.$store.commit("CONFIGURATOR_UPDATE_STEP", {
				index: stepIndex,
				property: "errorMessage",
				value: a
			});
		},
		isConfiguratorDataValid: function isConfiguratorDataValid(a, b) {
			if (!a) {
				if (!this.getUploaderPosition.before) {
					this.$store.commit("CONFIGURATOR_REMOVE_STEP", "uploader");
				}

				if (!this.configuratorType.isConfiguration) {
					this.$store.commit("CONFIGURATOR_REMOVE_STEP", "price-table");
				}

				this.$store.commit("CONFIGURATOR_REMOVE_STEP", "configurator-overview");
			}
		}
	},
	mounted: function mounted() {
		if (this.isConfiguratorDataValid && this.isExistingConfigurationAdded && !this.existingConfigIsFinalized) {
			this.$store.commit("FINAL_STEP_EXISTING_CONFIG");
		}
	},
	created: function created() {
		var firstStep = this.getAllSteps[0];

		this.addStep();

		if (Helper.isEmptyObject(this.getCurrentStep.data)) {
			this.$store.commit("CONFIGURATOR_SET_ACTIVE_STEP", firstStep);
		}

		if (this.getCurrentStep !== undefined && firstStep) {
			this.$store.commit("CONFIGURATOR_STEP_AVAILABLE");
		}

		if (this.setActive) {
			this.$store.commit("CONFIGURATOR_SET_ACTIVE_STEP", {
				name: this.stepName,
				title: this.title,
				errorMessage: this.errorMessage,
				groupId: this.id,
				valid: this.valid ? this.valid : false
			});
		}
	},
	beforeDestroy: function beforeDestroy() {
		var dontRemove = ["configurator-overview", "price-table", "uploader"];
		if (!dontRemove.includes(this.stepName)) {
			this.removeStep();
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-487fd9bf","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/step/step.vue
var step_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isFocusStep(_vm.stepName))?_c('div',{staticClass:"configurator-step configurator-step--validstate",class:{ 'configurator-step--active': _vm.stepActive, 'configurator-step--valid': _vm.isStepValid },attrs:{"id":_vm.stepName}},[_c('div',{staticClass:"configurator-step__content"},[_vm._t("title",function(){return [_c('div',{staticClass:"h5 configurator-step__title"},[_c('span',{staticClass:"configurator-step__count"},[_vm._v(_vm._s(_vm.getStepInt))]),_vm._v("\n\t\t\t\t"+_vm._s(_vm.title)+"\n\t\t\t")])]}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stepActive),expression:"stepActive"}],staticClass:"configurator-step__holder"},[_vm._t("default"),_vm._v(" "),_c('configurator-navigation-buttons',{attrs:{"name":_vm.stepName}})],2)],2)]):_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stepActive),expression:"stepActive"}],staticClass:"configurator-step",class:{ 'configurator-step--active': _vm.stepActive },attrs:{"id":_vm.stepName}},[_vm._t("title",function(){return [_c('div',{staticClass:"h5 configurator-step__title"},[_c('span',{staticClass:"configurator-step__count"},[_vm._v(_vm._s(_vm.getStepInt))]),_vm._v("\n\t\t\t"+_vm._s(_vm.title)+"\n\t\t")])]}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('configurator-navigation-buttons',{attrs:{"name":_vm.stepName}})],2)}
var step_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/step/step.vue
function step_injectStyle (context) {
  __webpack_require__("aF67")
}
/* script */


/* template */

/* template functional */
var step___vue_template_functional__ = false
/* styles */
var step___vue_styles__ = step_injectStyle
/* scopeId */
var step___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var step___vue_module_identifier__ = null

var step_Component = Object(component_normalizer["a" /* default */])(
  step_step,
  step_render,
  step_staticRenderFns,
  step___vue_template_functional__,
  step___vue_styles__,
  step___vue_scopeId__,
  step___vue_module_identifier__
)

/* harmony default export */ var components_step_step = (step_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/product/product-option.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var product_option = ({
	name: "ProductOption",
	props: {
		option: {
			type: Object,
			required: true
		}
	},
	computed: {
		imagePath: function imagePath() {
			return this.option.iconPath;
		},
		selectedProduct: function selectedProduct() {
			return this.$store.getters.getSelectedProduct;
		},
		checkData: function checkData() {
			return this.$store.getters.checkData;
		},
		itemActive: function itemActive() {
			return this.checked(this.option.id) && this.checkData.hasSelectedProduct ? "configurator-options__item--active" : "";
		}
	},
	methods: {
		selectProduct: function selectProduct(value) {
			tracking_pushEvent(Events.SELECT_PRODUCT, {
				productId: value.id,
				productName: value.name
			});

			this.$store.commit("SET_SELECTED_PRODUCT", value);
		},
		checked: function checked(value) {
			return this.selectedProduct !== null ? this.selectedProduct.id === value : false;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f593646","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/product-option.vue
var product_option_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell configurator-options__wrapper"},[_c('div',{staticClass:"configurator-options__item cursor-pointer",class:_vm.itemActive,on:{"click":function($event){return _vm.selectProduct(_vm.option)}}},[_c('img',{staticClass:"configurator-options__image",attrs:{"src":_vm.imagePath,"width":"500"}}),_vm._v(" "),_c('input',{staticClass:"configurator-block__input input-field input-field--custom",attrs:{"id":_vm.option.id,"type":"radio","name":"selectProduct"},domProps:{"checked":_vm.checked(_vm.option.id)}}),_vm._v(" "),_c('span',{staticClass:"configurator__input-selectable"}),_vm._v(" "),_c('p',{staticClass:"configurator-block__label cursor-pointer"},[_vm._v(_vm._s(_vm.option.name))])])])}
var product_option_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/product/product-option.vue
/* script */


/* template */

/* template functional */
var product_option___vue_template_functional__ = false
/* styles */
var product_option___vue_styles__ = null
/* scopeId */
var product_option___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var product_option___vue_module_identifier__ = null

var product_option_Component = Object(component_normalizer["a" /* default */])(
  product_option,
  product_option_render,
  product_option_staticRenderFns,
  product_option___vue_template_functional__,
  product_option___vue_styles__,
  product_option___vue_scopeId__,
  product_option___vue_module_identifier__
)

/* harmony default export */ var product_product_option = (product_option_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/product/product.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var product = ({
	name: "Product",
	components: {
		step: components_step_step,
		productOption: product_product_option
	},
	computed: {
		sortedProducts: function sortedProducts() {
			var productFronts = this.productData;
			return productFronts.sort(function (a, b) {
				return a.id - b.id;
			});
		},
		selectedProduct: function selectedProduct() {
			return this.$store.getters.getSelectedProduct;
		},
		check: function check() {
			return this.$store.getters.checkData;
		},
		title: function title() {
			return this.$store.getters.uploadsAreComplete && !this.hasMultipleSpecificationMatches ? "Product" : "Kies een product";
		},
		productData: function productData() {
			return this.$store.getters.getProductData;
		},
		productName: function productName() {
			if (this.selectedProduct === null) {
				return null;
			}

			return this.selectedProduct.name;
		}
	},
	methods: {
		stepExists: function stepExists(stepToCheck) {
			return this.$store.getters.getStepExists(stepToCheck);
		},
		setStepActive: function setStepActive(step) {
			if (this.stepExists(step).bool) {
				this.$store.commit("SET_STEP_ACTIVE", step);
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b0bac30","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/product.vue
var product_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('step',{attrs:{"name":"select-product","title":_vm.title,"valid":""}},[_c('template',{slot:"title"},[_c('div',{staticClass:"grid"},[_c('div',{staticClass:"cell cell--fit"},[(_vm.check.hasSelectedProduct)?[_c('h5',{staticClass:"configurator-step__title cursor-pointer",on:{"click":function($event){return _vm.setStepActive('select-product')}}},[_c('strong',[_vm._v("Product:")]),_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.productName)+"\n\t\t\t\t\t")])]:[_c('h5',{staticClass:"configurator-step__title"},[_vm._v(_vm._s(_vm.title))])]],2)])]),_vm._v(" "),_c('div',{staticClass:"configurator-options grid grid--gutters-s grid--1-4 grid--l-1-3 grid--ms-1-2"},_vm._l((_vm.sortedProducts),function(product,index){return _c('product-option',{key:index,attrs:{"option":product}})}),1)],2)}
var product_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/product/product.vue
/* script */


/* template */

/* template functional */
var product___vue_template_functional__ = false
/* styles */
var product___vue_styles__ = null
/* scopeId */
var product___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var product___vue_module_identifier__ = null

var product_Component = Object(component_normalizer["a" /* default */])(
  product,
  product_render,
  product_staticRenderFns,
  product___vue_template_functional__,
  product___vue_styles__,
  product___vue_scopeId__,
  product___vue_module_identifier__
)

/* harmony default export */ var product_product = (product_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/information/delivery-specification.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var delivery_specification = ({
	name: "DeliverySpecification",
	props: {
		format: {
			type: Object,
			required: true
		},
		overview: {
			type: Boolean,
			default: false
		}
	},
	computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])(["baseProps"]), {
		imagePath: function imagePath() {
			return this.format.iconPath;
		},
		pngPath: function pngPath() {
			return this.format.pngPath;
		},
		pdfPath: function pdfPath() {
			return this.format.pdfPath;
		},
		inDesignPath: function inDesignPath() {
			return this.format.inDesignPath;
		},
		pdfTemplatePath: function pdfTemplatePath() {
			return this.format.pdfTemplatePath;
		},
		formatInfo: function formatInfo() {
			return this.format.productSize;
		},
		customFormat: function customFormat() {
			return {
				bool: this.format.isCustomSize,
				minWidth: this.format.minWidthInMm,
				minHeight: this.format.minHeightInMm,
				maxWidth: this.format.maxWidthInMm,
				maxHeight: this.format.maxHeightInMm
			};
		},
		selectedProduct: function selectedProduct() {
			return this.$store.getters.getSelectedProduct;
		},
		showBookManual: function showBookManual() {
			return this.$store.getters.isBookProduct;
		},
		hasEditor: function hasEditor() {
			return this.baseProps.hasEditor.toLowerCase() === "true";
		},
		editorUrl: function editorUrl() {
			return this.baseProps.editorUrl;
		},
		standardDelivery: function standardDelivery() {
			return this.$store.getters.getStandardDelivery;
		},
		rushDelivery: function rushDelivery() {
			return this.$store.getters.getRushDelivery;
		}
	})
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-710b00d0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/delivery-specification.vue
var delivery_specification_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.format)?_c('div',{staticClass:"delivery-specifications"},[(!_vm.overview)?_c('div',{staticClass:"grid grid--gutters grid--center-vertical grid--ms-full"},[_c('div',{staticClass:"cell"},[_c('h3',{staticClass:"title--dot",domProps:{"textContent":_vm._s(_vm.selectedProduct.name + ' ' + _vm.formatInfo.fullName)}}),_vm._v(" "),_c('table',{staticClass:"configurator-overview__table mt-m"},[(!_vm.customFormat.bool)?[_c('tr',[_c('td',{staticClass:"configurator-overview__table-title"},[_vm._v("Hoogte")]),_vm._v(" "),_c('td',{staticClass:"configurator-overview__table-text"},[_vm._v(_vm._s(_vm.formatInfo.heightInMm)+" mm")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"configurator-overview__table-title"},[_vm._v("Breedte")]),_vm._v(" "),_c('td',{staticClass:"configurator-overview__table-text"},[_vm._v(_vm._s(_vm.formatInfo.widthInMm)+" mm")])])]:[_c('tr',[_c('td',{staticClass:"configurator-overview__table-title"},[_vm._v("Hoogte")]),_vm._v(" "),_c('td',{staticClass:"configurator-overview__table-text"},[_vm._v(_vm._s(_vm.customFormat.minHeight)+"mm tot "+_vm._s(_vm.customFormat.maxHeight)+"mm")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"configurator-overview__table-title"},[_vm._v("Breedte")]),_vm._v(" "),_c('td',{staticClass:"configurator-overview__table-text"},[_vm._v(_vm._s(_vm.customFormat.minWidth)+"mm tot "+_vm._s(_vm.customFormat.maxWidth)+"mm")])])],_vm._v(" "),(_vm.format.bleed > 0)?_c('tr',[_c('td',{staticClass:"configurator-overview__table-title"},[_vm._v("Bleed")]),_vm._v(" "),_c('td',{staticClass:"configurator-overview__table-text"},[_vm._v(_vm._s(_vm.format.bleed)+"mm")])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{staticClass:"configurator-overview__table-title"},[_vm._v("Verwachtte levering")]),_vm._v(" "),_c('td',{staticClass:"configurator-overview__table-text"},[_vm._v(_vm._s(_vm.standardDelivery.date))])]),_vm._v(" "),(_vm.format.isRushOrderAvailable)?_c('tr',[_c('td',{staticClass:"configurator-overview__table-title"},[_vm._v("Verwachtte spoedlevering")]),_vm._v(" "),_c('td',{staticClass:"configurator-overview__table-text"},[_vm._v(_vm._s(_vm.rushDelivery.date))])]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"cell cell--25"},[_c('div',{staticClass:"configurator-options__shape configurator-options__shape--square"},[_c('div',{staticClass:"configurator-options__image-holder content-block__image-holder content-block__image-holder--contain"},[_c('img',{staticClass:"configurator-options__image",attrs:{"src":_vm.imagePath,"width":"500"}})])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-m"},[(!_vm.overview)?_c('h3',{staticClass:"mt-s mb-s title--dot"},[_vm._v("Aanleverspecificaties")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Volg de aanwijzingingen in de werktekening of bekijk de volledige aanleverspecificatie om een drukklaar PDF aan te kunnen leveren. U kunt ook gebruik maken van een InDesign-sjabloon.")]),_vm._v(" "),(_vm.hasEditor)?_c('p',[_vm._v("\n\t\t\tMoeite met het aanleveren van uw PDF-bestand? "),_c('a',{staticClass:"link",attrs:{"href":_vm.editorUrl}},[_vm._v("Upload uw PDF-bestand in onze Online Editor")]),_vm._v(" en maak het bestand in een paar klikken drukklaar\n\t\t")]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.showBookManual)?_c('div',{staticClass:"cell cell--full alertbox alertbox--notification alertbox--inline mt-m"},[_c('svg',{staticClass:"alertbox__icon alertbox__icon--notification"},[_c('use',{attrs:{"xlink:href":"#alert--info"}})]),_vm._v(" "),_vm._m(1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"grid grid--gutters grid--l-1-2 grid--ms-full mt-s"},[_c('div',{staticClass:"cell"},[_c('a',{staticClass:"button button--cta",attrs:{"href":_vm.pdfPath,"target":"_blank"}},[_vm._v("\n\t\t\t\t\tAanleverspecificatie\n\t\t\t\t")])]),_vm._v(" "),(!_vm.format.isCustomSize)?_c('div',{staticClass:"cell"},[_c('a',{staticClass:"button",attrs:{"href":_vm.inDesignPath,"target":"_blank"}},[_vm._v("\n\t\t\t\t\tInDesign-sjabloon\n\t\t\t\t")])]):_vm._e(),_vm._v(" "),(_vm.format.pdfTemplatePath)?_c('div',{staticClass:"cell"},[_c('a',{staticClass:"button",attrs:{"href":_vm.pdfTemplatePath,"target":"_blank"}},[_vm._v("\n\t\t\t\t\tPDF-sjabloon\n\t\t\t\t")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mt-l"},[_c('img',{staticClass:"content-block__image",attrs:{"src":_vm.pngPath,"alt":_vm.formatInfo.fullName}})])]):_vm._e()}
var delivery_specification_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Heeft u nog vragen over het aanleveren van de bestanden? Neem dan contact op met onze "),_c('a',{staticClass:"link",attrs:{"href":"/contact"}},[_vm._v("klantenservice")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"alertbox__text"},[_vm._v("\n\t\t\t\tHulp nodig met het opmaken van uw document? Gebruik onze\n\t\t\t\t"),_c('a',{staticClass:"link",attrs:{"title":"Handleiding downloaden","href":"/content/pdf/indesign-templates-manual-drukwerknodig.pdf","target":"_blank"}},[_vm._v("handleiding")]),_vm._v("\n\t\t\t\tvoor indesign-templates met handige tips!\n\t\t\t")])}]

// CONCATENATED MODULE: ./src/components/information/delivery-specification.vue
/* script */


/* template */

/* template functional */
var delivery_specification___vue_template_functional__ = false
/* styles */
var delivery_specification___vue_styles__ = null
/* scopeId */
var delivery_specification___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var delivery_specification___vue_module_identifier__ = null

var delivery_specification_Component = Object(component_normalizer["a" /* default */])(
  delivery_specification,
  delivery_specification_render,
  delivery_specification_staticRenderFns,
  delivery_specification___vue_template_functional__,
  delivery_specification___vue_styles__,
  delivery_specification___vue_scopeId__,
  delivery_specification___vue_module_identifier__
)

/* harmony default export */ var information_delivery_specification = (delivery_specification_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/element/tooltip.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tooltip = ({
	name: "ToolTip",
	props: {
		content: {
			type: String,
			default: ""
		},
		closeOthers: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: ""
		},
		unmet: {
			type: Boolean,
			default: false
		},
		absolute: {
			type: Boolean,
			default: true
		},
		tooltipWrapperClassName: {
			type: String,
			default: null
		},
		hover: {
			type: Boolean,
			default: false
		}
	},
	data: function data() {
		return {
			active: false,
			transform: 0,
			style: {}
		};
	},

	computed: {
		tooltipWrapperClass: function tooltipWrapperClass() {
			var classList = [];
			var supportedTypes = ["list", "rounded", "absolute", "relative"];

			var typeClass = function typeClass(type) {
				return supportedTypes.includes(type) ? "tool-tip__wrapper--" + type : "";
			};

			if (this.tooltipWrapperClassName) {
				classList.push(this.tooltipWrapperClassName);
			}
			if (this.active) {
				classList.push("tool-tip__wrapper--active");
			}
			if (this.type) {
				classList.push(typeClass(this.type));
			}

			return classList;
		},
		toolTipClass: function toolTipClass() {
			var classList = [];
			if (this.absolute) {
				classList.push("tool-tip__label--absolute");
			}
			if (this.unmet) {
				classList.push("tool-tip__label--unmet");
			}
			if (this.active) {
				classList.push("tool-tip__label--active");
			}
			return classList;
		},
		tooltipStyle: function tooltipStyle() {
			return this.style;
		},
		formatContent: function formatContent() {
			var contentArray = this.content.split(" ");
			var count = 0;
			var wrapAt = 60;

			contentArray.map(function (item, index) {
				count += item.length;

				if (count > wrapAt) {
					contentArray.splice(index - 1, 0, "</span><span>");
					count = 0;
				}
			});
			return "<span>" + contentArray.join(" ") + "</span>";
		},
		configuratorBoundingRect: function configuratorBoundingRect() {
			return this.$store.getters.getBoundingRect;
		}
	},
	methods: {
		toggleToolTip: function toggleToolTip() {
			if (this.closeOthers) {
				EventBus.$emit("closeOtherTooltips");
			}
			this.active = !this.active;
		},
		setTooltipStyle: function setTooltipStyle(element) {
			var holder = this.$el.closest(".configurator__holder");
			if (!holder) return;
			var holderRect = holder.getBoundingClientRect();
			if (holderRect.width === 0) return;
			var configLeft = Math.max(holderRect.left, 0);
			var configRight = Math.min(holderRect.right, window.innerWidth);

			var halfWidth = element.getBoundingClientRect().width / 2;
			element.style.transform = "translateX(" + -halfWidth + "px)";
			element.style.transitionProperty = "none";

			var popupRect = element.getBoundingClientRect();
			var overflowRight = popupRect.right - configRight;
			var overflowLeft = configLeft - popupRect.left;
			var translate = -halfWidth;
			if (overflowRight > 0) {
				translate -= overflowRight;
			} else if (overflowLeft > 0) {
				translate += overflowLeft;
			}

			this.transform = translate;
			this.style = {
				visibility: this.active ? "visible" : "hidden",
				pointerEvents: this.active ? "all" : "none",
				transform: "translateX(" + translate + "px)",
				transitionProperty: "none"
			};
		}
	},
	mounted: function mounted() {
		var _this = this;

		EventBus.$on("closeOtherTooltips", function (e) {
			_this.active = false;
		});

		this.style = {
			visibility: "hidden",
			pointerEvents: "none"
		};
	},

	watch: {
		active: function active() {
			this.setTooltipStyle(this.$refs.tooltip);
		},
		configuratorBoundingRect: function configuratorBoundingRect() {
			if (this.active) {
				this.setTooltipStyle(this.$refs.tooltip);
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d25d679e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/tooltip.vue
var tooltip_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tool-tip__wrapper grid",class:_vm.tooltipWrapperClass},[_c('div',{staticClass:"tool-tip__wrapper-inner",on:{"mouseenter":function($event){_vm.hover ? _vm.toggleToolTip() : null},"mouseleave":function($event){_vm.hover ? _vm.toggleToolTip() : null}}},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{ref:"tooltip",staticClass:"tool-tip",style:(_vm.tooltipStyle),attrs:{"title":"Sluiten"},domProps:{"innerHTML":_vm._s(_vm.unmet ? '<span>Deze optie is niet mogelijk in uw huidige configuratie.</span>' : _vm.formatContent)}})]),_vm._v(" "),(_vm.hover)?[_vm._t("default",function(){return [_c('span',{staticClass:"tool-tip__label",class:_vm.toolTipClass,attrs:{"title":"Info"},on:{"click":function($event){$event.stopPropagation();_vm.hover ? null : _vm.toggleToolTip()}}},[_vm._v("i")])]})]:[_vm._t("default",function(){return [_c('span',{staticClass:"tool-tip__label",class:_vm.toolTipClass,attrs:{"title":"Info"}},[_vm._v("i")])]})]],2)])}
var tooltip_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/element/tooltip.vue
function tooltip_injectStyle (context) {
  __webpack_require__("Hun4")
}
/* script */


/* template */

/* template functional */
var tooltip___vue_template_functional__ = false
/* styles */
var tooltip___vue_styles__ = tooltip_injectStyle
/* scopeId */
var tooltip___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tooltip___vue_module_identifier__ = null

var tooltip_Component = Object(component_normalizer["a" /* default */])(
  tooltip,
  tooltip_render,
  tooltip_staticRenderFns,
  tooltip___vue_template_functional__,
  tooltip___vue_styles__,
  tooltip___vue_scopeId__,
  tooltip___vue_module_identifier__
)

/* harmony default export */ var element_tooltip = (tooltip_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/element/orientation.vue
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var orientation = ({
	name: "Orientation",
	components: {
		tooltip: element_tooltip
	},
	props: {
		orientation: {
			type: Number,
			default: 0
		}
	},

	computed: {
		orientationName: function orientationName() {
			return this.$store.getters.getDictionary.orientation[this.orientation].toLowerCase();
		},
		orientationText: function orientationText() {
			var orientationName = function orientationName(orientation) {
				return {
					"both": "staand en liggend",
					"portrait": "staand",
					"landscape": "liggend"
				}[orientation];
			};

			var text = "" + (!this.getViewPort.m ? "dit formaat is " : "") + orientationName(this.orientationName) + " mogelijk";

			return text && text[0].toUpperCase() + text.slice(1);
		},
		orientationSvg: function orientationSvg() {
			return this.$store.getters.getSvg.orientation[this.orientationName];
		},
		getViewPort: function getViewPort() {
			return this.$store.getters.getViewPort;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12fe218e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/orientation.vue
var orientation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.orientationSvg)?_c('tooltip',{attrs:{"tooltip-wrapper-class-name":"tool-tip__wrapper--relative tool-tip__wrapper--orientation","content":_vm.orientationText,"hover":""}},[_c('div',{staticClass:"orientation tool-tip__arrow-hook",domProps:{"innerHTML":_vm._s(_vm.orientationSvg)}})]):_vm._e()}
var orientation_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/element/orientation.vue
/* script */


/* template */

/* template functional */
var orientation___vue_template_functional__ = false
/* styles */
var orientation___vue_styles__ = null
/* scopeId */
var orientation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var orientation___vue_module_identifier__ = null

var orientation_Component = Object(component_normalizer["a" /* default */])(
  orientation,
  orientation_render,
  orientation_staticRenderFns,
  orientation___vue_template_functional__,
  orientation___vue_styles__,
  orientation___vue_scopeId__,
  orientation___vue_module_identifier__
)

/* harmony default export */ var element_orientation = (orientation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/format/format-option.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var format_option = ({
	name: "FormatOption",
	props: {
		"option": {
			type: Object,
			required: true
		},
		"disabled": {
			type: Boolean,
			default: false
		}
	},
	components: {
		modal: element_modal,
		deliverySpecification: information_delivery_specification,
		orientation: element_orientation,
		tooltip: element_tooltip
	},
	computed: {
		imagePath: function imagePath() {
			if (!this.uploadsAreComplete || !this.checked(this.option.id)) {
				return this.option.iconPath;
			}

			if (this.previewUrl && this.previewUrl !== null) {
				return this.previewUrl;
			}

			if (this.option.iconPath) {
				return this.option.iconPath;
			}

			return null;
		},
		availableFormats: function availableFormats() {
			return this.$store.getters.getAvailableFormats;
		},
		isSingleOption: function isSingleOption() {
			return this.availableFormats.length === 1;
		},
		hasMultipleSpecifications: function hasMultipleSpecifications() {
			return this.$store.getters.getConfiguratorData.hasFormatMatches;
		},
		pngPath: function pngPath() {
			return this.option.pngPath;
		},
		pdfPath: function pdfPath() {
			return this.option.pdfPath;
		},
		inDesignPath: function inDesignPath() {
			return this.option.inDesignPath;
		},
		pdfTemplatePath: function pdfTemplatePath() {
			return this.option.pdfTemplatePath;
		},
		formatInfo: function formatInfo() {
			return this.option.productSize;
		},
		selectedFormat: function selectedFormat() {
			return this.$store.getters.getSelectedFormat;
		},
		selectedProduct: function selectedProduct() {
			return this.$store.getters.getSelectedProduct;
		},
		itemClass: function itemClass() {
			var classString = "";
			if (this.checked(this.option.id)) {
				classString += "configurator-options__item--active";
			}
			if (this.disabled) {
				classString += " disabled";
			}

			return classString;
		},
		uploadsAreComplete: function uploadsAreComplete() {
			return this.$store.getters.uploadsAreComplete;
		},
		isCustomSize: function isCustomSize() {
			return this.$store.getters.isCustomSize;
		},
		customSize: function customSize() {
			return this.$store.getters.getCustomSize;
		},
		previewUrl: function previewUrl() {
			return this.$store.getters.getPreviewUrl;
		},
		showOrientation: function showOrientation() {
			return this.$store.getters.showOrientation;
		},
		hasSeparateCover: function hasSeparateCover() {
			return this.$store.getters.hasSeparateCover;
		},
		hasOffsetAvailable: function hasOffsetAvailable() {
			return this.option.offsetPricings.length > 0;
		},
		getSvg: function getSvg() {
			return this.$store.getters.getSvg;
		}
	},
	methods: {
		selectFormat: function selectFormat(value) {
			if (!this.selectedFormat.isCustomSize) {
				this.$store.commit("SET_CUSTOM_SIZE", { width: null, height: null });
			}

			this.$store.commit("SET_SELECTED_FORMAT", value);

			if (!this.selectedFormat.isCustomSize) {
				this.$store.commit("SET_STEP_VALID");
			}

			tracking_pushEvent(Events.SELECT_SIZE, {
				formatId: value,
				formatName: this.option.productSize.fullName,
				productId: this.selectedProduct.id,
				productName: this.selectedProduct.name
			});
		},
		checked: function checked(value) {
			return this.selectedFormat !== null ? this.selectedFormat.id === value : false;
		}
	},
	mounted: function mounted() {
		if (this.isSingleOption) {
			this.selectFormat(this.availableFormats[0].id);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f21e097a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/format/format-option.vue
var format_option_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.uploadsAreComplete || _vm.checked(_vm.option.id) || _vm.hasMultipleSpecifications)?_c('div',{staticClass:"cell configurator-options__wrapper"},[_c('div',{staticClass:"configurator-options__item cursor-pointer",class:{'configurator-options__item--active' : _vm.checked(_vm.option.id)},on:{"click":function($event){return _vm.selectFormat(_vm.option.id)}}},[_c('img',{staticClass:"configurator-options__image",attrs:{"src":_vm.imagePath,"width":"500"}}),_vm._v(" "),_c('input',{staticClass:"configurator-block__input input-field input-field--custom",attrs:{"id":_vm.option.id,"type":"radio","name":"selectFormat"},domProps:{"checked":_vm.checked(_vm.option.id)}}),_vm._v(" "),_c('span',{staticClass:"configurator__input-selectable"}),_vm._v(" "),_c('p',{staticClass:"configurator-block__label cursor-pointer"},[(_vm.uploadsAreComplete && _vm.isCustomSize && _vm.checked(_vm.option.id))?_c('span',[_vm._v("\n\t\t\t\t"+_vm._s(_vm.customSize.width)+" X "+_vm._s(_vm.customSize.height)+" mm (")]):_vm._e(),_vm._v("\n\t\t\t"+_vm._s(_vm.formatInfo.name)+"\n\t\t\t"),(_vm.uploadsAreComplete && _vm.isCustomSize && _vm.checked(_vm.option.id))?_c('span',[_vm._v(")")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"indicator-container indicator-container--top"},[(_vm.option.isBestChoice)?_c('span',{staticClass:"best-choice--label"},[_vm._v("\n\t\t\t\tmeest gekozen\n\t\t\t")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"indicator-container indicator-container--bottom"},[(_vm.hasOffsetAvailable)?_c('div',{staticClass:"indicator"},[_c('tooltip',{attrs:{"hover":"","tooltip-wrapper-class-name":"tool-tip__wrapper--offset","content":"Offset beschikbaar"}},[_c('div',{staticClass:"indicator__icon tool-tip__arrow-hook",domProps:{"innerHTML":_vm._s(_vm.getSvg.icon.inkDrops)}})])],1):_vm._e()]),_vm._v(" "),(!_vm.disabled && !_vm.option.isOffTheShelf)?_c('modal',{staticClass:"tool-tip__wrapper--absolute",attrs:{"title":"Informatie & aanleverspecificaties","button-style":"tooltip","button-text":"Informatie"}},[_c('delivery-specification',{attrs:{"format":_vm.option}})],1):_vm._e()],1)]):_vm._e()}
var format_option_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/format/format-option.vue
function format_option_injectStyle (context) {
  __webpack_require__("kdde")
}
/* script */


/* template */

/* template functional */
var format_option___vue_template_functional__ = false
/* styles */
var format_option___vue_styles__ = format_option_injectStyle
/* scopeId */
var format_option___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var format_option___vue_module_identifier__ = null

var format_option_Component = Object(component_normalizer["a" /* default */])(
  format_option,
  format_option_render,
  format_option_staticRenderFns,
  format_option___vue_template_functional__,
  format_option___vue_styles__,
  format_option___vue_scopeId__,
  format_option___vue_module_identifier__
)

/* harmony default export */ var format_format_option = (format_option_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/optional/format-custom.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var format_custom = ({
	name: "FormatCustom",
	components: { step: components_step_step },
	data: function data() {
		return {
			customWidth: 0,
			customHeight: 0,
			customUnitSize: null,
			unitSizes: [{ name: "mm", multiplier: 1 }, { name: "cm", multiplier: 10 }, { name: "m", multiplier: 1000 }]
		};
	},

	computed: {
		selectedFormat: function selectedFormat() {
			return this.$store.getters.getSelectedFormat;
		},
		trimmedLimits: function trimmedLimits() {
			// The specification sizes include bleed, the entered size is the end size without bleed
			var f = this.selectedFormat;
			var axisBleed = (f.bleed || 0) * 2;

			return {
				minWidthInMm: f.minWidthInMm - axisBleed,
				maxWidthInMm: f.maxWidthInMm - axisBleed,
				minHeightInMm: f.minHeightInMm - axisBleed,
				maxHeightInMm: f.maxHeightInMm - axisBleed
			};
		},
		customWidthInMm: function customWidthInMm() {
			return this.customWidth * this.customUnitSize.multiplier;
		},
		customHeightInMm: function customHeightInMm() {
			return this.customHeight * this.customUnitSize.multiplier;
		},
		getCustomSize: function getCustomSize() {
			return this.$store.getters.getCustomSize;
		},
		customSizeValid: function customSizeValid() {
			return this.$store.getters.getCustomSizeValid;
		},
		getSelectedFormatDescription: function getSelectedFormatDescription() {
			return this.$store.getters.getSelectedFormatDescription;
		}
	},
	methods: {
		calculatedAmount: function calculatedAmount(input) {
			return input / this.customUnitSize.multiplier;
		},
		setFirstActive: function setFirstActive() {
			this.customUnitSize = this.unitSizes[1];
		},
		setCustomSize: function setCustomSize(data) {
			this.$store.commit("SET_CUSTOM_SIZE", data);
		},
		validateCustomSize: function validateCustomSize() {
			var _this = this;

			var f = this.trimmedLimits;

			var portraitCondition = this.customHeightInMm < f.minHeightInMm || this.customHeightInMm > f.maxHeightInMm || this.customWidthInMm < f.minWidthInMm || this.customWidthInMm > f.maxWidthInMm;

			var landscapeCondition = this.customWidthInMm < f.minHeightInMm || this.customWidthInMm > f.maxHeightInMm || this.customHeightInMm < f.minWidthInMm || this.customHeightInMm > f.maxWidthInMm;

			var squareCondition = this.customWidthInMm < Math.max(f.minHeightInMm, f.minWidthInMm) || this.customWidthInMm > Math.min(f.maxHeightInMm, f.maxWidthInMm);

			var setCustomFormatInvalid = function setCustomFormatInvalid() {
				_this.$store.commit("SET_CUSTOM_SIZE_VALID", false);
				_this.$store.commit("SET_STEP_INVALID");
				_this.setCustomSize({ width: null, height: null });
			};

			var setCustomFormatValid = function setCustomFormatValid() {
				_this.$store.commit("SET_CUSTOM_SIZE_VALID", true);
				_this.$store.commit("SET_STEP_VALID");
				_this.setCustomSize({
					height: _this.customHeightInMm,
					width: _this.customWidthInMm
				});
			};

			if (this.customWidth && this.customHeight) {
				if (this.customWidthInMm < this.customHeightInMm) {
					if (portraitCondition) {
						setCustomFormatInvalid();

						if (landscapeCondition) {
							setCustomFormatInvalid();
						} else {
							setCustomFormatValid();
						}
					} else {
						setCustomFormatValid();
					}
				} else if (this.customWidthInMm > this.customHeightInMm) {
					if (landscapeCondition) {
						setCustomFormatInvalid();

						if (portraitCondition) {
							setCustomFormatInvalid();
						} else {
							setCustomFormatValid();
						}
					} else {
						setCustomFormatValid();
					}
				} else if (this.customWidthInMm === this.customHeightInMm) {
					if (squareCondition) {
						setCustomFormatInvalid();
					} else {
						setCustomFormatValid();
					}
				}
			} else {
				setCustomFormatInvalid();
			}
		},
		getSetCustomSize: function getSetCustomSize() {
			if (this.getCustomSize != null) {
				this.customWidth = this.calculatedAmount(this.getCustomSize.width);
				this.customHeight = this.calculatedAmount(this.getCustomSize.height);
			}
		}
	},
	created: function created() {
		this.setFirstActive();
	},
	mounted: function mounted() {
		this.getSetCustomSize();
		this.validateCustomSize();
	},
	beforeDestroy: function beforeDestroy() {
		if (this.$store.getters.getCurrentStep.data.name !== "uploader" && !this.$store.getters.isCustomSize) {
			this.setCustomSize({ width: null, height: null });
		}

		this.$store.commit("SET_STEP_VALID");
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f566f3cc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/optional/format-custom.vue
var format_custom_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configurator-step__inner configurator-step__inner--light-blue mt-m mb-s",class:{'configurator-step__inner--valid' : _vm.customSizeValid}},[_c('h4',{staticClass:"mb-s"},[_vm._v("Kies uw eindformaat")]),_vm._v(" "),_c('div',{staticClass:"grid grid--gutters"},[_c('div',{staticClass:"cell"},[_c('label',{staticClass:"input-label"},[_vm._v("Breedte:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.customWidth),expression:"customWidth",modifiers:{"number":true}}],staticClass:"input-field input-field--border",attrs:{"type":"number","placeholder":"Breedte","min":"0"},domProps:{"value":(_vm.customWidth)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.customWidth=_vm._n($event.target.value)},_vm.validateCustomSize],"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"cell"},[_c('label',{staticClass:"input-label"},[_vm._v("Hoogte:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.customHeight),expression:"customHeight",modifiers:{"number":true}}],staticClass:"input-field input-field--border",attrs:{"type":"number","placeholder":"Hoogte","min":"0"},domProps:{"value":(_vm.customHeight)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.customHeight=_vm._n($event.target.value)},_vm.validateCustomSize],"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"cell"},[_c('div',{staticClass:"custom-sizes-unit"},[_c('label',{staticClass:"input-label"},[_vm._v("Eenheid:")]),_vm._v(" "),_c('div',{staticClass:"dropdown-container"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.customUnitSize),expression:"customUnitSize"}],staticClass:"input-field input-field--border",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.customUnitSize=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.validateCustomSize]}},_vm._l((_vm.unitSizes),function(unit,index){return _c('option',{key:index,domProps:{"selected":unit === _vm.customUnitSize,"value":unit,"textContent":_vm._s(unit.name)}})}),0)])])])]),_vm._v(" "),(!_vm.customSizeValid)?_c('div',{staticClass:"custom-size-message mt-s"},[_c('p',[_vm._v("Kies een breedte tussen\n\t\t\t"+_vm._s(_vm.calculatedAmount(_vm.trimmedLimits.minWidthInMm))+" en\n\t\t\t"+_vm._s(_vm.calculatedAmount(_vm.trimmedLimits.maxWidthInMm))+" "+_vm._s(_vm.customUnitSize.name)+" en een hoogte tussen\n\t\t\t"+_vm._s(_vm.calculatedAmount(_vm.trimmedLimits.minHeightInMm))+" en\n\t\t\t"+_vm._s(_vm.calculatedAmount(_vm.trimmedLimits.maxHeightInMm))+" "+_vm._s(_vm.customUnitSize.name)+".\n\t\t")])]):_c('div',{staticClass:"custom-size-message mt-s"},[_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getSelectedFormatDescription)}})])])])}
var format_custom_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/optional/format-custom.vue
/* script */


/* template */

/* template functional */
var format_custom___vue_template_functional__ = false
/* styles */
var format_custom___vue_styles__ = null
/* scopeId */
var format_custom___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var format_custom___vue_module_identifier__ = null

var format_custom_Component = Object(component_normalizer["a" /* default */])(
  format_custom,
  format_custom_render,
  format_custom_staticRenderFns,
  format_custom___vue_template_functional__,
  format_custom___vue_styles__,
  format_custom___vue_scopeId__,
  format_custom___vue_module_identifier__
)

/* harmony default export */ var optional_format_custom = (format_custom_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/element/description.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var description = ({
	name: "Description",
	data: function data() {
		return {};
	},

	computed: {
		textMinMaxIncrement: function textMinMaxIncrement() {
			return "Dit product heeft een minimum van " + this.selectedFormat.minPageCount + " en een maximum van " + this.selectedFormat.maxPageCount + " pagina's met een meervoud van " + this.selectedFormat.pageIncrement + ".";
		},
		selectedFormat: function selectedFormat() {
			return this.$store.getters.getSelectedFormat;
		},
		pageCount: function pageCount() {
			return this.$store.getters.getPageCount;
		},
		productName: function productName() {
			return this.$store.getters.getSelectedProduct.name || "Product";
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91a1ae60","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/description.vue
var description_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"description__text mv-s"},[_vm._v("\n\tEen "+_vm._s(_vm.productName.toLowerCase())+" met "+_vm._s(_vm.pageCount)+" pagina's heeft "+_vm._s(_vm.pageCount / 2)+" vellen.\n\tKiest u voor dubbelzijdige bedrukking voor het binnenwerk dan zijn er dus "+_vm._s(_vm.pageCount)+" zijdes die u kunt opmaken.\n\tKiest u voor enkelzijdige bedrukking dan zijn er maar "+_vm._s(_vm.pageCount / 2)+" drukbare zijdes.\n\tBij enkelzijdige bedrukking zijn er om en om wel en geen drukbare zijde.\n\tWanneer u kiest voor een enkelzijdige bedrukking levert u enkel de bedrukte pagina’s aan in het PDF.\n\t"+_vm._s(_vm.textMinMaxIncrement)+"\n")])}
var description_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/element/description.vue
function description_injectStyle (context) {
  __webpack_require__("cX/a")
}
/* script */


/* template */

/* template functional */
var description___vue_template_functional__ = false
/* styles */
var description___vue_styles__ = description_injectStyle
/* scopeId */
var description___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var description___vue_module_identifier__ = null

var description_Component = Object(component_normalizer["a" /* default */])(
  description,
  description_render,
  description_staticRenderFns,
  description___vue_template_functional__,
  description___vue_styles__,
  description___vue_scopeId__,
  description___vue_module_identifier__
)

/* harmony default export */ var element_description = (description_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/optional/page-count.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var page_count = ({
	name: "PageCount",
	components: { description: element_description },
	data: function data() {
		return {
			valid: false,
			unvalidPageCount: false
		};
	},

	computed: {
		pageCount: {
			get: function get() {
				return this.$store.getters.getPageCount;
			},
			set: function set(a) {
				this.setPageCount(a);
			}
		},
		selectedFormat: function selectedFormat() {
			return this.$store.getters.getSelectedFormat;
		},
		hasSelectedFormat: function hasSelectedFormat() {
			return this.$store.getters.checkData.hasSelectedFormat;
		},
		printSidesAvailability: function printSidesAvailability() {
			return this.$store.getters.getPrintSidesAvailability;
		},
		textMinMaxIncrement: function textMinMaxIncrement() {
			return "Dit product heeft een minimum van " + this.selectedFormat.minPageCount + " en een maximum van " + this.selectedFormat.maxPageCount + " pagina's met een meervoud van " + this.selectedFormat.pageIncrement + ".";
		},
		dictionary: function dictionary() {
			return this.$store.getters.getDictionary;
		},
		isBookProduct: function isBookProduct() {
			return this.$store.getters.isBookProduct;
		},
		hasDescription: function hasDescription() {
			var _this = this;

			var showDescription = this.$store.getters.getSelectedFormat.productOptionGroups.some(function (x) {
				return _this.dictionary.optionCategory[x.optionCategory] === "print" && _this.dictionary.chunkType[x.chunkType] === "content" && _this.isBookProduct && _this.pageCount > 0;
			});

			return showDescription;
		}
	},
	methods: {
		setPageCount: function setPageCount(data) {
			this.$store.commit("SET_PAGE_COUNT", data);
		},
		validatePageCount: function validatePageCount() {
			var _this2 = this;

			var min = this.selectedFormat.minPageCount;
			var max = this.selectedFormat.maxPageCount;
			var percentage = this.pageCount / max * 100;
			var rangeSlider = this.$refs.amountInputRange;

			if (rangeSlider) {
				rangeSlider.style.background = "linear-gradient(to right, var(--cfg-primary-dark) " + percentage + "%, #fff " + percentage + "%)";
			}

			this.unvalidPageCount = false;

			clearTimeout(this.debounceTimeout);

			this.debounceTimeout = setTimeout(function () {
				_this2.valid = _this2.$store.getters.validatePageCount;

				if (!_this2.valid && !_this2.printSidesAvailability.set && _this2.hasSelectedFormat) {
					if (_this2.pageCount < min) {
						_this2.setPageCount(min);
					} else if (_this2.pageCount > max) {
						_this2.setPageCount(max);
					} else if (_this2.pageCount % _this2.selectedFormat.pageIncrement !== 0 && _this2.selectedFormat.pageIncrement !== 0) {
						var increment = _this2.selectedFormat.pageIncrement;
						var probableValid = Math.ceil(_this2.pageCount / increment) * increment;
						_this2.lastValidatedPageCount = _this2.pageCount;
						_this2.unvalidPageCount = true;
						_this2.setPageCount(probableValid);
					}

					_this2.validatePageCount();
				}
			}, 500);
		},
		pageCountIncrement: function pageCountIncrement() {
			this.pageCount = this.pageCount + this.selectedFormat.pageIncrement;
			this.validatePageCount();
		},
		pageCountDecrement: function pageCountDecrement() {
			this.pageCount = this.pageCount - this.selectedFormat.pageIncrement;
			this.validatePageCount();
		}
	},
	created: function created() {
		if (this.pageCount < this.selectedFormat.minPageCount || this.pageCount > this.selectedFormat.maxPageCount || this.pageCount === null) {
			this.pageCount = this.selectedFormat.minPageCount;
		}
		this.validatePageCount();
	},
	mounted: function mounted() {
		this.validatePageCount();
	},

	watch: {
		selectedFormat: function selectedFormat(a, b) {
			this.validatePageCount();
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e5ee124","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/optional/page-count.vue
var page_count_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configurator-step__page-selector"},[_c('h3',[_vm._v("Aantal pagina's")]),_vm._v(" "),_c('p',[_vm._v("Selecteer het aantal pagina's exclusief omslag:")]),_vm._v(" "),_c('div',{staticClass:"flex-space flex-align--center mt-s"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.pageCount),expression:"pageCount",modifiers:{"number":true}}],ref:"amountInputRange",staticClass:"amount-input__range",attrs:{"step":_vm.selectedFormat.pageIncrement,"min":0,"max":_vm.selectedFormat.maxPageCount,"type":"range","placeholder":"Aantal"},domProps:{"value":(_vm.pageCount)},on:{"input":_vm.validatePageCount,"__r":function($event){_vm.pageCount=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.pageCount),expression:"pageCount",modifiers:{"number":true}}],staticClass:"amount-field ml-s mr-xs",class:{'amount-field--invalid' : !_vm.valid},attrs:{"type":"number","step":_vm.selectedFormat.pageIncrement,"min":_vm.selectedFormat.minPageCount,"max":_vm.selectedFormat.maxPageCount},domProps:{"value":(_vm.pageCount)},on:{"blur":[_vm.validatePageCount,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.pageCount=_vm._n($event.target.value)}}}),_vm._v(" "),_c('p',[_vm._v("Pagina's")])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.unvalidPageCount),expression:"unvalidPageCount"}],staticClass:"description__text color-error"},[_vm._v("Ongeldig aantal pagina's. Het aantal is teruggezet naar "+_vm._s(_vm.pageCount)+" pagina's.")]),_vm._v(" "),(_vm.hasDescription)?_c('description'):_vm._e()],1)}
var page_count_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/optional/page-count.vue
function page_count_injectStyle (context) {
  __webpack_require__("2fgd")
}
/* script */


/* template */

/* template functional */
var page_count___vue_template_functional__ = false
/* styles */
var page_count___vue_styles__ = page_count_injectStyle
/* scopeId */
var page_count___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var page_count___vue_module_identifier__ = null

var page_count_Component = Object(component_normalizer["a" /* default */])(
  page_count,
  page_count_render,
  page_count_staticRenderFns,
  page_count___vue_template_functional__,
  page_count___vue_styles__,
  page_count___vue_scopeId__,
  page_count___vue_module_identifier__
)

/* harmony default export */ var optional_page_count = (page_count_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/format/format.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var format = ({
	name: "Format",
	components: {
		step: components_step_step,
		formatOption: format_format_option,
		formatCustom: optional_format_custom,
		pageCount: optional_page_count
	},
	computed: {
		configuratorType: function configuratorType() {
			return this.$store.getters.getConfiguratorType;
		},
		check: function check() {
			return this.$store.getters.checkData;
		},
		selectedFormat: function selectedFormat() {
			return this.$store.getters.getSelectedFormat;
		},
		availableFormats: function availableFormats() {
			return this.$store.getters.getAvailableFormats;
		},
		specificationMatches: function specificationMatches() {
			return this.$store.getters.getFormatMatches;
		},
		getCustomSizeValid: function getCustomSizeValid() {
			return this.$store.getters.getCustomSizeValid;
		},
		getConfiguratorData: function getConfiguratorData() {
			return this.$store.getters.getConfiguratorData;
		},
		hasSeparateCover: function hasSeparateCover() {
			return this.$store.getters.hasSeparateCover;
		},
		hasMultipleSpecificationMatches: function hasMultipleSpecificationMatches() {
			return this.getConfiguratorData.hasFormatMatches;
		},
		title: function title() {
			return this.$store.getters.uploadsAreComplete && !this.hasMultipleSpecificationMatches ? "Dit is uw bestand" : "Kies een formaat";
		},
		uploadsAreComplete: function uploadsAreComplete() {
			return this.$store.getters.uploadsAreComplete;
		},
		printSidesCountChoice: function printSidesCountChoice() {
			return this.$store.getters.isPrintSidesCountChoice;
		},
		formatDescription: function formatDescription() {
			return this.$store.getters.getSelectedFormatDescription;
		},
		getUniqueOrientations: function getUniqueOrientations() {
			return this.$store.getters.getUniqueOrientations;
		},
		showOrientation: function showOrientation() {
			return this.$store.getters.showOrientation;
		},
		getDictionary: function getDictionary() {
			return this.$store.getters.getDictionary;
		},
		getSvg: function getSvg() {
			return this.$store.getters.getSvg;
		}
	},
	methods: {
		orientationLegend: function orientationLegend(orientations, hasSelectedFormat) {
			var _this = this;

			var both = orientations.includes(0);
			var portrait = orientations.includes(1);
			var landscape = orientations.includes(2);

			var result = "<div class=\"orientation-indicator configurator-step__title\">";

			var _ref = function () {
				if (both) {
					return {
						svg: _this.getSvg.orientation.both,
						name: "Staand en liggend"
					};
				} else if (portrait) {
					return {
						svg: _this.getSvg.orientation.portrait,
						name: "Staand"
					};
				} else if (landscape) {
					return {
						svg: _this.getSvg.orientation.landscape,
						name: "Liggend"
					};
				}
			}(),
			    svg = _ref.svg,
			    name = _ref.name;

			if (svg) {
				result += "<div class=\"orientation orientation--relative orientation--indicator\">" + svg + "</div>";
			}

			if (name) {
				result += "<span class=\"orientation-indicator__text\">\n\t\t\t\t\t\t" + name + " " + (!hasSelectedFormat ? "mogelijk " : "") + "\n\t\t\t\t\t</span>";
			}

			result += "</div>";

			return result;
		},
		emptyCustomSize: function emptyCustomSize() {
			this.$store.commit("SET_CUSTOM_SIZE", { width: null, height: null });
		},
		stepExists: function stepExists(stepToCheck) {
			return this.$store.getters.getStepExists(stepToCheck);
		},
		setStepActive: function setStepActive(step) {
			if (this.stepExists(step).bool) {
				this.$store.commit("SET_STEP_ACTIVE", step);
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bab5bfc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/format/format.vue
var format_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('step',{attrs:{"name":"select-format","title":_vm.title,"valid":""}},[_c('template',{slot:"title"},[_c('div',{staticClass:"grid"},[_c('div',{staticClass:"cell cell--fit"},[(_vm.check.hasSelectedFormat)?[_c('div',{staticClass:"h5 configurator-step__title cursor-pointer",on:{"click":function($event){return _vm.setStepActive('select-format')}}},[(_vm.selectedFormat.productSize.fullName)?_c('span',{staticClass:"configurator-step__count configurator-step__count--valid"}):_c('span',{staticClass:"configurator-step__count"},[_vm._v("1")]),_vm._v("\n\t\t\t\t\t\tFormaat\n\t\t\t\t\t\t"),_c('span',{staticClass:"configurator-step__semi-colon configurator-step__not-active-mobile"},[_vm._v(":")]),_vm._v(" "),_c('span',{staticClass:"configurator-step__item configurator-step__not-active-mobile"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.selectedFormat.productSize.fullName)+"\n\t\t\t\t\t\t")])])]:[_c('div',{staticClass:"h5 configurator-step__title"},[_c('span',{staticClass:"configurator-step__count"},[_vm._v("1")]),_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.title)+"\n\t\t\t\t\t")])]],2)])]),_vm._v(" "),(_vm.configuratorType.isConfiguration)?_c('div',{staticClass:"alertbox alertbox--error alertbox mb-l"},[_c('svg',{staticClass:"alertbox__icon alertbox__icon--error"},[_c('use',{attrs:{"xlink:href":"#alert--error"}})]),_vm._v(" "),_c('p',{staticClass:"alertbox__text"},[_c('strong',[_vm._v("Let op:")]),_vm._v("\n\t\t\tHet aanpassen van een formaat is niet mogelijk.\n\t\t\tDoorloop hiervoor de stappen voor dit product opnieuw.\n\t\t")])]):_vm._e(),_vm._v(" "),(_vm.uploadsAreComplete && _vm.hasMultipleSpecificationMatches)?_c('div',{staticClass:"alertbox alertbox--warning alertbox mb-l"},[_c('svg',{staticClass:"alertbox__icon alertbox__icon--warning"},[_c('use',{attrs:{"xlink:href":"#alert--warning"}})]),_vm._v(" "),_c('p',{staticClass:"alertbox__text"},[_c('strong',[_vm._v("Let op:")]),_vm._v("\n\t\t\tUw upload past bij meerdere formaten.\n\t\t\tSelecteer uit onderstaande lijst handmatig uw gewenste formaat.\n\t\t")])]):_vm._e(),_vm._v(" "),(!_vm.configuratorType.isConfiguration)?[_c('div',{staticClass:"configurator-options grid grid--gutters-s grid--1-5 grid--l-1-4 grid--ms-1-2"},[(!_vm.hasMultipleSpecificationMatches)?_vm._l((_vm.availableFormats),function(format,index){return _c('format-option',{key:index,attrs:{"option":format,"disabled":_vm.uploadsAreComplete}})}):_vm._l((_vm.specificationMatches),function(format,index){return _c('format-option',{key:index,attrs:{"option":format}})})],2),_vm._v(" "),(_vm.check.hasSelectedFormat && _vm.selectedFormat.isCustomSize && !_vm.uploadsAreComplete)?_c('format-custom'):_vm._e()]:_vm._e()],2)}
var format_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/format/format.vue
/* script */


/* template */

/* template functional */
var format___vue_template_functional__ = false
/* styles */
var format___vue_styles__ = null
/* scopeId */
var format___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var format___vue_module_identifier__ = null

var format_Component = Object(component_normalizer["a" /* default */])(
  format,
  format_render,
  format_staticRenderFns,
  format___vue_template_functional__,
  format___vue_styles__,
  format___vue_scopeId__,
  format___vue_module_identifier__
)

/* harmony default export */ var format_format = (format_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/option/option-item.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var option_item = ({
	name: "OptionItem",
	components: { tooltip: element_tooltip },
	props: {
		option: {
			type: Object,
			required: true
		},
		group: {
			type: Object,
			required: true
		}
	},
	data: function data() {
		return {
			descriptionActive: false
		};
	},

	computed: {
		imageClass: function imageClass() {
			var imageClass = "";
			imageClass += this.group.rounded ? "configurator-options__shape--circle" : "configurator-options__shape--square";
			return imageClass;
		},
		showImage: function showImage() {
			return this.group.image;
		},
		showOption: function showOption() {
			if (this.groupIsLocked && !this.checked) {
				return false;
			}
			if (this.printSidesLocked && !this.checked) {
				return false;
			}
			return !(this.unmetRequired && this.getUnavailableOptions.length >= 6);
		},
		parent: function parent() {
			return this.group;
		},
		selectedOptions: function selectedOptions() {
			return this.$store.getters.getSelectedOptions;
		},
		imagePath: function imagePath() {
			return this.option.iconPath;
		},
		selectedOptionIds: function selectedOptionIds() {
			return this.$store.getters.getSelectedOptionIds;
		},
		printSidesCountChoice: function printSidesCountChoice() {
			return this.$store.getters.isPrintSidesCountChoice;
		},
		requiredOptionsWithinGroups: function requiredOptionsWithinGroups() {
			return this.$store.getters.getRequiredOptionsWithinGroups;
		},
		printSidesAvailability: function printSidesAvailability() {
			return this.$store.getters.getPrintSidesAvailability;
		},
		coverPrintSidesAvailability: function coverPrintSidesAvailability() {
			return this.$store.getters.getCoverPrintSidesAvailability;
		},
		existingConfigurationFinalized: function existingConfigurationFinalized() {
			return this.$store.getters.existingConfigIsFinalized;
		},
		uploadsComplete: function uploadsComplete() {
			return this.$store.getters.uploadsAreComplete;
		},
		dictionary: function dictionary() {
			return this.$store.getters.getDictionary;
		},
		deferredOption: function deferredOption() {
			var _this = this;

			var isVisible = this.group.visibleOptionIds.some(function (o) {
				return o.id === _this.option.id;
			});
			return !isVisible;
		},
		groupIsLocked: function groupIsLocked() {
			return this.$store.getters.getLockedOptionGroupIds.includes(this.group.id);
		},
		notAvailableWithOffset: function notAvailableWithOffset() {
			return this.getOrderLine.isOffset && !this.hasOffsetAvailable;
		},
		printSidesLocked: function printSidesLocked() {
			// Once a PDF has been uploaded (or an existing configuration with an upload is
			// reopened), the number of sides is derived from the uploaded file and must not
			// be changeable anymore - the customer already committed to it when uploading.
			if ((this.uploadsComplete || this.existingConfigurationFinalized) && this.dictionary.optionCategory[this.group.type] === "print") {
				// if has upload and type is print
				if (this.printSidesCountChoice && this.$store.getters.getFile.pageCount !== this.option.printSideCount) {
					// if isPrintSidesCountChoice (read store~index.js) && sides to print dont equal the pagecount. The option needs to be unmet.
					return this.$store.getters.getFile.pageCount !== null; // because it does need a pagecount to be able to check.
				}

				if (this.dictionary.chunkType[this.group.chunkType] === "content" && this.printSidesAvailability.set) {
					// if has upload and type is print and chunktype is content
					if (!this.printSidesAvailability.single && this.option.printSideCount === 1) {
						// if singlesided print is not possible (based on upload) and current iteration of option selects singlesided print
						return true;
					}

					if (!this.printSidesAvailability.double && this.option.printSideCount === 2) {
						// if doublesided print is not possible (based on upload) and current iteration of option selects doublesided print
						return true;
					}
				}

				if (this.dictionary.chunkType[this.group.chunkType] === "cover" && this.coverPrintSidesAvailability.set) {
					// if has upload and type is print and chunktype is cover
					if (!this.coverPrintSidesAvailability.single && this.option.printSideCount === 1) {
						// if singlesided print is not possible for the cover (based on upload) and current iteration of option selects singlesided print
						return true;
					}

					if (!this.coverPrintSidesAvailability.double && this.option.printSideCount === 2) {
						// if doublesided print is not possible for the cover (based on upload) and current iteration of option selects doublesided print
						return true;
					}
				}
			}

			return false;
		},
		unmetRequired: function unmetRequired() {
			if (this.printSidesLocked) {
				return true;
			}

			if (this.getAvailableOptions.includes(this.option.id)) {
				return false;
			}
			if (this.getUnavailableOptions.includes(this.option.id)) {
				return true;
			}
		},
		itemClass: function itemClass() {
			var itemClass = [];
			if (!this.isOffTheShelf) {
				itemClass.push("configurator-options__item--list");
			}

			if (this.deferredOption) {
				itemClass.push("configurator-options__item--deferred");
			}

			if (this.checked) {
				itemClass.push("configurator-options__item--active");
			}

			if (this.unmetRequired && this.getUnavailableOptions.length < 6 || this.notAvailableWithOffset) {
				itemClass.push("configurator-options__item--unmet-requirements");
			}
			return itemClass;
		},
		checked: function checked() {
			var checked = false;

			for (var i in this.selectedOptions) {
				if (this.selectedOptions[i].id === this.option.id) {
					checked = true;
				}
			}
			return checked;
		},
		getOrderLine: function getOrderLine() {
			return this.$store.getters.getOrderLine;
		},
		hasOffsetAvailable: function hasOffsetAvailable() {
			return this.option.hasOffsetPrices;
		},
		hasOffsetAvailableCalculated: function hasOffsetAvailableCalculated() {
			var _this2 = this;

			// check based on option id, in groups, of available offsetprices with previousely selected options
			var relevantOptionIds = [];
			var toSelect = this.option.baseOptionId;
			var groups = this.$store.getters.getUnsortedSelectedGroups;

			var relevantOptionGroups = [];
			keys_default()(groups).forEach(function (key) {
				if (groups[key].id !== _this2.$store.getters.getCurrentStep.data.groupId) {
					if (groups[key].optionCategory > 0) {
						relevantOptionGroups.push(groups[key]);
					}
				}
			});

			this.$store.getters.getUnsortedSelectedOptions.forEach(function (option) {
				relevantOptionGroups.forEach(function (group) {
					if (group.id === option.parentGroupId) {
						relevantOptionIds.push(option.baseOptionId);
					}
				});
			});

			relevantOptionIds.push(toSelect);

			var availableOffsetPricings = this.$store.getters.getSelectedFormat.offsetPricings.find(function (pricings) {
				if (relevantOptionIds.every(function (id) {
					return pricings.optionIds.includes(id);
				})) {
					return pricings;
				}
			});

			return availableOffsetPricings;
		},
		getSvg: function getSvg() {
			return this.$store.getters.getSvg;
		},
		getAvailableOptions: function getAvailableOptions() {
			return this.$store.getters.getAvailableOptions;
		},
		getUnavailableOptions: function getUnavailableOptions() {
			return this.$store.getters.getUnavailableOptions;
		},
		isOffTheShelf: function isOffTheShelf() {
			return this.$store.getters.isOffTheShelf;
		}
	},
	methods: {
		clickEvent: function clickEvent() {
			if (this.unmetRequired) {
				return;
			}

			this.selectOption(this.parent.id, this.option);
		},
		setImage: function setImage() {
			this.$emit("setSelectedOptionImage", this.imagePath);
		},
		selectOption: function selectOption(parentId, option) {
			option.parentGroupId = parentId;
			this.$store.commit("SET_SELECTED_OPTION", option);
			this.setImage();

			tracking_pushEvent(Events.SELECT_OPTION, {
				optionId: option.id,
				optionName: option.name,
				groupId: parentId,
				groupName: this.parent.name
			});
		}
	},
	watch: {
		unmetRequired: function unmetRequired(a, b) {
			if (a === true && this.checked && this.uploadsComplete) {
				this.$store.commit("CLEAR_SELECTED_OPTION", this.group.id);
				this.$store.commit("SET_STEP_ACTIVE", this.group.id);

				if (this.printSidesCountChoice) {
					EventBus.$emit("configuratorModal", {
						title: "Bedrukking niet mogelijk",
						content: "<p>De door u gekozen bedrukking is niet mogelijk met het ge\xFCploade bestand</p>"
					});
				} else {
					var printTypeString = !this.printSidesAvailability.single ? "enkelzijdig" : !this.printSidesAvailability.double ? "dubbelzijdig" : null;

					EventBus.$emit("configuratorModal", {
						title: "Bedrukking " + printTypeString + " niet mogelijk",
						content: "<p>De door u gekozen bedrukking(" + printTypeString + ") is niet mogelijk met het ge\xFCploade bestand</p>"
					});
				}
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fdcfec3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/option/option-item.vue
var option_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showOption)?_c('div',{staticClass:"cell configurator-options__wrapper"},[_c('div',{staticClass:"configurator-options__item cursor-pointer",class:{
			'configurator-options__item--active' : _vm.checked
	},on:{"click":function($event){return _vm.clickEvent()}}},[_c('img',{staticClass:"configurator-options__image",attrs:{"src":_vm.imagePath,"width":"500"}}),_vm._v(" "),_c('input',{staticClass:"configurator-block__input input-field input-field--custom",attrs:{"id":_vm.option.id,"type":"radio","name":"selectOption","disabled":_vm.unmetRequired || _vm.notAvailableWithOffset},domProps:{"checked":_vm.checked}}),_vm._v(" "),_c('span',{staticClass:"configurator__input-selectable"}),_vm._v(" "),_c('p',{staticClass:"configurator-block__label cursor-pointer"},[_vm._v("\n\t\t\t"+_vm._s(_vm.option.name)+"\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"indicator-container indicator-container--bottom"},[(_vm.option.isSustainableChoice)?_c('div',{staticClass:"indicator"},[_c('tooltip',{attrs:{"hover":"","tooltip-wrapper-class-name":"tool-tip__wrapper--sustainable","content":"Duurzaam product"}},[_c('div',{staticClass:"indicator__icon tool-tip__arrow-hook",domProps:{"innerHTML":_vm._s(_vm.getSvg.icon.leaf)}})])],1):_vm._e(),_vm._v(" "),(_vm.hasOffsetAvailable && _vm.hasOffsetAvailableCalculated)?_c('div',{staticClass:"indicator"},[_c('tooltip',{attrs:{"hover":"","tooltip-wrapper-class-name":"tool-tip__wrapper--offset","content":"Offset beschikbaar"}},[_c('div',{staticClass:"indicator__icon tool-tip__arrow-hook",domProps:{"innerHTML":_vm._s(_vm.getSvg.icon.inkDrops)}})])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"indicator-container indicator-container--top"},[(_vm.option.isOnlyForTesting)?_c('span',{staticClass:"only-for-testing--label",attrs:{"title":"Deze optie is alleen zichtbaar voor jou omdat je bent ingelogd met een intern testaccount. Klanten zien deze optie niet."}},[_vm._v("\n\t\t\t\tOnlyForTesting\n\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.option.isBestChoice)?_c('span',{staticClass:"best-choice--label"},[_vm._v("\n\t\t\t\tmeest gekozen\n\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.option.description && _vm.option.description.length > 3)?_c('div',{staticClass:"tool-tip__wrapper grid tool-tip__wrapper--absolute tool-tip__wrapper--multi"},[_c('div',{staticClass:"tool-tip__wrapper-inner",on:{"mouseenter":function($event){_vm.descriptionActive = true},"mouseleave":function($event){_vm.descriptionActive = false}}},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.descriptionActive),expression:"descriptionActive"}],staticClass:"tool-tip"},[_c('span',[_vm._v(_vm._s(_vm.option.description))])])]),_vm._v(" "),_c('span',{staticClass:"tool-tip__label tool-tip__label--absolute",attrs:{"title":"Info"}},[_vm._v("i")])],1)]):_vm._e()])])]):_vm._e()}
var option_item_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/option/option-item.vue
function option_item_injectStyle (context) {
  __webpack_require__("y5/u")
}
/* script */


/* template */

/* template functional */
var option_item___vue_template_functional__ = false
/* styles */
var option_item___vue_styles__ = option_item_injectStyle
/* scopeId */
var option_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var option_item___vue_module_identifier__ = null

var option_item_Component = Object(component_normalizer["a" /* default */])(
  option_item,
  option_item_render,
  option_item_staticRenderFns,
  option_item___vue_template_functional__,
  option_item___vue_styles__,
  option_item___vue_scopeId__,
  option_item___vue_module_identifier__
)

/* harmony default export */ var option_option_item = (option_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/option/option-groups.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var option_groups = ({
	name: "OptionGroups",
	components: { step: components_step_step, optionItem: option_option_item, description: element_description },
	props: {
		optionGroup: {
			type: Object,
			required: true
		}
	},
	data: function data() {
		return {
			optionalChildImage: null,
			showAllOptions: false,
			hasClickedTitle: false
		};
	},

	computed: {
		setView: function setView() {
			var viewObject = {
				0: {
					className: "grid--center-vertical grid--center-horizontal grid--ms-full",
					rounded: false,
					image: true
				},
				1: {
					className: "grid--center-vertical grid--center-horizontal grid--ms-full",
					rounded: false,
					image: false
				},
				2: {
					className: "grid--center-vertical grid--center-horizontal grid--ms-full",
					rounded: false,
					image: true
				},
				3: {
					className: "grid--center-vertical grid--center-horizontal grid--ms-full",
					rounded: true,
					image: true
				},
				4: {
					className: "grid--center-vertical grid--center-horizontal grid--ms-full",
					rounded: true,
					image: true
				}
			};

			return viewObject[this.optionGroup.optionCategory];
		},
		getCurrentStep: function getCurrentStep() {
			return this.$store.getters.getCurrentStep;
		},
		unavailableOptions: function unavailableOptions() {
			return this.$store.getters.getAllUnavailableOptions;
		},
		getAllSteps: function getAllSteps() {
			return this.$store.getters.getAllSteps;
		},
		getStepInt: function getStepInt() {
			var _this = this;

			var step = this.getAllSteps.find(function (s) {
				return s.title === _this.optionGroup.title;
			});
			return this.getAllSteps.indexOf(step) + 1;
		},
		groupActive: function groupActive() {
			var indexNum = this.getCurrentStep.index;
			if (indexNum >= keys_default()(this.getAllSteps).length) {
				indexNum = 0;
			}

			var currentGroupId = this.getAllSteps[indexNum].groupId;
			return currentGroupId === this.optionGroup.id;
		},
		groupData: function groupData() {
			return {
				id: this.optionGroup.id,
				name: this.optionGroup.name,
				supportsCombinedPrint: this.optionGroup.supportsCombinedPrint,
				type: this.optionGroup.optionCategory,
				rounded: this.setView.rounded,
				image: this.setView.image,
				chunkType: this.optionGroup.chunkType,
				totalGroupOptions: this.optionGroup.productOptions.length,
				groupActive: this.groupActive,
				visibleOptionIds: this.visibleProductOptionsList
			};
		},
		gridClass: function gridClass() {
			return this.isOffTheShelf ? "grid--gutters grid--1-5 grid--ms-1-3 grid--s-1-2" : "grid--1-2 grid--gutters-inline grid--ms-full";
		},
		dictionary: function dictionary() {
			return this.$store.getters.getDictionary;
		},
		isBookProduct: function isBookProduct() {
			return this.$store.getters.isBookProduct;
		},
		hasDescription: function hasDescription() {
			return this.dictionary.optionCategory[this.optionGroup.optionCategory] === "print" && this.dictionary.chunkType[this.optionGroup.chunkType] === "content" && this.isBookProduct;
		},
		checkData: function checkData() {
			return this.$store.getters.checkData;
		},
		getThisSelectedOption: function getThisSelectedOption() {
			return this.$store.getters.getGroupIndexedSelectedOptions;
		},
		uploadsComplete: function uploadsComplete() {
			return this.$store.getters.uploadsAreComplete;
		},

		// very ugly but necessary check for 'bedrukte schutbladen' product..
		showPrintableEndPapersAlert: function showPrintableEndPapersAlert() {
			return this.getThisSelectedOption[this.optionGroup.id] ? [411, 412].includes(this.getThisSelectedOption[this.optionGroup.id].baseOptionId) : false;
		},
		hasSingleOption: function hasSingleOption() {
			return this.optionGroup.productOptions.length === 1;
		},
		visibleProductOptionsList: function visibleProductOptionsList() {
			var _this2 = this;

			// Fall back to all options when no option is marked directly visible,
			// otherwise a group with every option flagged CONFIGURATOR_IS_HIDDEN_BY_DEFAULT
			// renders empty and the step can't be completed.
			if (!this.optionGroup.directlyVisibleOptions || this.optionGroup.directlyVisibleOptions.length === 0) {
				return this.optionGroup.productOptions.filter(function (o) {
					return !_this2.unavailableOptions.includes(o.id);
				});
			}

			var thisSelectedOption = function thisSelectedOption() {
				var option = _this2.getThisSelectedOption[_this2.optionGroup.id];
				return option ? option.id : null;
			};

			var visibleOptionIds = [].concat(this.optionGroup.directlyVisibleOptions, thisSelectedOption());

			return this.optionGroup.productOptions.filter(function (o) {
				return visibleOptionIds.includes(o.id) && !_this2.unavailableOptions.includes(o.id);
			});
		},
		visibleProductOptions: function visibleProductOptions() {
			var _this3 = this;

			var selectedOption = this.getThisSelectedOption[this.optionGroup.id] || null;

			if (!this.showAllOptions) {
				if (this.optionGroup.directlyVisibleOptions && selectedOption && !this.optionGroup.directlyVisibleOptions.includes(selectedOption.id) && this.optionGroup.directlyVisibleOptions.length > 1) {
					return [].concat(toConsumableArray_default()(this.visibleProductOptionsList.filter(function (o) {
						return o.id !== selectedOption.id;
					})), [selectedOption]);
				}

				return this.visibleProductOptionsList;
			}

			var visibleOptions = [].concat(toConsumableArray_default()(this.visibleProductOptionsList));

			if (selectedOption && !this.optionGroup.directlyVisibleOptions.includes(selectedOption.id)) {
				visibleOptions = [].concat(toConsumableArray_default()(this.visibleProductOptionsList.filter(function (o) {
					return o.id !== selectedOption.id;
				})));
			}

			// Filter out unavailable/excluded options even when showing all
			var availableProductOptions = this.optionGroup.productOptions.filter(function (o) {
				return !_this3.unavailableOptions.includes(o.id);
			});
			return from_default()(new set_default.a([].concat(toConsumableArray_default()(visibleOptions), toConsumableArray_default()(availableProductOptions))));
		},
		enableShowMore: function enableShowMore() {
			return this.optionGroup.productOptions.length > this.optionGroup.directlyVisibleOptions.length && this.visibleProductOptions.length > 1;
		},
		isOffTheShelf: function isOffTheShelf() {
			return this.$store.getters.isOffTheShelf;
		},
		getConfigurationType: function getConfigurationType() {
			return this.$store.getters.getConfiguratorType;
		},
		isGroupLockedFromEditor: function isGroupLockedFromEditor() {
			return this.getConfigurationType.isConfiguration && this.$store.getters.getConfigurationSettings.productGroupIdsForcedByEditor.includes(this.optionGroup.id);
		},
		isGroupHidden: function isGroupHidden() {
			// Tagged Hidden: never shown to the customer, unlike "locked from editor" this applies
			// regardless of whether we're editing an existing configuration.
			return !!this.optionGroup.isHidden;
		},
		getSvg: function getSvg() {
			return this.$store.getters.getSvg;
		},
		shouldShowLockedStep: function shouldShowLockedStep() {
			return !["configurator-overview", "price-table", "uploader"].includes(this.getCurrentStep.data.name);
		}
	},
	mounted: function mounted() {
		if (this.hasSingleOption) {
			var option = this.optionGroup.productOptions[0];
			option.parentGroupId = this.optionGroup.id;
			this.$store.commit("SET_SELECTED_OPTION", option);
		}
	},
	created: function created() {
		this.setOptionImageInitial();
	},

	methods: {
		toggleShowAllOptions: function toggleShowAllOptions() {
			this.showAllOptions = !this.showAllOptions;
		},
		setSelectedChildOptionImage: function setSelectedChildOptionImage(value) {
			this.optionalChildImage = value;
		},
		setOptionImageInitial: function setOptionImageInitial() {
			var imagePath = void 0;
			var bestChoice = this.optionGroup.productOptions.find(function (i) {
				return i.isBestChoice;
			});
			if (bestChoice) {
				imagePath = bestChoice.iconPath;
			} else {
				imagePath = this.optionGroup.productOptions[0].iconPath;
			}
			this.optionalChildImage = imagePath;
		},
		stepExists: function stepExists(stepToCheck) {
			return this.$store.getters.getStepExists(stepToCheck);
		},
		setStepActive: function setStepActive(step) {
			if (this.stepExists(step).bool) {
				this.hasClickedTitle = true;
				this.$store.commit("SET_STEP_ACTIVE", step);
			}
		},
		nextStep: function nextStep() {
			this.$store.commit("CONFIGURATOR_STEP_NEXT");
		},
		checkVisibleOptions: function checkVisibleOptions() {
			var _this4 = this;

			var filteredOptions = this.optionGroup.productOptions.filter(function (option) {
				return !_this4.unavailableOptions.includes(option.id);
			});

			if (filteredOptions.length === 1 && !this.hasClickedTitle && this.optionGroup.title === this.getCurrentStep.data.title) {
				this.nextStep();
			}
		}
	},
	watch: {
		getThisSelectedOption: function getThisSelectedOption(a, b) {
			var _this5 = this;

			if (this.optionGroup) {
				if (!a[this.optionGroup.id]) {
					var thisGroup = this.getAllSteps.find(function (a) {
						return a.groupId === _this5.optionGroup.id;
					});

					if (!thisGroup) {
						return;
					}

					var groupIndex = this.getAllSteps.indexOf(thisGroup);
					this.$store.commit("SET_STEP_INVALID", groupIndex);
				}
			}
		},
		groupActive: function groupActive(a, b) {
			this.showAllOptions = false;
		},
		"getCurrentStep.index": function getCurrentStepIndex(newOptions, oldOptions) {
			this.checkVisibleOptions();
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00846ea5","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/option/option-groups.vue
var option_groups_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hasSingleOption && !_vm.isGroupLockedFromEditor && !_vm.isGroupHidden)?_c('step',{attrs:{"name":_vm.optionGroup.name + '-' + _vm.optionGroup.id,"id":_vm.optionGroup.id,"data-id":_vm.optionGroup.id,"title":_vm.optionGroup.title}},[_c('template',{slot:"title"},[_c('div',{staticClass:"grid"},[(_vm.getThisSelectedOption[_vm.optionGroup.id])?[_c('div',{staticClass:"h5 configurator-step__title cursor-pointer",on:{"click":function($event){return _vm.setStepActive(_vm.optionGroup.id)}}},[(_vm.getThisSelectedOption[_vm.optionGroup.id].name)?_c('span',{staticClass:"configurator-step__count configurator-step__count--valid"}):_c('span',{staticClass:"configurator-step__count"},[_vm._v(_vm._s(_vm.getStepInt))]),_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.optionGroup.name)+"\n\t\t\t\t\t"),(_vm.optionGroup.isOnlyForTesting)?_c('span',{staticClass:"only-for-testing--tag",attrs:{"title":"Deze stap is alleen zichtbaar voor jou omdat je bent ingelogd met een intern testaccount. Klanten zien deze stap niet."}},[_vm._v("\n\t\t\t\t\t\tOnlyForTesting\n\t\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"configurator-step__semi-colon configurator-step__not-active-mobile"},[_vm._v(":")]),_vm._v(" "),_c('span',{staticClass:"configurator-step__item configurator-step__not-active-mobile"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.getThisSelectedOption[_vm.optionGroup.id].name)+"\n\t\t\t\t\t")])])]:[_c('div',{staticClass:"h5 configurator-step__title"},[_c('span',{staticClass:"configurator-step__count"},[_vm._v(_vm._s(_vm.getStepInt))]),_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.optionGroup.title)+"\n\t\t\t\t\t"),(_vm.optionGroup.isOnlyForTesting)?_c('span',{staticClass:"only-for-testing--tag",attrs:{"title":"Deze stap is alleen zichtbaar voor jou omdat je bent ingelogd met een intern testaccount. Klanten zien deze stap niet."}},[_vm._v("\n\t\t\t\t\t\tOnlyForTesting\n\t\t\t\t\t")]):_vm._e()])]],2)]),_vm._v(" "),(_vm.hasDescription)?_c('description'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"configurator-options grid grid--gutters",class:_vm.setView.className},[_c('div',{staticClass:"cell cell--fit"},[_c('div',{staticClass:"configurator-options grid grid--gutters-s grid--1-4 grid--l-1-3 grid--ms-1-2"},[_vm._l((_vm.visibleProductOptions),function(option,index){return _c('option-item',{key:index,attrs:{"option":option,"group":_vm.groupData},on:{"setSelectedOptionImage":_vm.setSelectedChildOptionImage}})}),_vm._v(" "),(_vm.enableShowMore)?_c('div',{staticClass:"cell configurator-options__wrapper"},[_c('div',{staticClass:"configurator-options__item cursor-pointer",on:{"click":_vm.toggleShowAllOptions}},[_c('span',{staticClass:"configurator-options__additional-icon"},[_vm._v(_vm._s(_vm.showAllOptions ? "-" : "+")+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"h4 configurator-block__label configurator-block__label--inline configurator-options__additional-text"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.showAllOptions ? "Minder" : "Alle")+" opties weergeven\n\t\t\t\t\t\t")])])]):_vm._e()],2),_vm._v(" "),(_vm.showPrintableEndPapersAlert)?_c('div',{staticClass:"cell cell--full alertbox alertbox--notification alertbox--inline shoppingcart-proof-message mt-s"},[_c('svg',{staticClass:"alertbox__icon alertbox__icon--notification"},[_c('use',{attrs:{"xlink:href":"#alert--info"}})]),_vm._v(" "),_c('p',{staticClass:"alertbox__text"},[_vm._v("\n\t\t\t\t\tAls u voor bedrukte schutbladen kiest moet u het product \""),_c('a',{attrs:{"href":"/boeken/bedrukte-schutbladen/","target":"_blank"}},[_vm._v("Bedrukte schutbladen")]),_vm._v("\"\n\t\t\t\t\tlos in uw winkelwagen plaatsen. De bestanden hiervoor dient u los van het boek te uploaden.\n\t\t\t\t")])]):_vm._e()])])],2):(_vm.isGroupLockedFromEditor && _vm.shouldShowLockedStep && _vm.getThisSelectedOption[_vm.optionGroup.id])?_c('div',{staticClass:"configurator-step configurator-step--validstate configurator-step--locked",attrs:{"id":"papiersoort"}},[_c('div',{staticClass:"configurator-step__identifier configurator-step__identifier--locked"},[_c('div',{staticClass:"configurator-step__line"}),_vm._v(" "),_c('span',{staticClass:"configurator-step__icon configurator-step__icon--locked"},[_c('div',{staticClass:"offset-indicator__icon tool-tip__arrow-hook",domProps:{"innerHTML":_vm._s(_vm.getSvg.locked)}})])]),_vm._v(" "),_c('div',{staticClass:"configurator-step__content"},[_c('div',{staticClass:"h5 configurator-step__title"},[_c('strong',[_vm._v(_vm._s(_vm.optionGroup.name))]),_vm._v("\n\t\t\t: "+_vm._s(_vm.getThisSelectedOption[_vm.optionGroup.id].name)+"\n\t\t")])])]):_vm._e()}
var option_groups_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/option/option-groups.vue
function option_groups_injectStyle (context) {
  __webpack_require__("qetc")
}
/* script */


/* template */

/* template functional */
var option_groups___vue_template_functional__ = false
/* styles */
var option_groups___vue_styles__ = option_groups_injectStyle
/* scopeId */
var option_groups___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var option_groups___vue_module_identifier__ = null

var option_groups_Component = Object(component_normalizer["a" /* default */])(
  option_groups,
  option_groups_render,
  option_groups_staticRenderFns,
  option_groups___vue_template_functional__,
  option_groups___vue_styles__,
  option_groups___vue_scopeId__,
  option_groups___vue_module_identifier__
)

/* harmony default export */ var option_option_groups = (option_groups_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/element/amount.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var element_amount = ({
	name: "Amount",
	data: function data() {
		return {
			valid: false,
			message: "",
			openModal: false,
			timeout: null,
			quoteModalDebounceTimeout: null
		};
	},

	props: {
		table: {
			type: Boolean,
			default: false
		},
		overview: {
			type: Boolean,
			default: false
		},
		clean: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		hasPrice: function hasPrice() {
			return this.$store.getters.getPrice != null;
		},
		getOrderLine: function getOrderLine() {
			return this.$store.getters.getOrderLine;
		},
		amountData: function amountData() {
			return this.$store.getters.getAmountData;
		},
		offsetAvailable: function offsetAvailable() {
			return this.$store.getters.currentConfigSupportsOffset;
		},
		isOffset: function isOffset() {
			return this.$store.getters.isOffset;
		},
		isConfiguratorDataValid: function isConfiguratorDataValid() {
			return this.$store.getters.isConfiguratorDataValid;
		},
		hasQuotation: function hasQuotation() {
			return this.$store.state.baseProps.hasQuotation === "true";
		},
		getOffsetAmounts: function getOffsetAmounts() {
			return this.$store.getters.getOffsetPriceTable.map(function (line) {
				return line.Amount;
			});
		},

		amount: {
			get: function get() {
				return this.getOrderLine.amount;
			},
			set: function set(a) {
				if (is_integer_default()(a)) {
					if (!this.isOffset) {
						if (a < this.amountData.minAmount) {
							a = this.amountData.minAmount;
						} else if (a > this.amountData.maxAmount) {
							clearTimeout(this.quoteModalDebounceTimeout);

							if (this.hasQuotation) {
								this.quoteModalDebounceTimeout = setTimeout(function () {
									EventBus.$emit("openQuoteModal");
								}, 700);
							}

							a = this.amountData.maxAmount;
						}
						if (!this.amountData.customAmountAllowed) {
							if (this.amountData.amountList.includes(a)) {
								this.setOrderLineAmount(a);
							}
						} else {
							this.setOrderLineAmount(a);
						}
					} else {
						this.setOrderLineAmount(this.getClosestOffsetAmount(a));
					}
				}
			}
		}
	},
	methods: {
		setOrderLineAmount: function setOrderLineAmount(amount) {
			var previousAmount = this.getOrderLine.amount;
			this.$store.commit("SET_ORDERLINE_AMOUNT", amount);
			if (this.isOffset) {
				this.$store.commit("SET_CONFIGURATION_OFFSET_PRICE", amount);
			}

			tracking_pushEvent(Events.CHANGE_QUANTITY, {
				previousAmount: previousAmount,
				newAmount: amount,
				isCustomAmount: this.amountData.customAmountAllowed
			});
		},
		setOffset: function setOffset(offset) {
			this.$store.commit("SET_OFFSET_SELECTED", offset);
		},
		validateAmount: function validateAmount() {
			if (this.amount < this.amountData.minAmount) {
				this.valid = false;
				this.amount = this.amountData.minAmount;
			} else if (this.amount > this.amountData.maxAmount) {
				this.valid = false;
				this.amount = this.amountData.maxAmount;
			} else {
				this.valid = true;
				this.amount = this.amount;
			}
		},
		getClosestOffsetAmount: function getClosestOffsetAmount(amount) {
			return this.getClosest(amount, this.getOffsetAmounts);
		},
		getNextOffsetAmount: function getNextOffsetAmount(amount, offsetAmounts) {
			return offsetAmounts[offsetAmounts.indexOf(amount) + 1];
		},
		getPreviousOffsetAmount: function getPreviousOffsetAmount(amount, offsetAmounts) {
			return offsetAmounts[offsetAmounts.indexOf(amount) - 1];
		},
		getClosest: function getClosest(num, arr) {
			var curr = arr[0];
			var diff = Math.abs(num - curr);
			for (var val = 0; val < arr.length; val++) {
				var newdiff = Math.abs(num - arr[val]);
				if (newdiff < diff) {
					diff = newdiff;
					curr = arr[val];
				}
			}
			return curr;
		},
		amountIncrement: function amountIncrement() {
			this.setOffset(false);
			this.amount++;
			if (this.amount > this.amountData.maxAmount) {
				this.amount = this.amountData.maxAmount;
			}
		},
		amountDecrement: function amountDecrement() {
			this.setOffset(false);
			this.amount--;
			if (this.amount < this.amountData.minAmount) {
				this.amount = this.amountData.minAmount;
			}
		}
	},
	mounted: function mounted() {
		this.validateAmount();
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72d301f4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/amount.vue
var amount_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPrice)?_c('div',{staticClass:"grid amount-holder grid--center-vertical"},[(!_vm.table && !_vm.clean)?_c('h3',{staticClass:"amount-title",class:{'amount-title--overview' : _vm.overview}},[_vm._v("\n\t\tAantal:\n\t")]):_vm._e(),_vm._v(" "),(_vm.amountData.customAmountAllowed)?_c('div',{staticClass:"amount-input",class:{'amount-input--table' : _vm.table}},[_c('button',{staticClass:"amount-button background-indigo-025",on:{"click":function($event){return _vm.amountDecrement()}}},[_vm._v("-")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.amount),expression:"amount",modifiers:{"number":true}}],staticClass:"amount-field",class:{'amount-field--invalid' : !_vm.valid},attrs:{"type":"number","min":_vm.amountData.minAmount,"max":!_vm.offsetAvailable ? _vm.amountData.maxAmount : 9999999999},domProps:{"value":(_vm.amount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.amount=_vm._n($event.target.value)},_vm.validateAmount],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('button',{staticClass:"amount-button background-indigo-025",on:{"click":function($event){return _vm.amountIncrement()}}},[_vm._v("+")])]):_vm._e(),_vm._v(" "),(!_vm.amountData.customAmountAllowed)?_c('div',{staticClass:"dropdown-container"},[_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.amount),expression:"amount",modifiers:{"number":true}}],staticClass:"amount-field",on:{"input":_vm.validateAmount,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.amount=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.amountData.amountList),function(amount,key){return _c('option',{key:key,attrs:{"values":amount},domProps:{"selected":amount === _vm.getOrderLine.amount}},[_vm._v("\n\t\t\t\t"+_vm._s(amount)+"\n\t\t\t")])}),0)]):_vm._e()]):_vm._e()}
var amount_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/element/amount.vue
function amount_injectStyle (context) {
  __webpack_require__("yK1m")
}
/* script */


/* template */

/* template functional */
var amount___vue_template_functional__ = false
/* styles */
var amount___vue_styles__ = amount_injectStyle
/* scopeId */
var amount___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var amount___vue_module_identifier__ = null

var amount_Component = Object(component_normalizer["a" /* default */])(
  element_amount,
  amount_render,
  amount_staticRenderFns,
  amount___vue_template_functional__,
  amount___vue_styles__,
  amount___vue_scopeId__,
  amount___vue_module_identifier__
)

/* harmony default export */ var components_element_amount = (amount_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/element/icons.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var icons = ({
	name: "Icons",
	data: function data() {
		return {
			valid: false,
			timeout: null
		};
	},

	props: {
		clock: {
			type: Boolean,
			default: false
		},
		dashboard: {
			type: Boolean,
			default: false
		},
		digitalprint: {
			type: Boolean,
			default: false
		},
		offset: {
			type: Boolean,
			default: false
		},
		file: {
			type: Boolean,
			default: false
		},
		upload: {
			type: Boolean,
			default: false
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a298ed70","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/icons.vue
var icons_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configurator__icon-container"},[(_vm.clock)?_c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 7V12L15 15M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12Z","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]):_vm._e(),_vm._v(" "),(_vm.dashboard)?_c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M13.45 11.5502L15.5 9.50015M10 13.0002C10 13.5306 10.2107 14.0393 10.5858 14.4144C10.9609 14.7894 11.4696 15.0002 12 15.0002C12.5304 15.0002 13.0391 14.7894 13.4142 14.4144C13.7893 14.0393 14 13.5306 14 13.0002C14 12.4697 13.7893 11.961 13.4142 11.5859C13.0391 11.2109 12.5304 11.0002 12 11.0002C11.4696 11.0002 10.9609 11.2109 10.5858 11.5859C10.2107 11.961 10 12.4697 10 13.0002ZM6.4 20.0002C4.93815 18.8382 3.87391 17.2504 3.35478 15.4566C2.83564 13.6629 2.88732 11.752 3.50265 9.98896C4.11797 8.22588 5.26647 6.69786 6.78899 5.61665C8.3115 4.53544 10.1326 3.95459 12 3.95459C13.8674 3.95459 15.6885 4.53544 17.211 5.61665C18.7335 6.69786 19.882 8.22588 20.4974 9.98896C21.1127 11.752 21.1644 13.6629 20.6452 15.4566C20.1261 17.2504 19.0619 18.8382 17.6 20.0002H6.4Z","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]):_vm._e(),_vm._v(" "),(_vm.digitalprint)?_c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M17 17H19C19.5304 17 20.0391 16.7893 20.4142 16.4142C20.7893 16.0391 21 15.5304 21 15V11C21 10.4696 20.7893 9.96086 20.4142 9.58579C20.0391 9.21071 19.5304 9 19 9H5C4.46957 9 3.96086 9.21071 3.58579 9.58579C3.21071 9.96086 3 10.4696 3 11V15C3 15.5304 3.21071 16.0391 3.58579 16.4142C3.96086 16.7893 4.46957 17 5 17H7M17 9V5C17 4.46957 16.7893 3.96086 16.4142 3.58579C16.0391 3.21071 15.5304 3 15 3H9C8.46957 3 7.96086 3.21071 7.58579 3.58579C7.21071 3.96086 7 4.46957 7 5V9M7 15C7 14.4696 7.21071 13.9609 7.58579 13.5858C7.96086 13.2107 8.46957 13 9 13H15C15.5304 13 16.0391 13.2107 16.4142 13.5858C16.7893 13.9609 17 14.4696 17 15V19C17 19.5304 16.7893 20.0391 16.4142 20.4142C16.0391 20.7893 15.5304 21 15 21H9C8.46957 21 7.96086 20.7893 7.58579 20.4142C7.21071 20.0391 7 19.5304 7 19V15Z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})]):_vm._e(),_vm._v(" "),(_vm.offset)?_c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.5022 19.4228C10.1042 21.5278 13.8972 21.5278 16.4982 19.4228C19.1002 17.3178 19.7602 13.7148 18.0642 10.8768L13.1742 3.61678C12.7542 2.99178 11.8872 2.81378 11.2382 3.21978C11.0753 3.32201 10.9356 3.45725 10.8282 3.61678L5.9352 10.8768C4.2402 13.7148 4.9002 17.3178 7.5022 19.4228Z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})]):_vm._e(),_vm._v(" "),(_vm.file)?_c('svg',{attrs:{"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M14 3.80469V7.80469C14 8.0699 14.1054 8.32426 14.2929 8.51179C14.4804 8.69933 14.7348 8.80469 15 8.80469H19M14 3.80469H7C6.46957 3.80469 5.96086 4.0154 5.58579 4.39047C5.21071 4.76555 5 5.27425 5 5.80469V19.8047C5 20.3351 5.21071 20.8438 5.58579 21.2189C5.96086 21.594 6.46957 21.8047 7 21.8047H17C17.5304 21.8047 18.0391 21.594 18.4142 21.2189C18.7893 20.8438 19 20.3351 19 19.8047V8.80469M14 3.80469L19 8.80469","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]):_vm._e(),_vm._v(" "),(_vm.upload)?_c('svg',{attrs:{"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4 17.8047V19.8047C4 20.3351 4.21071 20.8438 4.58579 21.2189C4.96086 21.594 5.46957 21.8047 6 21.8047H18C18.5304 21.8047 19.0391 21.594 19.4142 21.2189C19.7893 20.8438 20 20.3351 20 19.8047V17.8047M7 9.80469L12 4.80469M12 4.80469L17 9.80469M12 4.80469V16.8047","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]):_vm._e()])}
var icons_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/element/icons.vue
/* script */


/* template */

/* template functional */
var icons___vue_template_functional__ = false
/* styles */
var icons___vue_styles__ = null
/* scopeId */
var icons___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var icons___vue_module_identifier__ = null

var icons_Component = Object(component_normalizer["a" /* default */])(
  icons,
  icons_render,
  icons_staticRenderFns,
  icons___vue_template_functional__,
  icons___vue_styles__,
  icons___vue_scopeId__,
  icons___vue_module_identifier__
)

/* harmony default export */ var element_icons = (icons_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/element/price-table.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var price_table = ({
	name: "PriceTable",
	data: function data() {
		return {
			title: "Kies een oplage",
			offsetSelected: false
		};
	},

	props: {
		overview: {
			type: Boolean,
			default: false
		}
	},
	components: {
		amount: components_element_amount,
		icons: element_icons
	},
	computed: {
		configuratorData: function configuratorData() {
			return this.$store.getters.getConfiguratorData;
		},
		selectedProduct: function selectedProduct() {
			return this.$store.getters.getSelectedProduct;
		},
		selectedFormat: function selectedFormat() {
			return this.$store.getters.getSelectedFormat;
		},
		selectedOptions: function selectedOptions() {
			return this.$store.getters.getSelectedOptions;
		},
		isRushOrderAvailable: function isRushOrderAvailable() {
			return this.$store.getters.isRushOrderAvailable;
		},
		isRushOrderAvailableColspan: function isRushOrderAvailableColspan() {
			return this.isRushOrderAvailable ? 2 : 1;
		},
		hasPrice: function hasPrice() {
			return this.$store.getters.getPrice != null;
		},
		hasQuotation: function hasQuotation() {
			// data-has-quotation on the mount div opts the host site in to the
			// "Offerte aanvragen" feature. Used by DWN; SDW omits it.
			return this.$store.state.baseProps.hasQuotation === "true";
		},
		inclTaxOnly: function inclTaxOnly() {
			// data-prices-incl-tax-only="true" swaps the price-table to display
			// PriceWithTax / singlePriceWithTax instead of the excl-tax fields.
			return this.$store.state.baseProps.pricesInclTaxOnly === "true";
		},
		hasPriceExtra: function hasPriceExtra() {
			return !Helper.isEmptyObject(this.$store.getters.getPriceExtra);
		},
		hasOffsetAvailable: function hasOffsetAvailable() {
			return this.$store.getters.hasOffsetAvailable;
		},
		hasDigitalAvailable: function hasDigitalAvailable() {
			return this.$store.getters.hasDigitalAvailable;
		},
		priceTable: function priceTable() {
			return this.$store.getters.getPriceTable.filter(function (priceTable) {
				return priceTable.amount > 0;
			});
		},
		priceExistsInTable: function priceExistsInTable() {
			return this.priceTable.map(function (line) {
				return line.amount;
			}).includes(this.getOrderLine.amount);
		},
		offsetPriceTable: function offsetPriceTable() {
			return this.$store.getters.getOffsetPriceTable.filter(function (a) {
				return a.Amount > 0;
			});
		},
		supportsOffset: function supportsOffset() {
			return this.$store.getters.currentConfigSupportsOffset;
		},
		getOrderLine: function getOrderLine() {
			return this.$store.getters.getOrderLine;
		},
		amountData: function amountData() {
			return this.$store.getters.getAmountData;
		},
		priceExtra: function priceExtra() {
			return this.$store.getters.getPriceExtra;
		},
		rushIsAvailable: function rushIsAvailable() {
			return this.$store.getters.isRushOrderAvailable;
		},
		getOffsetAmounts: function getOffsetAmounts() {
			return this.$store.getters.getOffsetPriceTable.map(function (line) {
				return line.Amount;
			});
		},
		loadingPrice: function loadingPrice() {
			return this.$store.getters.getLoader.price;
		},
		standardDelivery: function standardDelivery() {
			return this.$store.getters.getStandardDelivery;
		},
		rushDelivery: function rushDelivery() {
			return this.$store.getters.getRushDelivery;
		},
		offsetDelivery: function offsetDelivery() {
			return this.$store.getters.getOffsetDelivery;
		}
	},
	methods: {
		formatPrice: function formatPrice(price) {
			if (price) {
				return Helper.toCurrencyString(price);
			}
		},
		formatOffsetSinglePrice: function formatOffsetSinglePrice(price) {
			if (price) {
				return Helper.toCurrencyString(price, 4);
			}
		},
		price: function price(_ref) {
			var _ref$rush = _ref.rush,
			    rush = _ref$rush === undefined ? false : _ref$rush;

			var incl = this.inclTaxOnly;
			var price = void 0;
			if (rush) {
				price = incl ? this.$store.state.config.price.rushPriceWithTax : this.$store.getters.getPriceExtra.rushPrice;
			} else {
				price = incl ? this.$store.getters.getPrice.PriceWithTax : this.$store.getters.getPrice.PriceWithoutTax;
			}

			return this.formatPrice(price);
		},
		priceSingle: function priceSingle(_ref2) {
			var _ref2$rush = _ref2.rush,
			    rush = _ref2$rush === undefined ? false : _ref2$rush;

			var extra = this.$store.getters.getPriceExtra;
			var incl = this.inclTaxOnly;
			var price = rush ? incl ? extra.singleRushPriceWithTax : extra.singleRushPrice : incl ? extra.singlePriceWithTax : extra.singlePrice;

			return this.formatPrice(price);
		},
		setOrderLineAmount: function setOrderLineAmount(amount) {
			this.$store.commit("SET_ORDERLINE_AMOUNT", amount);
			if (this.isOffset) {
				this.$store.commit("SET_CONFIGURATION_OFFSET_PRICE", amount);
			}
		},
		validateAmount: function validateAmount() {
			if (this.amount < this.amountData.minAmount) {
				this.valid = false;
				this.amount = this.amountData.minAmount;
			} else if (this.amount > this.amountData.maxAmount && !this.offsetAvailable) {
				this.valid = false;
				this.amount = this.amountData.maxAmount;
			} else if (this.amount > this.amountData.maxAmount && this.offsetAvailable) {
				this.valid = true;
				this.amount = this.getClosestOffsetAmount(this.amount);
				this.$store.commit("SET_OFFSET_SELECTED", true);
			} else {
				this.valid = true;
				this.$store.commit("SET_OFFSET_SELECTED", false);
			}
		},
		getClosestOffsetAmount: function getClosestOffsetAmount(amount) {
			return this.getClosest(amount, this.getOffsetAmounts);
		},
		getNextOffsetAmount: function getNextOffsetAmount(amount, offsetAmounts) {
			return offsetAmounts[offsetAmounts.indexOf(amount) + 1];
		},
		getPreviousOffsetAmount: function getPreviousOffsetAmount(amount, offsetAmounts) {
			return offsetAmounts[offsetAmounts.indexOf(amount) - 1];
		},
		getClosest: function getClosest(num, arr) {
			var curr = arr[0];
			var diff = Math.abs(num - curr);
			for (var val = 0; val < arr.length; val++) {
				var newdiff = Math.abs(num - arr[val]);
				if (newdiff < diff) {
					diff = newdiff;
					curr = arr[val];
				}
			}
			return curr;
		},
		setRush: function setRush(rush) {
			this.$store.commit("SET_RUSH_SELECTED", rush);
		},
		setOffset: function setOffset(offset) {
			this.offsetSelected = true;
			this.$store.commit("SET_OFFSET_SELECTED", offset);
			if (offset) {
				this.setOrderLineAmount(this.getClosest(this.getOrderLine.amount, this.getOffsetAmounts));
			} else {
				this.setOrderLineAmount(this.getClosest(this.getOrderLine.amount, this.amountData.amountList));
			}
		},
		openQuotationModal: function openQuotationModal() {
			EventBus.$emit("openQuoteModal");
		},
		isPastTimeLimit: function isPastTimeLimit(cutOffHour) {
			return new Date().getHours() > parseInt(cutOffHour.split(":")[0]);
		}
	},
	created: function created() {
		this.$store.dispatch("_getPriceTable");
		if (this.hasOffsetAvailable) {
			this.$store.dispatch("_getOffsetPriceTable");
		}
	},
	mounted: function mounted() {
		if (this.overview) {
			this.getOrderLine.isOffset ? this.offsetSelected = true : this.offsetSelected = false;
		}

		if (!this.hasDigitalAvailable && this.hasOffsetAvailable) {
			this.setOffset(true);
		}
	},

	watch: {
		offsetPriceTable: function offsetPriceTable() {
			this.$store.commit("SET_FIRST_OFFSET_AMOUNT_SELECTED");
		},
		selectedOptions: function selectedOptions(a, b) {
			this.$store.dispatch("_getOffsetPriceTable");
			this.$store.commit("SET_FIRST_OFFSET_AMOUNT_SELECTED");
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67049f54","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/price-table.vue
var price_table_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPrice)?_c('div',{staticClass:"mv-s"},[(_vm.isRushOrderAvailable)?_c('div',{staticClass:"grid grid--1-2 grid--ms-full grid--gutters-s"},[_c('div',{staticClass:"cell"},[_c('div',{staticClass:"configurator-choice cursor-pointer",class:{ 'configurator-choice--selected': !_vm.getOrderLine.isRush },on:{"click":function($event){return _vm.setRush(false)}}},[_c('span',{staticClass:"configurator__input-selectable"}),_vm._v(" "),_c('icons',{attrs:{"clock":""}}),_vm._v(" "),_c('p',{staticClass:"configurator-choice__copy"},[_c('strong',[_vm._v("Standaard productie")]),_c('br'),_vm._v("\n\t\t\t\t\tVerwachte leverdatum "+_vm._s(_vm.standardDelivery.date)+"\n\t\t\t\t")])],1)]),_vm._v(" "),_c('div',{staticClass:"cell"},[_c('div',{staticClass:"configurator-choice cursor-pointer",class:{ 'configurator-choice--selected': _vm.getOrderLine.isRush },on:{"click":function($event){return _vm.setRush(true)}}},[_c('span',{staticClass:"configurator__input-selectable"}),_vm._v(" "),_c('icons',{attrs:{"dashboard":""}}),_vm._v(" "),_c('p',{staticClass:"configurator-choice__copy"},[_c('strong',[_vm._v("Spoed productie")]),_c('br'),_vm._v("\n\t\t\t\t\tVerwachte leverdatum "+_vm._s(_vm.rushDelivery.date)+"\n\t\t\t\t")])],1)])]):(_vm.standardDelivery.date)?_c('div',{staticClass:"configurator-choice configurator-choice--selected"},[_c('icons',{attrs:{"clock":""}}),_vm._v(" "),_c('p',{staticClass:"configurator-choice__copy"},[_c('strong',[_vm._v("Standaard productie")]),_c('br'),_vm._v("\n\t\t\tVerwachte leverdatum "+_vm._s(_vm.standardDelivery.date)+"\n\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.supportsOffset)?_c('div',{staticClass:"production-choice mv-s"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"grid grid--1-2 grid--ms-full grid--gutters-s"},[(_vm.hasDigitalAvailable)?_c('div',{staticClass:"cell"},[_c('div',{staticClass:"configurator-choice cursor-pointer",class:{ 'configurator-choice--selected': !_vm.getOrderLine.isOffset && _vm.offsetSelected },on:{"click":function($event){return _vm.setOffset(false)}}},[_c('span',{staticClass:"configurator__input-selectable"}),_vm._v(" "),_c('icons',{attrs:{"digitalprint":""}}),_vm._v(" "),_vm._m(1)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cell"},[_c('div',{staticClass:"configurator-choice cursor-pointer",class:{ 'configurator-choice--selected': _vm.getOrderLine.isOffset && _vm.offsetSelected },on:{"click":function($event){return _vm.setOffset(true)}}},[_c('span',{staticClass:"configurator__input-selectable"}),_vm._v(" "),_c('icons',{attrs:{"offset":""}}),_vm._v(" "),_vm._m(2)],1)])])]):_vm._e(),_vm._v(" "),(_vm.offsetSelected && _vm.supportsOffset && _vm.getOrderLine.isOffset)?_c('div',{staticClass:"production-choice--offset"},[_c('div',{staticClass:"price-overview-grid mv-m"},[_vm._m(3),_vm._v(" "),_vm._l((_vm.offsetPriceTable),function(priceRow){return _c('div',{key:priceRow.Amount + '-offset',staticClass:"grid grid--1-3 price-overview-row",class:{ 'price-overview-row--active': _vm.getOrderLine.amount === priceRow.Amount },on:{"click":function($event){return _vm.setOrderLineAmount(priceRow.Amount)}}},[_c('div',{staticClass:"cell price-overview-row__field price-overview-row__field--amount"},[_c('label',{staticClass:"price-overview-row__input"}),_vm._v("\n\t\t\t\t\t"+_vm._s(priceRow.Amount)+"\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"cell price-overview-row__field"},[(!_vm.loadingPrice)?[_c('p',{staticClass:"mh-auto"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.formatOffsetSinglePrice(priceRow.Single))+"\n\t\t\t\t\t\t\t"),_c('span',{staticClass:"price-overview__exclbtw"},[_vm._v("(excl. btw)")])])]:[_vm._m(4,true)]],2),_vm._v(" "),_c('div',{staticClass:"cell price-overview-row__field"},[(!_vm.loadingPrice)?[_c('p',{staticClass:"ml-auto text--right"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.formatPrice(priceRow.Price))+"\n\t\t\t\t\t\t\t"),_c('span',{staticClass:"price-overview__exclbtw"},[_vm._v("(excl. btw)")])])]:[_vm._m(5,true)]],2)])})],2),_vm._v(" "),_c('div',{staticClass:"description p-s"},[_c('p',{staticClass:"description__text"},[_vm._v("\n\t\t\t\tVerwachte leverdatum "+_vm._s(_vm.offsetDelivery.date)+"\n\t\t\t")])])]):_vm._e(),_vm._v(" "),(!_vm.supportsOffset || (_vm.offsetSelected && !_vm.getOrderLine.isOffset))?_c('div',{staticClass:"production-choice--digital"},[_c('div',{staticClass:"price-overview-grid mv-m"},[(_vm.hasDigitalAvailable)?_c('div',{staticClass:"grid grid--1-3 price-overview-table__head"},[_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8)]):_vm._e(),_vm._v(" "),_vm._l((_vm.priceTable),function(priceRow){return (priceRow.amount !== 0)?_c('div',{key:priceRow.amount + '-digital',staticClass:"grid grid--1-3 price-overview-row",class:{ 'price-overview-row--active': _vm.getOrderLine.amount === priceRow.amount },on:{"click":function($event){return _vm.setOrderLineAmount(priceRow.amount)}}},[_c('div',{staticClass:"cell price-overview-row__field price-overview-row__field--amount"},[_c('label',{staticClass:"price-overview-row__input"}),_vm._v("\n\t\t\t\t\t"+_vm._s(priceRow.amount)+"\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"cell price-overview-row__field"},[(_vm.isRushOrderAvailable && _vm.getOrderLine.isRush)?_c('p',{staticClass:"mh-auto"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.formatPrice(_vm.inclTaxOnly ? priceRow.rush.singlePriceWithTax : priceRow.rush.singlePrice))+"\n\t\t\t\t\t\t"),_c('span',{staticClass:"price-overview__exclbtw hide-s"},[_vm._v(" ("+_vm._s(_vm.inclTaxOnly ? "incl" : "excl")+". btw)")])]):(priceRow.default.singlePrice)?_c('p',{staticClass:"mh-auto"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.formatPrice(_vm.inclTaxOnly ? priceRow.default.singlePriceWithTax : priceRow.default.singlePrice))+"\n\t\t\t\t\t\t"),_c('span',{staticClass:"price-overview__exclbtw hide-s"},[_vm._v(" ("+_vm._s(_vm.inclTaxOnly ? "incl" : "excl")+". btw)")])]):_c('div',{staticClass:"loading loading--table"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])]),_vm._v(" "),_c('div',{staticClass:"cell price-overview-row__field"},[(_vm.isRushOrderAvailable && _vm.getOrderLine.isRush)?_c('p',{staticClass:"ml-auto text--right"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.formatPrice(_vm.inclTaxOnly ? priceRow.rush.PriceWithTax : priceRow.rush.PriceWithoutTax))+"\n\t\t\t\t\t\t"),_c('span',{staticClass:"price-overview__exclbtw"},[_vm._v(" ("+_vm._s(_vm.inclTaxOnly ? "incl" : "excl")+". btw)")])]):(priceRow.default.PriceWithoutTax)?_c('p',{staticClass:"ml-auto text--right"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.formatPrice(_vm.inclTaxOnly ? priceRow.default.PriceWithTax : priceRow.default.PriceWithoutTax))+"\n\t\t\t\t\t\t"),_c('span',{staticClass:"price-overview__exclbtw"},[_vm._v(" ("+_vm._s(_vm.inclTaxOnly ? "incl" : "excl")+". btw)")])]):_c('div',{staticClass:"loading loading--table"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])]):_vm._e()}),_vm._v(" "),(_vm.selectedProduct.isCustomAmountAllowed)?_c('div',{staticClass:"grid grid--1-3 price-overview-row background-indigo-050",class:{ 'price-overview-row--active': !this.priceExistsInTable },on:{"click":function($event){return _vm.setOrderLineAmount(_vm.getOrderLine.amount)}}},[_c('div',{staticClass:"cell price-overview-row__field"},[_c('div',{staticClass:"price-overview-row__amount-container pl-xs"},[_c('amount',{attrs:{"table":""}})],1)]),_vm._v(" "),_c('div',{staticClass:"cell price-overview-row__field"},[(!_vm.loadingPrice)?[(_vm.isRushOrderAvailable && _vm.getOrderLine.isRush)?_c('p',{staticClass:"mh-auto text--bold"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.formatPrice(_vm.priceSingle({ rush: true })))+"\n\t\t\t\t\t\t\t"),_c('span',{staticClass:"price-overview__exclbtw hide-s"},[_vm._v(" ("+_vm._s(_vm.inclTaxOnly ? "incl" : "excl")+". btw)")])]):_c('p',{staticClass:"mh-auto text--bold"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.formatPrice(_vm.priceSingle({ rush: false })))+"\n\t\t\t\t\t\t\t"),_c('span',{staticClass:"price-overview__exclbtw hide-s"},[_vm._v(" ("+_vm._s(_vm.inclTaxOnly ? "incl" : "excl")+". btw)")])])]:[_vm._m(9)]],2),_vm._v(" "),_c('div',{staticClass:"cell price-overview-row__field"},[(!_vm.loadingPrice)?[(_vm.isRushOrderAvailable && _vm.getOrderLine.isRush)?_c('p',{staticClass:"ml-auto mr-xs text--right text--bold"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.formatPrice(_vm.price({ rush: true })))+"\n\t\t\t\t\t\t\t"),_c('span',{staticClass:"price-overview__exclbtw"},[_vm._v(" ("+_vm._s(_vm.inclTaxOnly ? "incl" : "excl")+". btw)")])]):_c('p',{staticClass:"ml-auto mr-xs text--right text--bold"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.formatPrice(_vm.price({ rush: false })))+"\n\t\t\t\t\t\t\t"),_c('span',{staticClass:"price-overview__exclbtw"},[_vm._v(" ("+_vm._s(_vm.inclTaxOnly ? "incl" : "excl")+". btw)")])])]:[_vm._m(10)]],2)]):_vm._e()],2),_vm._v(" "),(_vm.hasQuotation)?_c('div',{staticClass:"description mv-sm"},[_c('p',{staticClass:"description__text"},[_vm._v("\n\t\t\t\tVoor aantallen boven de "+_vm._s(_vm.selectedFormat.maxAmount)+" kunt u een offerte op maat aanvragen.\n\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"description__button",on:{"click":_vm.openQuotationModal}},[_vm._v("\n\t\t\t\tOfferte aanvragen\n\t\t\t")])]):_vm._e()]):_vm._e()]):_vm._e()}
var price_table_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"description mv-sm"},[_c('p',{staticClass:"description__text"},[_vm._v("\n\t\t\t\tBij het drukken kunnen wij gebruik maken van twee verschillende druktechnieken: offset en digitaal.\n\t\t\t\tBij een kleine oplage raden we u aan om voor digitaal te kiezen.\n\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"configurator-choice__copy"},[_c('strong',[_vm._v("Digitaal")]),_c('br'),_vm._v("\n\t\t\t\t\t\tIdeaal voor kleine oplages\n\t\t\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"configurator-choice__copy"},[_c('strong',[_vm._v("Offset")]),_c('br'),_vm._v("\n\t\t\t\t\t\tGeschikt voor grote oplages\n\t\t\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid grid--1-3 price-overview-table__head"},[_c('div',{staticClass:"cell"},[_c('div',{staticClass:"h4 price-overview__title ml-xl"},[_vm._v("Aantal")])]),_vm._v(" "),_c('div',{staticClass:"cell"},[_c('div',{staticClass:"h4 price-overview__title text--center"},[_vm._v("Prijs per stuk")])]),_vm._v(" "),_c('div',{staticClass:"cell"},[_c('div',{staticClass:"h4 price-overview__title text--right"},[_vm._v("Totaalprijs")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading loading--table"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading loading--table"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell"},[_c('div',{staticClass:"h4 price-overview__title ml-xl"},[_vm._v("Aantal")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell"},[_c('div',{staticClass:"h4 price-overview__title text--center"},[_vm._v("Prijs per stuk")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell"},[_c('div',{staticClass:"h4 price-overview__title text--right"},[_vm._v("Totaalprijs")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading loading--table"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading loading--table"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])}]

// CONCATENATED MODULE: ./src/components/element/price-table.vue
function price_table_injectStyle (context) {
  __webpack_require__("CRBY")
}
/* script */


/* template */

/* template functional */
var price_table___vue_template_functional__ = false
/* styles */
var price_table___vue_styles__ = price_table_injectStyle
/* scopeId */
var price_table___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var price_table___vue_module_identifier__ = null

var price_table_Component = Object(component_normalizer["a" /* default */])(
  price_table,
  price_table_render,
  price_table_staticRenderFns,
  price_table___vue_template_functional__,
  price_table___vue_styles__,
  price_table___vue_scopeId__,
  price_table___vue_module_identifier__
)

/* harmony default export */ var element_price_table = (price_table_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/overview/quotation.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var quotation = ({
	name: "Quotation",
	components: { modal: element_modal, spine: components_element_spine },
	data: function data() {
		return {
			openModal: false,
			email: "",
			validEmail: false,
			amount: null,
			loading: false,
			response: false,
			phoneNumber: "",
			validPhoneNumber: false,
			validateTimeOut: null
		};
	},

	computed: {
		selectedProduct: function selectedProduct() {
			return this.$store.getters.getSelectedProduct;
		},
		selectedFormat: function selectedFormat() {
			return this.$store.getters.getSelectedFormat;
		},
		selectedOptions: function selectedOptions() {
			return values_default()(this.$store.getters.getSelectedOptions);
		},
		visibleSelectedOptions: function visibleSelectedOptions() {
			var hiddenOptionGroupIds = this.$store.getters.getHiddenOptionGroupIds;
			return this.selectedOptions.filter(function (option) {
				return !hiddenOptionGroupIds.includes(option.parentGroupId);
			});
		},
		selectedCustomSize: function selectedCustomSize() {
			return this.$store.getters.getCustomSize;
		},
		check: function check() {
			return this.$store.getters.checkData;
		},
		formatDescription: function formatDescription() {
			return this.$store.getters.getSelectedFormatDescription;
		},
		configuratorData: function configuratorData() {
			return this.$store.getters.getConfiguratorData;
		},
		priceTable: function priceTable() {
			return this.$store.getters.getPriceTable.filter(function (row) {
				return row.amount > 0;
			});
		},
		offsetPriceTable: function offsetPriceTable() {
			return this.$store.getters.getOffsetPriceTable;
		},
		supportsOffset: function supportsOffset() {
			return this.$store.getters.currentConfigSupportsOffset;
		},
		mainImage: function mainImage() {
			return this.configuratorData.hasMultipleProducts ? this.selectedProduct.iconPath : this.selectedFormat.iconPath;
		},
		previewUrl: function previewUrl() {
			return this.$store.getters.getPreviewUrl;
		},
		validAmount: function validAmount() {
			return this.amount !== null && this.amount !== "" && this.amount >= this.selectedFormat.maxAmount;
		},
		quotationResponse: function quotationResponse() {
			return this.$store.getters.getQuotationResponse;
		}
	},
	methods: {
		imagePath: function imagePath(iconPath) {
			if (!this.previewUrl && this.previewUrl === null) {
				return iconPath;
			} else {
				return this.previewUrl;
			}
		},
		validAddress: function validAddress(email) {
			var _this = this;

			var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			this.validEmail = true;
			if (this.validateTimeOut) {
				clearTimeout(this.validateTimeOut);
			}
			this.validateTimeOut = setTimeout(function () {
				_this.validEmail = re.test(email);
			}, 500);
		},
		validatePhoneNumber: function validatePhoneNumber(phoneNumber) {
			var _this2 = this;

			var validPhoneNumberRegex = /^[\\+]?[(]?[0-9]{3}[)]?[-\s\\.]?[0-9]{3}[-\s\\.]?[0-9]{4,6}$/im;
			this.validPhoneNumber = true;
			if (this.validateTimeOut) {
				clearTimeout(this.validateTimeOut);
			}
			this.validateTimeOut = setTimeout(function () {
				_this2.validPhoneNumber = validPhoneNumberRegex.test(phoneNumber);
			}, 500);
		},

		productOptionGroup: function productOptionGroup(groupId) {
			var productGroupInfo = this.selectedFormat.productOptionGroups.find(function (g) {
				return g.id === groupId;
			});

			return productGroupInfo;
		},
		formatPrice: function formatPrice(price) {
			if (price) {
				return Helper.toCurrencyString(price);
			}
		},
		sendProposition: function sendProposition() {
			var _this3 = this;

			return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
				var token, siteKey;
				return regenerator_default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								token = null;

								_this3.loading = true;

								_context.prev = 2;
								siteKey = window.getRecaptchaSiteKeyByLanguage(document.documentElement.lang);
								_context.next = 6;
								return window.grecaptcha.execute(siteKey, { action: "quotation_mail_form" });

							case 6:
								token = _context.sent;
								_context.next = 11;
								break;

							case 9:
								_context.prev = 9;
								_context.t0 = _context["catch"](2);

							case 11:

								_this3.$store.dispatch("_sendQuotationMail", {
									email: _this3.email,
									phoneNumber: _this3.phoneNumber,
									amount: _this3.amount,
									recaptchaToken: token
								});

							case 12:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this3, [[2, 9]]);
			}))();
		}
	},
	mounted: function mounted() {
		var _this4 = this;

		EventBus.$on("openQuoteModal", function () {
			_this4.openModal = false;
			setTimeout(function () {
				this.openModal = true;
			}.bind(_this4), 100);
		});

		window._appendGoogleRecaptchaScript(window.getRecaptchaSiteKeyByLanguage(document.documentElement.lang));
	},

	watch: {
		quotationResponse: function quotationResponse(a, b) {
			this.response = true;
			this.loading = false;
		},
		amount: function amount() {
			var _this5 = this;

			setTimeout(function () {
				if (_this5.amount < _this5.selectedFormat.maxAmount) {
					_this5.amount = _this5.selectedFormat.maxAmount;
				}
			}, 1000);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8290a44","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/overview/quotation.vue
var quotation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"button-style":"none","modal-style":"styled","open":_vm.openModal,"title":"Offerte aanvragen"}},[_c('p',[_vm._v("\n\t\tBij bestellingen vanaf "+_vm._s(_vm.selectedFormat.maxAmount)+" bieden wij een offerte op maat, afgestemd op uw\n\t\tspecifieke wensen.\n\t\tProfiteer van schaalvoordelen en ontvang een scherpe prijs voor uw oplage.\n\t\t"),_c('br'),_vm._v("\n\t\tLaat hieronder uw gewenste oplage en contactgegevens achter.\n\t\tOns team neemt zo snel mogelijk contact met u op om de mogelijkheden te bespreken en een passende offerte te\n\t\tbieden.\n\t")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label',{staticClass:"input-label",attrs:{"for":"amount"}},[_vm._v("Oplage")]),_vm._v(" "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],staticClass:"input-field input-field--border mb-s",attrs:{"type":"number","id":"amount","name":"amount","min":_vm.selectedFormat.maxAmount,"required":""},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"input-label",attrs:{"for":"email"}},[_vm._v("E-mailadres")]),_vm._v(" "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"input-field input-field--border mb-s",attrs:{"type":"email","id":"email","name":"email","required":""},domProps:{"value":(_vm.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.email=$event.target.value},function($event){return _vm.validAddress(_vm.email)}]}}),_vm._v(" "),(_vm.email !== '' && !_vm.validEmail)?_c('span',{staticClass:"text-danger field-validation-error"},[_c('span',[_vm._v("Er moet een geldig e-mailadres ingevuld worden.")])]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"input-label",attrs:{"for":"phoneNumber"}},[_vm._v("Telefoonnummer")]),_vm._v(" "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")]),_vm._v(" "),_c('div',{staticClass:"grid grid--gutters grid--ms-full mb-s"},[_c('div',{staticClass:"cell cell--fit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneNumber),expression:"phoneNumber"}],staticClass:"input-field input-field--border",attrs:{"type":"text","id":"phoneNumber","name":"phoneNumber","required":""},domProps:{"value":(_vm.phoneNumber)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.phoneNumber=$event.target.value},function($event){return _vm.validatePhoneNumber(_vm.phoneNumber)}]}}),_vm._v(" "),(_vm.phoneNumber !== '' && !_vm.validPhoneNumber)?_c('span',{staticClass:"text-danger field-validation-error"},[_c('span',[_vm._v("Er moet een geldig telefoonnummer ingevuld worden.")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cell cell--auto"},[_c('button',{staticClass:"button button--cta button--icon button--full-width button--full-height",attrs:{"aria-hidden":"Offerte aanvragen","disabled":!_vm.validEmail || !_vm.validAmount || !_vm.validPhoneNumber},on:{"click":_vm.sendProposition}},[_vm._v("\n\t\t\t\tAanvragen\n\t\t\t\t"),(_vm.loading)?_c('span',{staticClass:"button-loader loading",staticStyle:{"margin":"0"}}):_vm._e()])])]),_vm._v(" "),(_vm.response)?[(_vm.quotationResponse.status === 200 && _vm.quotationResponse.body.configurationId)?[_c('div',{staticClass:"alertbox alertbox--success alertbox mv-m"},[_c('svg',{staticClass:"alertbox__icon alertbox__icon--success"},[_c('use',{attrs:{"xlink:href":"#alert--success"}})]),_vm._v(" "),_c('p',{staticClass:"alertbox__text"},[_vm._v("Aanvraag voltooid! U ontvangt binnenkort een e-mail met uw offerte.")])])]:[_c('div',{staticClass:"alertbox alertbox--error alertbox mv-m"},[_c('svg',{staticClass:"alertbox__icon alertbox__icon--error"},[_c('use',{attrs:{"xlink:href":"#alert--error"}})]),_vm._v(" "),_c('p',{staticClass:"alertbox__text"},[_vm._v("\n\t\t\t\t\tEr ging iets fout.. Als dit probleem zich blijft voordoen kunt u contact opnemen met onze\n\t\t\t\t\t"),_c('a',{attrs:{"href":"/klantenservice","title":"klantenservice"}},[_vm._v("klantenservice")]),_vm._v(".\n\t\t\t\t")])])]]:_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"grid grid--gutters grid--m-full"},[_c('div',{staticClass:"cell cell--auto"},[_c('h3',{staticClass:"hide-ms title--dot mb-m"},[_vm._v("Productgegevens")]),_vm._v(" "),(_vm.check.hasSelectedOptions)?_c('table',{staticClass:"configurator-overview__table"},[_c('tr',[_c('td',{staticClass:"configurator-overview__table-title"},[_vm._v("Product:")]),_vm._v(" "),_c('td',{staticClass:"configurator-overview__table-text",domProps:{"textContent":_vm._s(_vm.selectedProduct.name)}})]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"configurator-overview__table-title"},[_vm._v("Formaat:")]),_vm._v(" "),_c('td',{staticClass:"configurator-overview__table-text"},[_vm._v(_vm._s(_vm.selectedFormat.productSize.fullName))])]),_vm._v(" "),_vm._l((_vm.visibleSelectedOptions),function(option,index){return _c('tr',{key:index},[_c('td',{staticClass:"configurator-overview__table-title"},[_vm._v(_vm._s(_vm.productOptionGroup(option.parentGroupId).name + ":"))]),_vm._v(" "),_c('td',{staticClass:"configurator-overview__table-text",domProps:{"textContent":_vm._s(option.name)}})])}),_vm._v(" "),(_vm.configuratorData.hasMultiplePages)?_c('spine',{attrs:{"table":""}}):_vm._e()],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cell cell--fit"},[(_vm.previewUrl)?_c('div',{staticClass:"preview-image-wrapper"},[_c('img',{staticClass:"content-block__image quotation-modal__image",attrs:{"src":_vm.imagePath(_vm.mainImage),"width":"300"}})]):_c('img',{staticClass:"content-block__image quotation-modal__image",attrs:{"src":_vm.imagePath(_vm.mainImage),"width":"300"}})])])],2)}
var quotation_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/overview/quotation.vue
function quotation_injectStyle (context) {
  __webpack_require__("vg8X")
}
/* script */


/* template */

/* template functional */
var quotation___vue_template_functional__ = false
/* styles */
var quotation___vue_styles__ = quotation_injectStyle
/* scopeId */
var quotation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var quotation___vue_module_identifier__ = null

var quotation_Component = Object(component_normalizer["a" /* default */])(
  quotation,
  quotation_render,
  quotation_staticRenderFns,
  quotation___vue_template_functional__,
  quotation___vue_styles__,
  quotation___vue_scopeId__,
  quotation___vue_module_identifier__
)

/* harmony default export */ var overview_quotation = (quotation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/overview/configurator-overview.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ var configurator_overview = ({
	name: "ConfiguratorOverview",
	data: function data() {
		return {
			openModal: false,
			name: "",
			previewIsLoaded: false,
			isPreview: false,
			placeholderUrl: "/images/svg/placeholder.svg",
			previewImage: null
		};
	},

	components: {
		step: components_step_step,
		price: components_element_price,
		priceTable: element_price_table,
		amount: components_element_amount,
		spine: components_element_spine,
		modal: element_modal,
		deliverySpecification: information_delivery_specification,
		quotation: overview_quotation
	},
	computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])(["baseProps"]), {
		isConfiguration: function isConfiguration() {
			return this.$store.getters.getConfiguratorType.isConfiguration;
		},
		configuratorData: function configuratorData() {
			return this.$store.getters.getConfiguratorData;
		},
		selectedProduct: function selectedProduct() {
			return this.$store.getters.getSelectedProduct;
		},
		selectedFormat: function selectedFormat() {
			return this.$store.getters.getSelectedFormat;
		},
		selectedOptions: function selectedOptions() {
			var hiddenOptionGroups = this.selectedFormat.productOptionGroups.reduce(function (_hiddenOptionGroups, og) {
				if (og.productOptions.length === 1) {
					_hiddenOptionGroups.push(og.id);
				}
				return _hiddenOptionGroups;
			}, []);

			var selectedOptionsArray = values_default()(this.$store.getters.getSelectedOptions);

			return selectedOptionsArray.filter(function (o) {
				return !hiddenOptionGroups.includes(o.parentGroupId);
			});
		},
		selectedDesign: function selectedDesign() {
			var _designGroupIdentifier = "Ontwerp";
			var designGroup = this.$store.getters.getSelectedFormat.productOptionGroups.find(function (og) {
				return og.name === _designGroupIdentifier;
			});

			if (designGroup) {
				return this.selectedOptions.find(function (o) {
					return o.parentGroupId === designGroup.id;
				});
			}
		},
		getSvg: function getSvg() {
			return this.$store.getters.getSvg;
		},
		productSize: function productSize() {
			return this.$store.getters.getProductSize;
		},
		selectedCustomSize: function selectedCustomSize() {
			return this.$store.getters.getCustomSize;
		},
		configuratorChanged: function configuratorChanged() {
			return this.$store.getters.getConfiguratorChanged;
		},
		iconPath: function iconPath() {
			if (this.isOffTheShelf && this.selectedDesign) {
				return this.selectedDesign.iconPath;
			}

			if (this.configuratorData.hasMultipleProducts) {
				return this.selectedProduct.iconPath;
			}

			return this.selectedFormat.iconPath;
		},
		check: function check() {
			return this.$store.getters.checkData;
		},
		formatDescription: function formatDescription() {
			return this.$store.getters.getSelectedFormatDescription;
		},
		productTitleString: function productTitleString() {
			return this.name !== "" ? this.name : this.selectedFormat.productSize.fullName;
		},
		isCustomSize: function isCustomSize() {
			return this.$store.getters.isCustomSize;
		},
		previewUrl: function previewUrl() {
			return this.$store.getters.getPreviewUrl;
		},
		isEditorProject: function isEditorProject() {
			return this.$store.getters.isEditorProject;
		},
		getOrderLine: function getOrderLine() {
			return this.$store.getters.getOrderLine;
		},
		loadingPrice: function loadingPrice() {
			return this.$store.getters.getLoader.price;
		},
		getAmount: function getAmount() {
			return this.getOrderLine.amount;
		},
		isOffTheShelf: function isOffTheShelf() {
			return this.$store.getters.isOffTheShelf;
		},
		forcedOptionGroup: function forcedOptionGroup() {
			return this.$store.getters.getConfigurationSettings.productGroupIdsForcedByEditor;
		},
		hiddenOptionGroupIds: function hiddenOptionGroupIds() {
			return this.$store.getters.getHiddenOptionGroupIds;
		},
		visibleSelectedOptions: function visibleSelectedOptions() {
			var _this = this;

			// Options belonging to a group tagged Hidden are never shown here, unlike groups
			// forced by the editor which still show up read-only (see groupLocked/forcedOptionGroup).
			return this.selectedOptions.filter(function (option) {
				return !_this.hiddenOptionGroupIds.includes(option.parentGroupId);
			});
		},
		getUploaderPosition: function getUploaderPosition() {
			return this.$store.getters.getUploaderPosition;
		},
		uploadSizeMatchesCustomSize: function uploadSizeMatchesCustomSize() {
			if (this.$store.getters.uploadsAreComplete && this.isCustomSize) {
				var customSize = this.selectedCustomSize;
				var bleedSize = this.bleedSize(this.productSize).trimmed();

				return customSize.width === bleedSize.width && customSize.height === bleedSize.height || customSize.width === bleedSize.height && customSize.height === bleedSize.width;
			}

			return true;
		},
		config: function config() {
			return CONFIG;
		},
		showDefaultConfigAlert: function showDefaultConfigAlert() {
			return this.isConfiguration && this.isEditorProject && !this.configuratorChanged;
		},
		productPageUrl: function productPageUrl() {
			return location.href.split("?")[0];
		}
	}),
	methods: {
		resetAllUploads: function resetAllUploads() {
			this.isPreview = false;
			this.previewIsLoaded = false;
			this.$store.commit("RESET_ALL_FILE_UPLOADS");
		},
		bleedSize: function bleedSize(size) {
			return this.$store.getters.bleedSize(size);
		},
		setStepActive: function setStepActive(payload) {
			if (this.groupLocked(payload)) {
				return;
			}
			this.$store.commit("SET_STEP_ACTIVE", payload);
		},
		navigateToPriceTable: function navigateToPriceTable() {
			if (this.isConfiguration) {
				var el = this.$el.querySelector(".price-overview-grid");
				if (el) {
					el.scrollIntoView({ behavior: "smooth", block: "center" });
				}
			} else {
				this.setStepActive("price-table");
			}
		},
		setFirstStepActive: function setFirstStepActive() {
			var nonSelectableGroupIds = this.$store.getters.getNonSelectableOptionGroupIds;
			var filteredOptions = this.selectedOptions.filter(function (option) {
				return !nonSelectableGroupIds.includes(option.parentGroupId);
			});
			this.$store.commit("SET_IS_SPECIFICATION_CONFIGURATION", false);
			this.$store.commit("SET_STEP_ACTIVE", filteredOptions[0].parentGroupId);
		},
		openNameModal: function openNameModal() {
			this.openModal = false;

			setTimeout(function () {
				this.openModal = true;
			}.bind(this), 100);
		},
		closeNameModal: function closeNameModal() {
			this.openModal = false;
		},
		setConfigurationName: function setConfigurationName() {
			if (this.name !== "" || this.name.length) {
				this.$store.commit("SET_CONFIGURATION_NAME", this.name);
			}
		},
		imagePath: function imagePath(iconPath) {
			var _this2 = this;

			var result = "";
			if (!this.previewUrl && this.previewUrl === null) {
				result = iconPath;
			} else {
				result = this.placeholderUrl;
				this.isPreview = true;
			}

			if (this.isPreview) {
				var retryAttempt = 1; // ms

				var maxRetryAttempts = 40;
				var handle = setInterval(function () {
					if (retryAttempt === maxRetryAttempts || _this2.previewIsLoaded) {
						clearInterval(handle);
						_this2.previewIsLoaded = true;
					}

					var src = _this2.previewUrl.indexOf("http") !== -1 ? _this2.previewUrl : _this2.previewUrl;

					if (!_this2.previewIsLoaded) {
						_this2.$http.get(src).then(function (response) {
							src += src.indexOf("?") === -1 ? "?" : "&";
							src += "timestamp=" + new Date().getTime();
							_this2.previewImage = src;
							_this2.previewIsLoaded = true;
							clearInterval(handle);
						}, function (response) {
							_this2.previewIsLoaded = false;
							_this2.previewImage = _this2.placeholderUrl;
						});
					}
					retryAttempt += 1;
				}, 3000 * retryAttempt);
			}

			return this.previewImage || result;
		},
		productOptionGroup: function productOptionGroup(groupId) {
			var productGroupInfo = this.selectedFormat.productOptionGroups.find(function (g) {
				return g.id === groupId;
			});

			return productGroupInfo;
		},
		groupLocked: function groupLocked(groupId) {
			return this.forcedOptionGroup.includes(groupId);
		}
	},
	mounted: function mounted() {
		if (this.isConfiguration) {
			this.$store.commit("SET_STEP_ACTIVE", "configurator-overview");
		}

		document.addEventListener("resetStandardSpecificationConfiguration", this.setFirstStepActive);
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener("resetStandardSpecificationConfiguration", this.setFirstStepActive);
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-978ebda2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/overview/configurator-overview.vue
var configurator_overview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isConfiguration)?_c('step',{attrs:{"valid":"","name":"price-table","title":!_vm.isConfiguration ? 'Kies een oplage' : _vm.productTitleString + ' aanpassen'}},[_c('price-table')],1):_vm._e(),_vm._v(" "),_c('step',{attrs:{"name":"configurator-overview","valid":""}},[_c('div',{staticClass:"h4 hide",attrs:{"slot":"title"},slot:"title"}),_vm._v(" "),_c('modal',{attrs:{"title":"Productnaam aanpassen","button-style":"none","modal-style":"styled","open":_vm.openModal}},[_c('div',{staticClass:"h4 configurator-step__title cursor-pointer",attrs:{"slot":"button"},on:{"click":_vm.openNameModal},slot:"button"},[_vm._v("\n\t\t\t\t"+_vm._s(!_vm.isConfiguration ? _vm.productTitleString : _vm.productTitleString + ' aanpassen')+"\n\t\t\t\t"),_c('svg',{staticClass:"icon icon--small color-gray-500"},[_c('use',{attrs:{"xlink:href":"#edit"}})])]),_vm._v(" "),_c('label',{staticClass:"input-label",attrs:{"for":"name"}},[_vm._v("Productnaam")]),_vm._v(" "),_c('div',{staticClass:"grid grid--gutters grid--center-vertical grid--ms-full mb-s"},[_c('div',{staticClass:"cell cell--fit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"input-field input-field--border",attrs:{"type":"text","id":"name","name":"name"},domProps:{"value":(_vm.name)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.name=$event.target.value},_vm.setConfigurationName]}})]),_vm._v(" "),_c('div',{staticClass:"cell cell--auto"},[_c('button',{staticClass:"button button--cta button--full-width",attrs:{"aria-hidden":"Naam opslaan"},on:{"click":_vm.closeNameModal}},[_vm._v("Opslaan")])])])]),_vm._v(" "),(_vm.isConfiguration)?_c('div',{staticClass:"h4 hide-ms product-title"},[_vm._v("\n\t\t\t"+_vm._s(_vm.productTitleString)+"\n\t\t")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"configurator-options__holder configurator-options mv-s"},[_c('div',{staticClass:"configurator-options__holder-inner"},[_c('div',{staticClass:"grid grid--1-2 grid--ms-full grid--gutters mb-m"},[_c('div',{staticClass:"cell cell--40 cell--ms-100"},[_c('div',{staticClass:"configurator-overview__image-holder ph-l"},[(!_vm.previewUrl)?_c('img',{ref:"imagePreview",staticClass:"configurator-overview__image",attrs:{"src":_vm.iconPath,"width":"500"}}):_c('img',{ref:"imagePreview",staticClass:"configurator-overview__image",attrs:{"src":_vm.imagePath(_vm.iconPath),"width":"500"}}),_vm._v(" "),(!_vm.previewIsLoaded && _vm.isPreview)?_c('div',{staticClass:"configurator__loader configurator__loader--overlay"},[_c('div',{attrs:{"id":"loader"}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"cell cell--60 cell--ms-100"},[(_vm.check.hasSelectedOptions)?_c('div',{staticClass:"grid grid--1-2 grid--s-full grid--gutters-s"},[(_vm.formatDescription != null)?_c('div',{staticClass:"cell"},[_c('div',{staticClass:"configurator-overview__option configurator-overview__option--active cursor-pointer",on:{"click":function($event){return _vm.setStepActive('select-format')}}},[_c('p',[_c('Strong',[_vm._v("Formaat")]),_vm._v(" "),_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":"#edit"}})])],1),_vm._v(" "),_c('p',{staticClass:"configurator-overview__option-name",domProps:{"innerHTML":_vm._s(_vm.formatDescription)}})])]):_vm._e(),_vm._v(" "),_vm._l((_vm.visibleSelectedOptions),function(option,index){return _c('div',{key:index,staticClass:"cell"},[(!_vm.groupLocked(option.parentGroupId))?_c('div',{staticClass:"configurator-overview__option configurator-overview__option--active cursor-pointer",on:{"click":function($event){return _vm.setStepActive(option.parentGroupId)}}},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.productOptionGroup(option.parentGroupId).name))]),_vm._v(" "),_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":"#edit"}})])]),_vm._v(" "),_c('p',{staticClass:"configurator-overview__option-name"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(option.name)+"\n\t\t\t\t\t\t\t\t\t")])]):_c('div',{staticClass:"configurator-overview__option"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.productOptionGroup(option.parentGroupId).name))])]),_vm._v(" "),_c('p',{staticClass:"configurator-overview__option-name"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(option.name)+"\n\t\t\t\t\t\t\t\t\t")])])])}),_vm._v(" "),(_vm.isConfiguration && _vm.isEditorProject && _vm.configuratorChanged)?_c('div',{staticClass:"cell"},[_c('p',[_c('strong',[_vm._v("Configuratie aanpassen")])]),_vm._v(" "),_c('button',{staticClass:"button configurator-overview__option-button--edit",on:{"click":_vm.setFirstStepActive}},[_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":"#edit"}})])])]):_vm._e(),_vm._v(" "),(_vm.configuratorData.hasMultiplePages)?_c('spine',{attrs:{"table":""}}):_vm._e()],2):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"grid grid--1-2 grid--gutters pv-s"},[_c('div',{staticClass:"cell cell--40 hide-ms"}),_vm._v(" "),_c('div',{staticClass:"cell cell--60 cell--ms-full"},[(!_vm.getOrderLine.isOffset)?_c('div',{staticClass:"configurator-overview__price-row flex-space flex-space--between"},[_c('p',[_c('strong',[_vm._v("Oplage")])]),_vm._v(" "),_c('amount',{attrs:{"clean":""}})],1):_c('div',{staticClass:"configurator-overview__price-row flex-space flex-space--between"},[_c('p',[_c('strong',[_vm._v("Oplage")])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.getOrderLine.amount))]),_vm._v(" stuks")])]),_vm._v(" "),(!_vm.getOrderLine.isOffset)?_c('p',{staticClass:"configurator-overview__price-row--discount color-indigo-600 cursor-pointer",on:{"click":_vm.navigateToPriceTable}},[_vm._v("\n\t\t\t\t\t\t\tTip: voordeliger bij een hogere oplage\n\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"configurator__price-row__linebreak mv-s"}),_vm._v(" "),_c('div',{staticClass:"configurator-overview__price-row flex-space flex-space--between"},[(!_vm.loadingPrice)?[_c('p',[_c('strong',[_vm._v("Totaalprijs")])]),_vm._v(" "),_c('price')]:[_c('div',{staticClass:"loading"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])]],2)])]),_vm._v(" "),_c('div',{staticClass:"description mv-s"},[_c('p',{staticClass:"description__text"},[_vm._v("\n\t\t\t\t\t\tNeem voor het uploaden de aanleverspecificaties goed door.\n\t\t\t\t\t\tDit voorkomt problemen met het uploaden.\n\t\t\t\t\t")]),_vm._v(" "),(!_vm.isConfiguration && !_vm.isOffTheShelf)?_c('modal',{attrs:{"title":"Aanleverspecificaties","button-style":"descriptionButton","modal-style":"styled","button-text":"Aanleverspecificaties"}},[_c('delivery-specification',{attrs:{"format":_vm.selectedFormat,"overview":""}})],1):_vm._e()],1),_vm._v(" "),(!_vm.uploadSizeMatchesCustomSize && _vm.getUploaderPosition.after)?[_c('div',{staticClass:"alertbox alertbox--error alertbox mt-s mb-s"},[_c('svg',{staticClass:"alertbox__icon alertbox__icon--error"},[_c('use',{attrs:{"xlink:href":"#alert--error"}})]),_vm._v(" "),_c('p',{staticClass:"alertbox__text"},[_vm._v("\n\t\t\t\t\t\t\tUw ingevoerde maatwerk formaat is aangepast naar het formaat van de geüploade PDF.\n\t\t\t\t\t\t\tControleer het eindformaat goed voordat u bestelt.\n\t\t\t\t\t\t")])]),_vm._v(" "),_c('button',{staticClass:"button button--line-grey button--small",on:{"click":_vm.resetAllUploads}},[_vm._v("\n\t\t\t\t\t\tUpload(s) resetten\n\t\t\t\t\t")]),_vm._v(" "),_c('br')]:_vm._e(),_vm._v(" "),(_vm.showDefaultConfigAlert)?_c('div',{staticClass:"alertbox alertbox--notification alertbox mt-s mb-s"},[_c('svg',{staticClass:"alertbox__icon alertbox__icon--notification"},[_c('use',{attrs:{"xlink:href":"#alert--info"}})]),_vm._v(" "),_c('p',{staticClass:"alertbox__text"},[_vm._v("\n\t\t\t\t\t\tOnderstaande configuratie is een standaard configuratie.\n\t\t\t\t\t\t"),_c('a',{staticClass:"link",on:{"click":_vm.setFirstStepActive}},[_vm._v("Klik hier om de configuratie aan te passen.")])])]):_vm._e(),_vm._v(" "),(_vm.baseProps.isSpecificationConfiguration)?_c('div',{staticClass:"alertbox alertbox--notification alertbox mt-s mb-s"},[_c('svg',{staticClass:"alertbox__icon alertbox__icon--notification"},[_c('use',{attrs:{"xlink:href":"#alert--info"}})]),_vm._v(" "),_c('p',{staticClass:"alertbox__text"},[_c('a',{staticClass:"link",attrs:{"href":_vm.productPageUrl}},[_vm._v("\n\t\t\t\t\t\t\tBekijk alle mogelijke formaten en afwerkingen van dit product\n\t\t\t\t\t\t")])])]):_vm._e()],2)]),_vm._v(" "),(_vm.isConfiguration)?_c('price-table',{attrs:{"overview":""}}):_vm._e()],1),_vm._v(" "),_c('quotation')],1)}
var configurator_overview_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/overview/configurator-overview.vue
function configurator_overview_injectStyle (context) {
  __webpack_require__("ncnX")
}
/* script */


/* template */

/* template functional */
var configurator_overview___vue_template_functional__ = false
/* styles */
var configurator_overview___vue_styles__ = configurator_overview_injectStyle
/* scopeId */
var configurator_overview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var configurator_overview___vue_module_identifier__ = null

var configurator_overview_Component = Object(component_normalizer["a" /* default */])(
  configurator_overview,
  configurator_overview_render,
  configurator_overview_staticRenderFns,
  configurator_overview___vue_template_functional__,
  configurator_overview___vue_styles__,
  configurator_overview___vue_scopeId__,
  configurator_overview___vue_module_identifier__
)

/* harmony default export */ var overview_configurator_overview = (configurator_overview_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-upload-component/dist/vue-upload-component.js
var vue_upload_component = __webpack_require__("1Wvq");
var vue_upload_component_default = /*#__PURE__*/__webpack_require__.n(vue_upload_component);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/uploader/upload-field.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var upload_field = ({
	name: "UploadField",
	components: {
		FileUpload: vue_upload_component_default.a,
		icons: element_icons,
		spine: components_element_spine,
		modal: element_modal,
		deliverySpecification: information_delivery_specification
	},
	props: {
		separateCover: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: null
		},
		id: {
			type: String,
			default: null
		},
		name: {
			type: String,
			default: null
		},
		isLast: {
			type: Boolean,
			default: false
		},
		position: {
			type: Object,
			required: true
		}
	},
	data: function data() {
		return {
			hasInput: false,
			files: [],
			fieldHasError: false
		};
	},

	computed: {
		file: function file() {
			return this.files[0];
		},
		progress: function progress() {
			return Math.round(this.file.progress);
		},
		success: function success() {
			return this.file.success;
		},
		postUrl: function postUrl() {
			if (!this.uploadSessionGuid) {
				return null;
			}
			if (this.type === "content") {
				return window.PDF_API_HOST + "upload-configurator/?contentUploadPublicId=" + this.uploadSessionGuid + "&productFrontId=" + this.productFrontId + "&specificationId=" + this.getProductSpecificationId + "&type=Content" + "&ShopId=" + window.SHOP_ID;
			} else {
				return window.PDF_API_HOST + "upload-configurator/?contentUploadPublicId=" + this.uploadSessionGuid + "&productFrontId=" + this.productFrontId + (this.$store.getters.getFile.contentIsUploaded ? "&specificationId=" + this.$store.getters.getFile.content.specificationIds[0] : "") + "&type=Cover" + "&ShopId=" + window.SHOP_ID;
			}
		},
		uploadSessionGuid: function uploadSessionGuid() {
			return this.$store.getters.getUploadSessionGuid;
		},
		productFrontId: function productFrontId() {
			var selectedProduct = this.$store.getters.getSelectedProduct;
			return selectedProduct ? selectedProduct.id : this.$store.state.baseProps.productFrontId[0];
		},
		getProductSpecificationId: function getProductSpecificationId() {
			return this.$store.getters.getSelectedFormat.id;
		},
		errorMessage: function errorMessage() {
			var errorMessage = function errorMessage(error) {
				return {
					"size": "Maximum bestandsgrootte overschreden.",
					"extension": "Onjuist bestandsformaat.",
					"timeout": "De verbinding werd verbroken.",
					"abort": "Geannuleerd.",
					"network": "Er is iets misgegaan tijdens het uploaden van het bestand.",
					"server": "Er is iets misgegaan tijdens het uploaden van het bestand.",
					"denied": "Bestand geweigerd.",
					"default": "Er is iets mis gegaan."
				}[error];
			};

			return errorMessage(this.file.error) || errorMessage("default");
		},
		customErrorMessage: function customErrorMessage() {
			var errorMessages = this.$store.getters.getCustomErrorMessages;
			return errorMessages[this.type];
		},
		uploadText: function uploadText() {
			return this.coverUpload.bool ? this.coverUpload.valid ? "Sleep uw bestand hierheen of selecteer een bestand" : "Upload binnenwerk eerst" : "Sleep uw bestand hierheen of selecteer een bestand";
		},
		coverUpload: function coverUpload() {
			return {
				valid: this.$store.getters.getFile.contentIsUploaded && this.$store.getters.getFile.customErrorMessages.content === null,
				bool: this.separateCover && this.type === "cover"
			};
		},
		uploadsAreComplete: function uploadsAreComplete() {
			return this.$store.getters.uploadsAreComplete;
		},
		selectedFormat: function selectedFormat() {
			return this.$store.getters.getSelectedFormat;
		},
		hasSelectedFormat: function hasSelectedFormat() {
			return this.selectedFormat.id && this.selectedFormat.id !== null;
		},
		pageCount: function pageCount() {
			return this.$store.getters.getPageCount;
		},
		productWidth: function productWidth() {
			return this.selectedFormat.productSize.widthInMm;
		},
		productHeight: function productHeight() {
			return this.selectedFormat.productSize.heightInMm;
		}
	},
	methods: {
		inputFilter: function inputFilter(newFile, oldFile, prevent) {
			if (newFile && !oldFile) {
				// Before adding a file
				// Filter system files or hide files
				if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
					return prevent();
				}
				// Filter php html js file
				if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
					return prevent();
				}
			}
		},
		inputFile: function inputFile(newFile, oldFile) {
			if (newFile && !oldFile) {
				// add
				if (!this.$refs.upload.active) {
					this.$refs.upload.active = true;
				}
				this.hasInput = true;
			}
			if (newFile && oldFile) {
				if (newFile.success !== oldFile.success) {
					// success handler
					this.handleSuccess(newFile.response);
				}
			}
		},
		handleInput: function handleInput() {
			this.fieldHasError = false;
		},
		fileIsValid: function fileIsValid(response) {
			this.fieldHasError = false;

			if (!this.hasSelectedFormat || this.id === "cover" && this.customErrorMessage === null || this.pageCount === response.pageCount && response.uploadSize.width === this.productWidth && response.uploadSize.height === this.productHeight) {
				return true;
			}

			this.fieldHasError = true;
			return false;
		},
		handleSuccess: function handleSuccess(response) {
			response.mainPreviewUrl = response.mainPreviewUrl ? response.mainPreviewUrl + "?v=" + new Date().getTime().toString() : null;
			response.type = this.type;
			response.message = response.errors && response.errors.length > 0 ? this.aggregatePageMessages(response.errors).join(" ") : response.errorMessage;

			if (response.uploadSize) {
				response.uploadSize = {
					width: Math.round(response.uploadSize.width),
					height: Math.round(response.uploadSize.height)
				};
			}

			this.$store.commit("SET_FILE_UPLOAD", response);
		},
		aggregatePageMessages: function aggregatePageMessages(messages) {
			var result = [];
			var current = null;

			var flush = function flush() {
				if (!current) return;
				var word = current.capitalized ? "Pagina " : "pagina ";
				var pageRef = current.startPage === current.endPage ? word + current.startPage : word + current.startPage + " t/m " + current.endPage;
				result.push(current.template.replace("___PAGE_REF___", pageRef));
				current = null;
			};

			for (var i = 0; i < messages.length; i++) {
				var msg = messages[i];
				var match = msg.match(/pagina (\d+)/i);
				if (match) {
					var pageNum = parseInt(match[1], 10);
					var capitalized = match[0][0] === "P";
					var template = msg.replace(/pagina \d+/i, "___PAGE_REF___");
					if (current && current.template === template && current.capitalized === capitalized && pageNum === current.endPage + 1) {
						current.endPage = pageNum;
					} else {
						flush();
						current = { template: template, startPage: pageNum, endPage: pageNum, capitalized: capitalized };
					}
				} else {
					flush();
					result.push(msg);
				}
			}
			flush();
			return result;
		},
		uploadNewFile: function uploadNewFile() {
			if (!this.isLast) {
				this.$store.commit("SET_STEP_INVALID");
			}
			this.$store.commit("RESET_FORMAT_SUGGESTIONS");
			this.$store.commit("RESET_FORMAT_MATCHES");

			this.$store.commit("RESET_CUSTOM_ERROR_MESSAGE", this.type);
			this.$store.commit("RESET_FILE_UPLOAD", this.type);

			this.$store.commit("RESET_MATCHED_CUSTOMSIZE_FORMAT_SUGGESTION");

			if (this.type === "content" && this.separateCover) {
				this.$store.commit("RESET_CUSTOM_ERROR_MESSAGE", "cover");
				this.$store.commit("RESET_FILE_UPLOAD", "cover");
				EventBus.$emit("resetUploadInput");
			}

			if (!this.isLast) {
				this.$store.commit("CONFIGURATOR_STEP_AVAILABLE");
			}
			this.$refs.upload.active = false;
			this.hasInput = false;
		}
	},
	watch: {
		customErrorMessage: function customErrorMessage(newValue, oldValue) {
			if (newValue !== null) {
				this.fieldHasError = true;
			}
		}
	},
	mounted: function mounted() {
		var _this = this;

		EventBus.$on("resetUploadInput", function () {
			if (_this.files.length > 0) {
				_this.files[0].success = false;
			}

			_this.hasInput = false;
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28bf76aa","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploader/upload-field.vue
var upload_field_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell"},[_c('div',{staticClass:"upload-field",class:[_vm.type, { 'upload-field--error': _vm.fieldHasError }]},[(_vm.hasSelectedFormat)?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.separateCover || _vm.id === 'cover'),expression:"separateCover || id === 'cover'"}],staticClass:"h3"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),(_vm.id === 'content' !== null)?_c('p',{staticClass:"mb-s"},[(_vm.pageCount && _vm.pageCount > 1 && _vm.id !== 'cover')?_c('span',[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.pageCount)+" pagina's,\n\t\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.id === 'cover')?_c('span',[_c('spine',{attrs:{"inline":""}})],1):_vm._e(),_vm._v("\n\t\t\t\t"+_vm._s(_vm.selectedFormat.productSize.name)+"\n\t\t\t")]):_vm._e()]:_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasInput),expression:"!hasInput"}],staticClass:"upload-field--wrapper"},[(!_vm.coverUpload.bool)?[_c('file-upload',{ref:"upload",staticClass:"file-upload-field",attrs:{"post-action":_vm.postUrl,"extensions":"pdf","accept":"application/pdf","multiple":false,"drop":true,"drop-directory":false,"size":1024 * 1024 * 1024,"input-id":'configurator-upload-' + _vm.id},on:{"input-filter":_vm.inputFilter,"input-file":_vm.inputFile,"input":_vm.handleInput},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}},[_c('icons',{attrs:{"upload":""}}),_vm._v(" "),_c('span',{staticClass:"file-upload-field__copy"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.uploadText)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"file-upload-field__copy--browse"},[_vm._v("Browse")])],1)]:(_vm.coverUpload.bool)?[(_vm.coverUpload.valid)?_c('file-upload',{ref:"upload",staticClass:"file-upload-field",attrs:{"post-action":_vm.postUrl,"extensions":"pdf","accept":"application/pdf","multiple":false,"drop":true,"drop-directory":false,"size":1024 * 1024 * 1024,"input-id":'configurator-upload-' + _vm.id},on:{"input-filter":_vm.inputFilter,"input-file":_vm.inputFile,"input":_vm.handleInput},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}},[_c('icons',{attrs:{"upload":""}}),_vm._v(" "),_c('span',{staticClass:"file-upload-field__copy"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.uploadText)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"file-upload-field__copy--browse"},[_vm._v("Browse")])],1):(!_vm.coverUpload.valid)?_c('div',{staticClass:"file-upload-field file-upload-field--disabled"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.uploadText)+"\n\t\t\t\t")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasInput),expression:"hasInput"}],staticClass:"files"},_vm._l((_vm.files),function(file){return _c('li',{key:file.id,staticClass:"file",on:{"click":function($event){$event.preventDefault();return _vm.uploadNewFile.apply(null, arguments)}}},[_c('span',{staticClass:"file-upload-field file-upload-field--valid"},[_c('icons',{attrs:{"file":""}}),_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.customErrorMessage)+"\n\t\t\t\t\t"),(_vm.progress < 100)?_c('span',{staticClass:"file-upload-field__progress"},[_c('span',{staticClass:"file-upload-field__progress-animation"}),_vm._v(" "),_c('span',{staticClass:"file-upload-field__copy"},[_vm._v("uploading")])]):(file.error)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errorMessage))]):(_vm.fieldHasError && _vm.selectedFormat.id)?_c('span',{staticClass:"file-upload-field__copy"},[_vm._v("\n\t\t\t\t\t\tHet bestand voldoet niet aan de specificaties\n\t\t\t\t\t\t"),_c('span',{on:{"click":function($event){$event.stopPropagation();}}},[_c('modal',{attrs:{"title":"Aanleverspecificaties","button-style":"inline","holder-class":"file-upload-field__inline-copy-container","modal-style":"styled","button-text":"Bekijk de aanleverspecificaties"}},[_c('delivery-specification',{attrs:{"format":_vm.selectedFormat,"overview":""}})],1)],1)]):(file.success && !_vm.customErrorMessage)?_c('span',{staticClass:"file-upload-field__copy"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(file.name)+"\n\t\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"file-upload-field__copy--browse"},[_vm._v("Browse")])],1)])}),0)],2)])}
var upload_field_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/uploader/upload-field.vue
function upload_field_injectStyle (context) {
  __webpack_require__("/qWP")
}
/* script */


/* template */

/* template functional */
var upload_field___vue_template_functional__ = false
/* styles */
var upload_field___vue_styles__ = upload_field_injectStyle
/* scopeId */
var upload_field___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var upload_field___vue_module_identifier__ = null

var upload_field_Component = Object(component_normalizer["a" /* default */])(
  upload_field,
  upload_field_render,
  upload_field_staticRenderFns,
  upload_field___vue_template_functional__,
  upload_field___vue_styles__,
  upload_field___vue_scopeId__,
  upload_field___vue_module_identifier__
)

/* harmony default export */ var uploader_upload_field = (upload_field_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/element/specification-canvas.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var specification_canvas = ({
	name: "SpecificationCanvas",
	data: function data() {
		return {
			viewingPdf: true
		};
	},

	props: {
		large: {
			type: Boolean,
			default: false
		},
		data: {
			type: Object,
			default: null
		}
	},
	methods: {
		generateCanvas: function generateCanvas(toggle) {
			var canvas = this.$refs.canvas;
			var original = canvas.getContext("2d");
			var originalSecondary = canvas.getContext("2d");
			var uploaded = canvas.getContext("2d");
			var customSize = this.data.customSize;
			var inRange = this.data.inRange;

			var large = this.large;
			var strokeWidth = large ? 4 : 2;
			var x = canvas.width / 2;
			var y = canvas.height / 2;
			var padding = large ? 120 : 75;

			var canvasSize = [canvas.getAttribute("width"), canvas.getAttribute("height")];
			var originalRaw = [this.data.original.minWidth, this.data.original.maxWidth, this.data.original.minHeight, this.data.original.maxHeight];
			var originalSize = [Math.round((originalRaw[0] + originalRaw[1]) / 2 * 100) / 100, Math.round((originalRaw[2] + originalRaw[3]) / 2 * 100) / 100];
			var sizeUploaded = [this.data.uploaded.width, this.data.uploaded.height];
			var sizeCustom = [this.data.custom.minWidth, this.data.custom.maxWidth, this.data.custom.minHeight, this.data.custom.maxHeight];
			var sizes = customSize ? [(canvasSize[0] - padding) / originalSize[0], (canvasSize[1] - padding) / originalSize[1], (canvasSize[0] - padding) / sizeUploaded[0], (canvasSize[1] - padding) / sizeUploaded[1], (canvasSize[0] - padding) / customSize[0], (canvasSize[1] - padding) / sizeCustom[1], (canvasSize[0] - padding) / sizeCustom[2], (canvasSize[1] - padding) / sizeCustom[3]] : [(canvasSize[0] - padding) / originalSize[0], (canvasSize[1] - padding) / originalSize[1], (canvasSize[0] - padding) / sizeUploaded[0], (canvasSize[1] - padding) / sizeUploaded[1]];

			var factor = Math.min.apply(null, sizes);

			function calcFactor(input) {
				return factor * input;
			}

			var _specification = [0, 0, calcFactor(originalSize[0]), calcFactor(originalSize[1])];
			var _uploaded = [0, 0, calcFactor(sizeUploaded[0]), calcFactor(sizeUploaded[1])];
			var _customSizeMin = [0, 0, calcFactor(sizeCustom[0]), calcFactor(sizeCustom[2])];
			var _customSizeMax = [0, 0, calcFactor(sizeCustom[1]), calcFactor(sizeCustom[3])];
			// draw original size

			function generateOriginal() {
				if (customSize) {
					original.save();

					original.translate(x - _customSizeMax[2] / 2, y - _customSizeMax[3] / 2);
					original.fillStyle = toggle ? "rgba(217, 239, 218, 0.6)" : "rgba(217, 239, 218, 0.8)";
					original.fillRect(_customSizeMax[0], _customSizeMax[1], _customSizeMax[2], _customSizeMax[3]);

					originalSecondary.strokeStyle = toggle ? "rgba(0,0,0,0.2)" : "#438c47"; // darkgreen
					originalSecondary.lineWidth = 2;
					originalSecondary.strokeRect(_customSizeMax[0] + 1, _customSizeMax[1] + 1, _customSizeMax[2] - 2, _customSizeMax[3] - 2);

					original.font = large ? "bold 23px Arial" : "14px Arial";
					original.fillStyle = toggle ? "#bbb" : "#555";
					original.fillText(sizeCustom[1] + "X" + sizeCustom[3] + "mm", 0, -8);

					original.restore();

					originalSecondary.save();

					originalSecondary.translate(x - _customSizeMin[2] / 2, y - _customSizeMin[3] / 2);
					originalSecondary.fillStyle = toggle ? "rgba(239, 217, 217, 0.4)" : "rgba(239, 217, 217, 0.8)";
					originalSecondary.fillRect(_customSizeMin[0], _customSizeMin[1], _customSizeMin[2], _customSizeMin[3]);

					originalSecondary.strokeStyle = toggle ? "rgba(0,0,0,0.2)" : "#8c4343"; // darkred
					originalSecondary.lineWidth = 2;
					originalSecondary.strokeRect(_customSizeMin[0] + 1, _customSizeMin[1] + 1, _customSizeMin[2] - 2, _customSizeMin[3] - 2);

					originalSecondary.font = large ? "bold 23px Arial" : "14px Arial";
					originalSecondary.fillStyle = toggle ? "#bbb" : "#555";
					originalSecondary.fillText(sizeCustom[0] + "X" + sizeCustom[2] + "mm", 0, -8);

					originalSecondary.restore();
				} else {
					original.save();

					original.translate(x - _specification[2] / 2, y - _specification[3] / 2);
					original.fillStyle = "rgba(255,255,255, 0.85)";
					original.strokeStyle = toggle ? "rgba(0,0,0,0.2)" : "#fddd05";
					original.lineCap = "square";
					original.fillRect(_specification[0], _specification[1], _specification[2], _specification[3]);
					original.beginPath();

					original.lineWidth = strokeWidth;

					original.moveTo(_specification[0], _specification[1]);
					original.lineTo(_specification[2], _specification[0]);
					original.lineTo(_specification[2], _specification[3]);
					original.lineTo(_specification[1], _specification[3]);
					original.lineTo(_specification[1], _specification[0]);
					original.stroke();

					original.font = large ? "bold 23px Arial" : "14px Arial";
					original.fillStyle = toggle ? "#bbb" : "#555";
					original.fillText(originalSize[0] + "X" + originalSize[1] + "mm", 0, -8);

					original.restore();
				}
			}

			// draw uploaded size
			function generateUploaded() {
				uploaded.save();

				uploaded.translate(x - _uploaded[2] / 2, y - _uploaded[3] / 2);
				uploaded.fillStyle = toggle ? "rgba(49, 145, 193, 0.8)" : "rgba(49, 145, 193, 0.5)";
				uploaded.fillRect(_uploaded[0], _uploaded[1], _uploaded[2], _uploaded[3]);

				// top
				uploaded.beginPath();
				uploaded.moveTo(_uploaded[0], _uploaded[1]);
				uploaded.lineTo(_uploaded[2], _uploaded[0]);
				uploaded.lineWidth = strokeWidth;
				uploaded.lineCap = "square";
				uploaded.strokeStyle = inRange.width ? toggle ? "#32cd32" : "#90ee90" : toggle ? "red" : "#F08080";
				uploaded.stroke();

				// bottom
				uploaded.beginPath();
				uploaded.moveTo(_uploaded[0], _uploaded[3]);
				uploaded.lineTo(_uploaded[2], _uploaded[3]);
				uploaded.lineWidth = strokeWidth;
				uploaded.lineCap = "square";
				uploaded.strokeStyle = inRange.width ? toggle ? "#32cd32" : "#90ee90" : toggle ? "red" : "#F08080";
				uploaded.stroke();

				// right
				uploaded.beginPath();
				uploaded.moveTo(_uploaded[2], _uploaded[0]);
				uploaded.lineTo(_uploaded[2], _uploaded[3]);
				uploaded.lineWidth = strokeWidth;
				uploaded.lineCap = "square";
				uploaded.strokeStyle = inRange.height ? toggle ? "#32cd32" : "#90ee90" : toggle ? "red" : "#F08080";
				uploaded.stroke();

				// left
				uploaded.beginPath();
				uploaded.moveTo(_uploaded[0], _uploaded[0]);
				uploaded.lineTo(_uploaded[0], _uploaded[3]);
				uploaded.lineWidth = strokeWidth;
				uploaded.lineCap = "square";
				uploaded.strokeStyle = inRange.height ? toggle ? "#32cd32" : "#90ee90" : toggle ? "red" : "#F08080";
				uploaded.stroke();

				uploaded.font = large ? "bold 23px Arial" : "14px Arial";
				uploaded.fillStyle = toggle ? "#555" : "#bbb";
				uploaded.textAlign = "right";
				uploaded.fillText(sizeUploaded[0] + "X" + sizeUploaded[1] + "mm", _uploaded[2], _uploaded[3] + (large ? 30 : 20));

				uploaded.restore();
			}

			function resetCanvas() {
				original.setTransform(1, 0, 0, 1, 0, 0);
				original.clearRect(0, 0, canvas.width, canvas.height);
				uploaded.setTransform(1, 0, 0, 1, 0, 0);
				uploaded.clearRect(0, 0, canvas.width, canvas.height);
			}

			if (toggle) {
				resetCanvas();
				generateOriginal();
				generateUploaded();
			} else {
				resetCanvas();
				generateUploaded();
				generateOriginal();
			}
		},
		toggle: function toggle() {
			this.viewingPdf = !this.viewingPdf;
		}
	},
	mounted: function mounted() {
		this.generateCanvas(this.viewingPdf);
	},

	watch: {
		viewingPdf: function viewingPdf(a, b) {
			this.generateCanvas(this.viewingPdf);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ec9eaf2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/specification-canvas.vue
var specification_canvas_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configurator-canvas__holder"},[_c('canvas',{ref:"canvas",staticClass:"configurator-canvas",attrs:{"width":_vm.large ? 900 : 380,"height":_vm.large ? 900 : 380}}),_vm._v(" "),_c('div',{staticClass:"switch-sides",class:{'switch-sides--large' : _vm.large, 'switch-sides--light': _vm.viewingPdf}},[_c('span',[_vm._v("\n\t\t\tU bekijkt: "),_c('strong',[_vm._v(_vm._s(_vm.viewingPdf ? "Geupload bestand": "Formaatsuggestie"))])]),_vm._v(" "),_c('span',{staticClass:"switch-sides__link",on:{"click":function($event){$event.stopPropagation();return _vm.toggle.apply(null, arguments)}}},[_vm._v("\n\t\t\tKlik hier om te wissellen\n\t\t")])])])}
var specification_canvas_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/element/specification-canvas.vue
function specification_canvas_injectStyle (context) {
  __webpack_require__("GuHI")
}
/* script */


/* template */

/* template functional */
var specification_canvas___vue_template_functional__ = false
/* styles */
var specification_canvas___vue_styles__ = specification_canvas_injectStyle
/* scopeId */
var specification_canvas___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var specification_canvas___vue_module_identifier__ = null

var specification_canvas_Component = Object(component_normalizer["a" /* default */])(
  specification_canvas,
  specification_canvas_render,
  specification_canvas_staticRenderFns,
  specification_canvas___vue_template_functional__,
  specification_canvas___vue_styles__,
  specification_canvas___vue_scopeId__,
  specification_canvas___vue_module_identifier__
)

/* harmony default export */ var element_specification_canvas = (specification_canvas_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/uploader/upload-suggestion.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var upload_suggestion = ({
	name: "UploadSuggestion",
	props: {
		option: {
			type: Object,
			required: true
		}
	},
	components: {
		modal: element_modal,
		deliverySpecification: information_delivery_specification,
		specificationCanvas: element_specification_canvas
	},
	data: function data() {
		return {
			openModal: false
		};
	},

	computed: {
		canvasData: function canvasData() {
			return {
				isCover: this.option.isCoverComparision,
				customSize: this.option.isCustomSize,
				uploaded: this.option.isCoverComparision ? this.getFile.uploadSizes.cover : this.getFile.uploadSizes.content,
				original: {
					minHeight: this.option.minAllowedSize.height,
					maxHeight: this.option.maxAllowedSize.height,
					minWidth: this.option.minAllowedSize.width,
					maxWidth: this.option.maxAllowedSize.width
				},
				custom: {
					minHeight: this.option.minAllowedSize.height,
					maxHeight: this.option.maxAllowedSize.height,
					minWidth: this.option.minAllowedSize.width,
					maxWidth: this.option.maxAllowedSize.width
				},
				inRange: {
					height: this.option.heightInRange,
					width: this.option.widthInRange

				}
			};
		},
		uploadsAreComplete: function uploadsAreComplete() {
			return this.$store.getters.uploadsAreComplete;
		},
		isCustomSize: function isCustomSize() {
			return this.$store.getters.isCustomSize;
		},
		formatInfo: function formatInfo() {
			return this.option.productSize;
		},
		getFile: function getFile() {
			return this.$store.getters.getFile;
		},
		separateCover: function separateCover() {
			return this.$store.getters.hasSeparateCover;
		}
	},
	methods: {
		openSuggestionModal: function openSuggestionModal() {
			this.openModal = false;

			setTimeout(function () {
				this.openModal = true;
			}.bind(this), 100);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c70a066","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploader/upload-suggestion.vue
var upload_suggestion_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell"},[_c('modal',{attrs:{"title":"","button-style":"tooltip","button-text":"Bekijk aanpassingen","holder-class":"configurator-options-wrapper","open":_vm.openModal}},[_vm._t("default",function(){return [_c('label',{staticClass:"configurator-options__item"},[_c('div',{staticClass:"configurator-options__shape configurator-options__shape--square configurator-options__shape configurator-options__shape--border-white configurator-options__shape--background-blue cursor-pointer"},[_c('div',{staticClass:"configurator-options__image-holder content-block__image-holder content-block__image-holder--contain"},[_c('div',{on:{"click":_vm.openSuggestionModal}},[(_vm.separateCover)?_c('span',[_vm._v(_vm._s(_vm.option.isCoverComparision ? "Omslagsuggestie" : "Binnenwerksuggestie"))]):_vm._e(),_vm._v(" "),_c('specification-canvas',{attrs:{"data":_vm.canvasData}})],1)])]),_vm._v(" "),_c('p',{staticClass:"configurator-block__label cursor-pointer"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.formatInfo.fullName)+"\n\t\t\t\t")])])]},{"slot":"button"}),_vm._v(" "),_c('div',{staticClass:"grid grid--gutters grid--ms-full grid--center-vertical"},[_c('div',{staticClass:"cell"},[_c('h3',{staticClass:"content-block__title title--dot"},[_vm._v("Wijzigingen voor dit formaat")]),_vm._v(" "),_c('ul',{staticClass:"list list--svg"},_vm._l((_vm.option.reasonsFailed),function(reason,index){return _c('li',{key:index,staticClass:"list__item"},[_c('svg',{staticClass:"icon icon--list icon--error"},[_c('use',{attrs:{"xlink:href":"#alert--error"}})]),_vm._v("\n\t\t\t\t\t\t"+_vm._s(reason)+"\n\t\t\t\t\t")])}),0)]),_vm._v(" "),_c('div',{staticClass:"cell"},[_c('div',{staticClass:"configurator-options__shape configurator-options__shape--square configurator-options__shape configurator-options__shape--background-blue cursor-pointer"},[_c('div',{staticClass:"configurator-options__image-holder content-block__image-holder content-block__image-holder--contain"},[_c('specification-canvas',{attrs:{"data":_vm.canvasData,"large":""}})],1)])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('delivery-specification',{attrs:{"format":_vm.option}})],2)],1)}
var upload_suggestion_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/uploader/upload-suggestion.vue
/* script */


/* template */

/* template functional */
var upload_suggestion___vue_template_functional__ = false
/* styles */
var upload_suggestion___vue_styles__ = null
/* scopeId */
var upload_suggestion___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var upload_suggestion___vue_module_identifier__ = null

var upload_suggestion_Component = Object(component_normalizer["a" /* default */])(
  upload_suggestion,
  upload_suggestion_render,
  upload_suggestion_staticRenderFns,
  upload_suggestion___vue_template_functional__,
  upload_suggestion___vue_styles__,
  upload_suggestion___vue_scopeId__,
  upload_suggestion___vue_module_identifier__
)

/* harmony default export */ var uploader_upload_suggestion = (upload_suggestion_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/format/format-custom-choice.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var format_custom_choice = ({
	name: "FormatCustomChoice",
	props: {
		"option": {
			type: Object,
			required: true
		},
		"disabled": {
			type: Boolean,
			default: false
		},
		"type": {
			type: String,
			default: null
		},
		"hasSuggestion": {
			type: Boolean,
			default: false
		}
	},
	components: {
		modal: element_modal,
		deliverySpecification: information_delivery_specification
	},
	data: function data() {
		return {
			customFormat: false
		};
	},

	computed: {
		formatInfo: function formatInfo() {
			return this.option.productSize;
		},
		selectedFormat: function selectedFormat() {
			return this.$store.getters.getSelectedFormat;
		},
		wantsCustomFormat: function wantsCustomFormat() {
			return this.customFormat;
		},
		uploaderPosition: function uploaderPosition() {
			return this.$store.getters.getUploaderPosition;
		},
		title: function title() {
			return this.hasSuggestion ? "Liever maatwerk?" : "Geen suggesties voor dit formaat. Liever maatwerk?";
		},
		description: function description() {
			return this.hasSuggestion ? "Uw geuploadde formaat komt niet geheel overeen met onze aanleverspecificaties. Voor dit product is maatwerk beschikbaar. Wilt maatwerk selecteren in plaats van een hierboven aangegeven formaat? <br>Selecteer hieronder als u verder wilt met een maatwerk formaat." : "Uw geuploadde formaat komt niet overeen met onze aanleverspecificaties. Wel kunt u kiezen om verder te gaan met een maatwerk-formaat.<br>Selecteer hieronder om een maatwerk formaat te selecteren.";
		}
	},
	methods: {
		selectFormat: function selectFormat(value) {
			this.$store.commit("SET_UPLOADS_COMPLETE", true);
			this.$store.commit("SET_SELECTED_FORMAT", value);
			this.$store.commit("SET_STEP_VALID");
			this.$store.commit("CONFIGURATOR_STEP_AVAILABLE");
		},
		clearFormat: function clearFormat() {
			this.$store.commit("CLEAR_SELECTED_FORMAT");
			this.$store.commit("SET_UPLOADS_COMPLETE", false);
			this.$store.commit("SET_STEP_INVALID");
			this.$store.commit("CONFIGURATOR_STEP_AVAILABLE");
		},
		checked: function checked(value) {
			return this.selectedFormat !== null ? this.selectedFormat.id === value : false;
		},
		clickHandler: function clickHandler() {
			if (!this.checked(this.option.id)) {
				this.selectFormat(this.option.id);
			} else {
				this.clearFormat();
			}
		}
	},
	mounted: function mounted() {
		if (this.uploaderPosition.before) {
			this.clearFormat();
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a6e9094","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/format/format-custom-choice.vue
var format_custom_choice_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell"},[_c('div',{staticClass:"grid",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"cell"},[_c('h4',{domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('p',{staticClass:"mb-s",domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "),_c('label',{staticClass:"custom-size-checkbox cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customFormat),expression:"customFormat"}],staticClass:"input-field input-field--custom",attrs:{"type":"checkbox"},domProps:{"value":_vm.checked(_vm.option.id),"checked":Array.isArray(_vm.customFormat)?_vm._i(_vm.customFormat,_vm.checked(_vm.option.id))>-1:(_vm.customFormat)},on:{"click":_vm.clickHandler,"change":function($event){var $$a=_vm.customFormat,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.checked(_vm.option.id),$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.customFormat=$$a.concat([$$v]))}else{$$i>-1&&(_vm.customFormat=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.customFormat=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"input-field__selectable mr-s"}),_vm._v(" "),_c('p',[_vm._v("Ik wil verder met een maatwerk formaat")])])]),_vm._v(" "),(_vm.type === 'format')?_c('modal',{attrs:{"title":"Informatie & aanleverspecificaties","button-style":"tooltip","button-text":"Informatie"}},[_c('delivery-specification',{attrs:{"format":_vm.option}})],1):_vm._e()],1)])}
var format_custom_choice_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/format/format-custom-choice.vue
function format_custom_choice_injectStyle (context) {
  __webpack_require__("gji0")
}
/* script */


/* template */

/* template functional */
var format_custom_choice___vue_template_functional__ = false
/* styles */
var format_custom_choice___vue_styles__ = format_custom_choice_injectStyle
/* scopeId */
var format_custom_choice___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var format_custom_choice___vue_module_identifier__ = null

var format_custom_choice_Component = Object(component_normalizer["a" /* default */])(
  format_custom_choice,
  format_custom_choice_render,
  format_custom_choice_staticRenderFns,
  format_custom_choice___vue_template_functional__,
  format_custom_choice___vue_styles__,
  format_custom_choice___vue_scopeId__,
  format_custom_choice___vue_module_identifier__
)

/* harmony default export */ var format_format_custom_choice = (format_custom_choice_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/uploader/uploader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var uploader = ({
	name: "Uploader",
	components: {
		step: components_step_step,
		UploadField: uploader_upload_field,
		UploadSuggestion: uploader_upload_suggestion,
		modal: element_modal,
		deliverySpecification: information_delivery_specification,
		formatCustomChoice: format_format_custom_choice
	},
	data: function data() {
		return {
			name: "uploader",
			canUpload: true
		};
	},

	computed: {
		isConfiguration: function isConfiguration() {
			return this.$store.getters.getConfiguratorType.isConfiguration;
		},
		isOffTheShelf: function isOffTheShelf() {
			return this.$store.getters.isOffTheShelf;
		},
		selectedFormat: function selectedFormat() {
			return this.$store.getters.getSelectedFormat;
		},
		configuratorData: function configuratorData() {
			return this.$store.getters.getConfiguratorData;
		},
		position: function position() {
			return this.$store.getters.getUploaderPosition;
		},
		setPosition: function setPosition() {
			return this.position.before ? 0 : null;
		},
		loadUploader: function loadUploader() {
			if (this.$store.getters.isOffTheShelf) {
				return false;
			}

			if (this.position.after) {
				return this.$store.getters.isConfiguratorDataValid;
			}

			return true;
		},
		title: function title() {
			var name = "Upload uw bestand";
			if (this.hasSeparateCover && !this.onlyCoverRequired) {
				name += "en";
			}
			return name;
		},
		hasEditorUrl: function hasEditorUrl() {
			return this.$store.getters.hasEditorUrl;
		},
		hasSeparateCover: function hasSeparateCover() {
			return this.$store.getters.hasSeparateCover;
		},
		onlyCoverRequired: function onlyCoverRequired() {
			return this.$store.getters.onlyCoverRequired;
		},
		isLast: function isLast() {
			return !this.position.before;
		},
		stepIsUploader: function stepIsUploader() {
			return this.$store.getCurrentStep.data.name === "uploader";
		},
		availableFormats: function availableFormats() {
			return this.$store.getters.getAvailableFormats;
		},
		getConfiguratorData: function getConfiguratorData() {
			return this.$store.getters.getConfiguratorData;
		},
		getFormatSuggestions: function getFormatSuggestions() {
			return this.$store.getters.getFormatSuggestions;
		},
		getUploadHasError: function getUploadHasError() {
			return this.$store.getters.getUploadHasError;
		},
		getMatchedCustomSizeFormat: function getMatchedCustomSizeFormat() {
			return this.$store.getters.getMatchedCustomSizeFormat;
		},
		getMatchedCustomSizeFormatData: function getMatchedCustomSizeFormatData() {
			return this.$store.getters.getMatchedCustomSizeFormatData;
		},
		uploadsAreComplete: function uploadsAreComplete() {
			return this.$store.getters.uploadsAreComplete;
		},
		checkData: function checkData() {
			return this.$store.getters.checkData;
		}
	},
	created: function created() {
		var _this = this;

		var existingPublicId = this.$store.getters.getUploadSessionGuid;
		var selectedFormat = this.$store.getters.getSelectedFormat;
		var specificationId = selectedFormat && selectedFormat.id ? selectedFormat.id : null;
		var selectedProduct = this.$store.getters.getSelectedProduct;
		var productFrontId = selectedProduct ? selectedProduct.id : this.$store.state.baseProps.productFrontId[0];
		var customSize = this.$store.getters.getCustomSize;
		var pageCount = this.$store.getters.getPageCount;

		var params = [];
		if (existingPublicId) {
			params.push("publicId=" + existingPublicId);
		}
		if (specificationId) {
			params.push("specificationId=" + specificationId);
		}
		if (productFrontId) {
			params.push("productFrontId=" + productFrontId);
		}
		if (customSize && customSize.width) {
			params.push("customWidth=" + customSize.width);
		}
		if (customSize && customSize.height) {
			params.push("customHeight=" + customSize.height);
		}
		if (pageCount) {
			params.push("pageCount=" + pageCount);
		}

		var url = CONFIG.HOST + "configurator/create-configuration/" + (params.length > 0 ? "?" + params.join("&") : "");

		this.$http.get(url).then(function (result) {
			_this.$store.commit("SET_UPLOAD_SESSION_GUID", result.body);
		});
	},

	methods: {
		toConfigurator: function toConfigurator() {
			this.$store.commit("RESET_ALL_FILE_UPLOADS");
			this.$store.commit("SET_CONFIGURATOR_TYPE", "calculate");
		},
		handleSuccess: function handleSuccess() {
			this.$store.commit("SET_STEP_VALID");
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d423f56e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploader/uploader.vue
var uploader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('step',{attrs:{"name":_vm.name,"title":_vm.title,"valid":_vm.isLast,"set-active":_vm.position.before,"position":_vm.setPosition}},[(!_vm.loadUploader)?[_c('div',{staticClass:"alertbox alertbox--error alertbox mt-s mb-m"},[_c('svg',{staticClass:"alertbox__icon alertbox__icon--error"},[_c('use',{attrs:{"xlink:href":"#alert--error"}})]),_vm._v(" "),_c('p',{staticClass:"alertbox__text"},[_c('strong',[_vm._v("Let op:")]),_vm._v(" Voor dit product is het niet mogelijk om te uploaden.\n\t\t\t\t"),_c('span',{staticClass:"calculate-button link cursor-pointer"},[_vm._v("Klik hier om terug te gaan")]),_vm._v(".\n\t\t\t")])])]:[(_vm.selectedFormat.id)?_c('div',{staticClass:"description mv-s"},[_c('p',{staticClass:"description__text"},[_vm._v("\n\t\t\t\tNeem voor het uploaden de aanleverspecificaties goed door.\n\t\t\t\tDit voorkomt problemen met het uploaden.\n\t\t\t")]),_vm._v(" "),(!_vm.isConfiguration && !_vm.isOffTheShelf)?_c('modal',{attrs:{"title":"Aanleverspecificaties","button-style":"descriptionButton","modal-style":"styled","button-text":"Aanleverspecificaties"}},[_c('delivery-specification',{attrs:{"format":_vm.selectedFormat,"overview":""}})],1):_vm._e()],1):_c('div',{staticClass:"description description--vertical mv-s"},[_c('p',{staticClass:"description__text"},[(_vm.availableFormats)?[_vm._v("\n\t\t\t\t\tNeem voor het uploaden de aanleverspecificaties goed door.\n\t\t\t\t\tDit voorkomt problemen met het uploaden.\n\t\t\t\t")]:(!_vm.checkData.hasSelectedProduct)?[_vm._v("\n\t\t\t\t\tOm te kunnen uploaden dient er eerst een product geselecteerd te worden.\n\t\t\t\t\t"),_c('span',{staticClass:"calculate-button cursor-pointer click-here-to-choose-product"},[_vm._v("Klik hier om een product te kiezen")]),_vm._v(".\n\t\t\t\t")]:_vm._e()],2),_vm._v(" "),(!_vm.getConfiguratorData.hasFormatSuggestions && _vm.checkData.hasSelectedProduct)?_c('div',{staticClass:"description__link-container"},_vm._l((_vm.availableFormats),function(format,index){return _c('modal',{key:index,attrs:{"title":"Aanleverspecificaties","button-style":"custom","button-class":"link description__link","button-text":format.productSize.fullName}},[_c('delivery-specification',{attrs:{"format":format}})],1)}),1):_vm._e()]),_vm._v(" "),(_vm.checkData.hasSelectedProduct && _vm.onlyCoverRequired)?_c('div',{staticClass:"grid grid--ms-full grid--gutters"},[_c('upload-field',{attrs:{"is-last":_vm.isLast,"name":"Upload omslag","type":"content","id":"cover","position":_vm.position}})],1):(_vm.checkData.hasSelectedProduct)?_c('div',{staticClass:"grid grid--ms-full grid--gutters"},[_c('upload-field',{attrs:{"separate-cover":_vm.hasSeparateCover,"is-last":_vm.isLast,"name":"Upload binnenwerk","type":"content","id":"content","position":_vm.position}}),_vm._v(" "),(_vm.hasSeparateCover)?_c('upload-field',{attrs:{"separate-cover":_vm.hasSeparateCover,"is-last":_vm.isLast,"name":"Upload omslag","type":"cover","id":"cover","position":_vm.position}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.getConfiguratorData.hasFormatSuggestions)?_c('div',{staticClass:"description description--vertical mv-s"},[_c('p',{staticClass:"description__text"},[_vm._v("Uw geüploade bestand komt niet overeen met onze formaten. Onderstaand een aantal suggesties voor formaten die dicht in de buurt komen. Pas uw bestand hier op aan en probeer het nogmaals.")]),_vm._v(" "),_c('div',{staticClass:"description__link-container"},_vm._l((_vm.getFormatSuggestions),function(format,index){return _c('modal',{key:index,attrs:{"title":"Aanleverspecificaties","button-style":"custom","button-class":"link description__link","button-text":format.productSize.fullName}},[_c('delivery-specification',{attrs:{"format":format}})],1)}),1)]):_vm._e(),_vm._v(" "),(_vm.getMatchedCustomSizeFormat !== null && !_vm.isLast)?_c('div',{staticClass:"mt-m mb-m"},[_c('format-custom-choice',{attrs:{"has-suggestion":_vm.getConfiguratorData.hasFormatSuggestions,"option":_vm.getMatchedCustomSizeFormatData,"type":"uploader"}})],1):_vm._e(),_vm._v(" "),(_vm.getUploadHasError)?_c('div',{staticClass:"cell cell--full"},[_c('div',{staticClass:"wetransfer-upload background-indigo-025 text--center"},[_c('div',{staticClass:"grid grid--full"},[_c('div',{staticClass:"cell"},[_c('h3',{staticClass:"mb-s"},[_vm._v("Problemen met uploaden?")]),_vm._v(" "),(_vm.isLast)?_c('p',[_vm._v("Plaats uw bestelling dan eerst, kies voor de optie PDF-controle en lever vervolgens uw bestanden aan (bij achteraf uploaden kan dit via WeTransfer). Wij geven u vervolgens feedback om het bestand geschikt voor productie te maken.")]):_c('p',[_c('span',{staticClass:"link cursor-pointer",on:{"click":_vm.toConfigurator}},[_vm._v("Configureer uw product eerst")]),_vm._v(" en plaats uw bestelling, kies voor de optie PDF-controle en lever vervolgens uw bestanden aan (bij achteraf uploaden kan dit via WeTransfer). Wij geven u vervolgens feedback om het bestand geschikt voor productie te maken.\n\t\t\t\t\t\t")])])])])]):_vm._e()]],2)}
var uploader_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/uploader/uploader.vue
function uploader_injectStyle (context) {
  __webpack_require__("qYJZ")
}
/* script */


/* template */

/* template functional */
var uploader___vue_template_functional__ = false
/* styles */
var uploader___vue_styles__ = uploader_injectStyle
/* scopeId */
var uploader___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var uploader___vue_module_identifier__ = null

var uploader_Component = Object(component_normalizer["a" /* default */])(
  uploader,
  uploader_render,
  uploader_staticRenderFns,
  uploader___vue_template_functional__,
  uploader___vue_styles__,
  uploader___vue_scopeId__,
  uploader___vue_module_identifier__
)

/* harmony default export */ var uploader_uploader = (uploader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/optional/page-step.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var page_step = ({
	name: "PageStep",
	components: {
		step: components_step_step,
		formatOption: format_format_option,
		formatCustom: optional_format_custom,
		pageCount: optional_page_count
	},
	computed: {
		pageCount: function pageCount() {
			return this.$store.getters.getPageCount;
		},
		isPageStep: function isPageStep() {
			return this.$store.getters.getCurrentStep.data.name === "page-count";
		},
		shouldRowBeActive: function shouldRowBeActive() {
			if (this.isPageStep) {
				return true;
			}

			// if the step after the page-step has options associated with it, make the row active.
			if (this.stepAfterPageStepHasValue) {
				return true;
			}

			// if the current step is right after the page-step, make the row active, regardless of step state
			if (this.getPreviousStepName === "page-count") {
				return true;
			}

			return false;
		},
		getAllSteps: function getAllSteps() {
			return this.$store.getters.getAllSteps;
		},
		getCurrentStep: function getCurrentStep() {
			return this.$store.getters.getCurrentStep;
		},
		stepAfterPageStepHasValue: function stepAfterPageStepHasValue() {
			var countStepInt = this.getAllSteps.findIndex(function (s) {
				return s.name === "page-count";
			});
			var stepAfterCountStep = this.getStepByIndex(countStepInt + 1);
			return stepAfterCountStep ? stepAfterCountStep.valid : false;
		},
		getPreviousStepName: function getPreviousStepName() {
			var previousStep = this.getAllSteps[this.getCurrentStep.index - 1];
			return previousStep ? previousStep.name : null;
		},
		getStepInt: function getStepInt() {
			var step = this.getAllSteps.find(function (s) {
				return s.name === "page-count";
			});
			return this.getAllSteps.indexOf(step) + 1;
		}
	},
	methods: {
		stepExists: function stepExists(stepToCheck) {
			return this.$store.getters.getStepExists(stepToCheck);
		},
		setStepActive: function setStepActive(step) {
			if (this.stepExists(step).bool) {
				this.$store.commit("SET_STEP_ACTIVE", step);
			}
		},
		getStepByIndex: function getStepByIndex(index) {
			return this.getAllSteps[index] || null;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a1a6d96","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/optional/page-step.vue
var page_step_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('step',{attrs:{"name":"page-count","title":"Aantal pagina's","valid":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{staticClass:"grid"},[_c('div',{staticClass:"cell cell--fit"},[(_vm.shouldRowBeActive)?_c('h5',{staticClass:"configurator-step__title cursor-pointer",on:{"click":function($event){return _vm.setStepActive('page-count')}}},[_c('span',{staticClass:"configurator-step__count configurator-step__count--valid"}),_vm._v("\n\t\t\t\t\tAantal pagina's\n\t\t\t\t\t"),_c('span',{staticClass:"configurator-step__semi-colon configurator-step__not-active-mobile"},[_vm._v(":")]),_vm._v(" "),_c('span',{staticClass:"configurator-step__item configurator-step__not-active-mobile"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.pageCount)+"\n\t\t\t\t\t")])]):_c('h5',{staticClass:"configurator-step__title configurator-step--inactive"},[_c('span',{staticClass:"configurator-step__count"},[_vm._v(_vm._s(_vm.getStepInt))]),_vm._v("\n\t\t\t\t\tAantal pagina's\n\t\t\t\t")])])])]},proxy:true}])},[_vm._v(" "),_c('div',{staticClass:"configurator-options"},[_c('page-count')],1)])}
var page_step_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/optional/page-step.vue
function page_step_injectStyle (context) {
  __webpack_require__("jY7J")
}
/* script */


/* template */

/* template functional */
var page_step___vue_template_functional__ = false
/* styles */
var page_step___vue_styles__ = page_step_injectStyle
/* scopeId */
var page_step___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var page_step___vue_module_identifier__ = null

var page_step_Component = Object(component_normalizer["a" /* default */])(
  page_step,
  page_step_render,
  page_step_staticRenderFns,
  page_step___vue_template_functional__,
  page_step___vue_styles__,
  page_step___vue_scopeId__,
  page_step___vue_module_identifier__
)

/* harmony default export */ var optional_page_step = (page_step_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var configurator = ({
	name: "Configurator",
	components: { PageStep: optional_page_step, product: product_product, format: format_format, optionGroups: option_option_groups, configuratorOverview: overview_configurator_overview, uploader: uploader_uploader, modal: element_modal },
	data: function data() {
		return {
			hasMultipleProducts: this.$store.state.configuratorData.hasMultipleProducts,
			openModal: false
		};
	},

	computed: {
		check: function check() {
			return this.$store.getters.checkData;
		},
		printSidesCountChoice: function printSidesCountChoice() {
			return this.$store.getters.isPrintSidesCountChoice;
		},
		optionGroups: function optionGroups() {
			var optionGroups = this.$store.getters.getSelectedFormat.productOptionGroups;
			// Sort by index first, then alphabetically by name as tiebreaker
			return optionGroups.sort(function (a, b) {
				if (a.index !== b.index) {
					return a.index - b.index;
				}
				return a.name.localeCompare(b.name);
			});
		},
		configuratorType: function configuratorType() {
			return this.$store.getters.getConfiguratorType;
		},
		isOptionsRenderable: function isOptionsRenderable() {
			return this.$store.getters.isOptionsRenderable;
		},
		showOverview: function showOverview() {
			return this.check.hasSelectedFormat && this.check.hasSelectedProduct && this.check.hasSelectedOptions && this.$store.getters.isConfiguratorDataValid;
		},
		uploaderPosition: function uploaderPosition() {
			return this.$store.getters.getUploaderPosition;
		},
		getConfiguratorData: function getConfiguratorData() {
			return this.$store.getters.getConfiguratorData;
		},
		uploadsAreComplete: function uploadsAreComplete() {
			return this.$store.getters.uploadsAreComplete;
		},
		currentStep: function currentStep() {
			return this.$store.getters.getCurrentStep.data.name;
		},
		showPageCount: function showPageCount() {
			var configHasUploadedFile = this.$store.state.baseProps.isConfiguration && this.$store.state.config.configurationSettings.fileIsUploaded;

			return this.check.hasSelectedFormat && this.getConfiguratorData.hasMultiplePages && !this.uploadsAreComplete && !this.printSidesCountChoice && !this.$store.getters.getSelectedFormat.hidePageCount && !configHasUploadedFile && !this.$store.getters.hasConfiguratorPageCountOptions;
		}
	},
	mounted: function mounted() {
		var _this = this;

		EventBus.$on("scrollToStep", function () {
			setTimeout(function () {
				var item = document.querySelector(".configurator-step--active");

				function offset(el) {
					var rect = el.getBoundingClientRect();
					var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
					var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
					return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
				}

				function scrollToItem(elem) {
					var topOfElement = offset(elem).top;

					window.scroll({
						"behavior": "smooth",
						"top": topOfElement - 130
					});
				}

				if (item) {
					scrollToItem(item);
				}
			}, 10);
		});

		EventBus.$on("selectedFormatDoesNotMatch", function () {
			_this.openModal = false;
			setTimeout(function () {
				this.openModal = true;
			}.bind(_this), 100);
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c86ab65","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator.vue
var configurator_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configurator cell"},[_c('div',{staticClass:"configurator__container"},[(_vm.uploaderPosition.before)?_c('uploader'):_vm._e(),_vm._v(" "),(_vm.hasMultipleProducts)?_c('product'):_vm._e(),_vm._v(" "),(_vm.check.hasSelectedProduct)?_c('format'):_vm._e(),_vm._v(" "),(_vm.showPageCount)?_c('page-step'):_vm._e(),_vm._v(" "),(_vm.check.hasSelectedFormat && _vm.check.hasSelectedProduct && _vm.isOptionsRenderable)?_vm._l((_vm.optionGroups),function(optionGroup){return _c('option-groups',{key:optionGroup.id,attrs:{"option-group":optionGroup}})}):_vm._e(),_vm._v(" "),(_vm.showOverview)?_c('configurator-overview'):_vm._e(),_vm._v(" "),(_vm.uploaderPosition.after && _vm.currentStep !== 'configurator-overview')?_c('uploader'):_vm._e()],2),_vm._v(" "),_c('modal',{attrs:{"button-style":"none","modal-style":"styled","open":_vm.openModal,"title":"Configureer uw product opnieuw"}},[_c('p',[(_vm.getConfiguratorData.hasFormatMatches)?[_vm._v("Het door u "),(_vm.uploadsAreComplete)?[_vm._v("geüploade bestand")]:[_vm._v("gekozen formaat")],_vm._v(" is mogelijk bij meerdere formaten. ")]:[_vm._v("Het door u "),(_vm.uploadsAreComplete)?[_vm._v("geüploade bestand")]:[_vm._v("gekozen formaat")],_vm._v(" komt niet overeen met uw eerder gekozen formaat. ")],_vm._v("\n\t\t\tSelecteer daarom opnieuw uw opties.\n\t\t")],2)])],1)}
var configurator_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/configurator.vue
function configurator_injectStyle (context) {
  __webpack_require__("GmRo")
}
/* script */


/* template */

/* template functional */
var configurator___vue_template_functional__ = false
/* styles */
var configurator___vue_styles__ = configurator_injectStyle
/* scopeId */
var configurator___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var configurator___vue_module_identifier__ = null

var configurator_Component = Object(component_normalizer["a" /* default */])(
  configurator,
  configurator_render,
  configurator_staticRenderFns,
  configurator___vue_template_functional__,
  configurator___vue_styles__,
  configurator___vue_scopeId__,
  configurator___vue_module_identifier__
)

/* harmony default export */ var components_configurator = (configurator_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var App = ({
	name: "App",
	components: {
		configurator: components_configurator,
		modal: element_modal
	},
	data: function data() {
		return {
			modalOpened: false,
			modalContent: {
				title: "",
				content: ""
			}
		};
	},

	computed: {
		configuratorType: function configuratorType() {
			return this.$store.getters.getConfiguratorType;
		},
		configuratorDataLoaded: function configuratorDataLoaded() {
			return this.$store.state.isLoaded;
		}
	},
	mounted: function mounted() {
		var _this = this;

		EventBus.$on("configuratorModal", function (object) {
			_this.modalContent = object || { title: "", content: "" };

			_this.modalOpened = false;
			setTimeout(function () {
				this.modalOpened = true;
			}.bind(_this), 100);
		});
	},

	watch: {
		configuratorDataLoaded: function configuratorDataLoaded(newVal) {
			if (newVal) {
				document.body.classList.add("configurator--loaded");

				var configuratorType = "initial";
				if (this.configuratorType.isConfiguration) {
					configuratorType = "configuration";
				} else if (this.configuratorType.isUploader) {
					configuratorType = "uploader";
				} else if (this.configuratorType.isCalculate) {
					configuratorType = "calculate";
				}

				tracking_pushEvent(Events.INIT, {
					configuratorType: configuratorType,
					hasMultipleProducts: this.$store.state.configuratorData.hasMultipleProducts
				});
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dea712a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.configuratorDataLoaded)?_c('div',{staticClass:"configurator__holder",class:{'configurator__holder--full' : _vm.configuratorType.isConfiguration }},[_vm._m(0)]):(_vm.configuratorDataLoaded)?_c('div',{staticClass:"configurator__holder",class:{'configurator__holder--full' : _vm.configuratorType.isConfiguration }},[_c('div',{staticClass:"scroll-hook"}),_vm._v(" "),_c('div',{staticClass:"grid grid--gutters grid--m-full flex-space--between"},[_c('configurator')],1),_vm._v(" "),_c('modal',{attrs:{"button-style":"none","modal-style":"styled","open":_vm.modalOpened,"title":_vm.modalContent.title}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.modalContent.content)}})])],1):_vm._e()}
var App_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configurator__loader"},[_c('div',{attrs:{"id":"loader"}})])}]

// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (context) {
  __webpack_require__("cDNU")
}
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null

var App_Component = Object(component_normalizer["a" /* default */])(
  App,
  App_render,
  App_staticRenderFns,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/main.js





// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





vue_esm["a" /* default */].config.productionTip = false;

var elem = document.getElementById("product-configurator");
var init = false;
var main_data = {};
var main__iteratorNormalCompletion = true;
var main__didIteratorError = false;
var main__iteratorError = undefined;

try {
	for (var main__iterator = get_iterator_default()(entries_default()(elem.dataset)), main__step; !(main__iteratorNormalCompletion = (main__step = main__iterator.next()).done); main__iteratorNormalCompletion = true) {
		var main__ref = main__step.value;

		var main__ref2 = slicedToArray_default()(main__ref, 2);

		var main_key = main__ref2[0];
		var main_value = main__ref2[1];

		main_data[main_key] = main_value;
	}
} catch (err) {
	main__didIteratorError = true;
	main__iteratorError = err;
} finally {
	try {
		if (!main__iteratorNormalCompletion && main__iterator.return) {
			main__iterator.return();
		}
	} finally {
		if (main__didIteratorError) {
			throw main__iteratorError;
		}
	}
}

main_data["productFrontId"] = elem.dataset.productFrontId.split(",");
main_data["specifications"] = window.__cms_specifications;

var targetElement = JSON.parse(stringify_default()(main_data)); // for the productdata from html
var main_addClass = function addClass(element, className) {
	var elements = from_default()(document.querySelectorAll(element));
	elements.forEach(function (item) {
		item.classList.add(className);
	});
};

var main_removeClass = function removeClass(element, className) {
	var elements = from_default()(document.querySelectorAll(element));
	elements.forEach(function (item) {
		item.classList.remove(className);
	});
};

if (!Element.prototype.closest) {
	if (!Element.prototype.matches) {
		Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}
	Element.prototype.closest = function (s) {
		var el = this;
		var ancestor = this;
		if (!document.documentElement.contains(el)) return null;
		do {
			if (ancestor.matches(s)) return ancestor;
			ancestor = ancestor.parentElement;
		} while (ancestor !== null);
		return null;
	};
}

function addDelegatedListener(elem, event, callback) {
	document.addEventListener(event, function (e) {
		var element = e.target;
		if (element.closest(elem)) {
			// Found a `td` within the container!
			if (typeof callback === "function") {
				callback();
			}
		}
	});
}

function getUrlParameter(name) {
	// eslint-disable-next-line no-useless-escape
	name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
	var results = regex.exec(location.search);
	return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

/* eslint-disable no-new */

addDelegatedListener("#upload-button", "click", function () {
	initApp("upload");
});
addDelegatedListener("#calculate-button", "click", function () {
	initApp("calculate");
});
addDelegatedListener(".upload-button", "click", function () {
	initApp("upload");
});
addDelegatedListener(".calculate-button", "click", function () {
	initApp("calculate");
});

if (targetElement.configId !== "null") {
	initApp("configuration");
} else {
	initApp("calculate");
}

function initApp(type) {
	if (type !== store.getters.getConfiguratorTypeString) {
		if (!store.getters.checkData.hasSelectedOptions) {
			store.commit("SET_CONFIGURATOR_TYPE", type);
		} else {
			EventBus.$emit("scrollToStep");
		}
	}

	if (init) {
		EventBus.$emit("scrollToStep");
	}

	if (init === false) {
		new vue_esm["a" /* default */]({
			el: "#product-configurator",
			components: { App: src_App },
			template: "<App/>",
			store: store,
			data: {
				isLoaded: false
			},
			computed: {
				hasSelectedOptions: function hasSelectedOptions() {
					return store.getters.checkData.hasSelectedOptions;
				},
				isOffTheShelf: function isOffTheShelf() {
					return this.$store.getters.isOffTheShelf;
				}
			},
			mounted: function mounted() {
				var configuratorHolder = this.$el;

				var measureBounds = function measureBounds() {
					var rect = configuratorHolder.getBoundingClientRect();
					var left = Math.max(rect.left, 0);
					var right = Math.min(rect.right, window.innerWidth);
					return {
						top: rect.top,
						bottom: rect.bottom,
						left: left,
						right: right,
						width: right - left,
						height: rect.height,
						x: left,
						y: rect.top
					};
				};

				Helper.optimizedResize(function () {
					store.commit("SET_BOUNDING_RECT", measureBounds());
					store.commit("SET_VIEWPORT_INFO", window.innerWidth);
				});

				store.commit("SET_BOUNDING_RECT", measureBounds());
				store.commit("SET_VIEWPORT_INFO", window.innerWidth);
			},
			created: function created() {
				this.$store.commit("SET_BASE_PROPS", targetElement);

				var specificationId = getUrlParameter("s");
				if (specificationId) {
					this.$store.commit("SET_IS_SPECIFICATION_CONFIGURATION", true);
					this.$store.commit("SET_SPECIFICATION_ID", parseInt(specificationId));

					var quantity = getUrlParameter("q");
					if (quantity) {
						this.$store.commit("SET_PRESELECTED_QUANTITY", parseInt(quantity));
					}
				}

				this.$store.dispatch("_SetProductData");
			},
			methods: {},
			watch: {
				hasSelectedOptions: function hasSelectedOptions(a, b) {
					if (a) {
						["#upload-button", "#calculate-button", ".upload-button", ".calculate-button"].forEach(function (item) {
							return main_addClass(item, "button--opaque");
						});
					}
				},
				isOffTheShelf: function isOffTheShelf(a, b) {
					if (a) {
						["#upload-button", ".upload-button"].forEach(function (item) {
							return main_addClass(item, "hide");
						});
					} else {
						["#upload-button", ".upload-button"].forEach(function (item) {
							return main_removeClass(item, "hide");
						});
					}
				}
			}
		});
		init = true;
	}
}

/***/ }),

/***/ "aF67":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cDNU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cX/a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gji0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jY7J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kAG1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kdde":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ncnX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qYJZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qetc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rtms":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s7rG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vg8X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y5/u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yK1m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/main.js